
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref920"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref920"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("4ccia", function(module, exports) {
$parcel$export(module.exports, "CustomerLandingPageRelayQuery", function () { return $3dc4ed61a4433ffb$export$a2e9c729852eb9a1; });
$parcel$export(module.exports, "getCustomerLandingPageRelayQueryVars", function () { return $3dc4ed61a4433ffb$export$d97c1c828e8e0162; });
$parcel$export(module.exports, "CustomerLandingPageContentfulResponse", function () { return $3dc4ed61a4433ffb$export$4b589896422ec0e0; });

var $hu7gH = parcelRequire("hu7gH");

var $kf4PU = parcelRequire("kf4PU");
var $3dc4ed61a4433ffb$var$_customerLandingPageRelayQuery;

const $3dc4ed61a4433ffb$export$a2e9c729852eb9a1 = $3dc4ed61a4433ffb$var$_customerLandingPageRelayQuery !== void 0 ? $3dc4ed61a4433ffb$var$_customerLandingPageRelayQuery : ($3dc4ed61a4433ffb$var$_customerLandingPageRelayQuery = (parcelRequire("i7ByD")), $3dc4ed61a4433ffb$var$_customerLandingPageRelayQuery.hash && $3dc4ed61a4433ffb$var$_customerLandingPageRelayQuery.hash !== "8c843ab041f86aaa1c91e2fdfd9f9c32" && console.error("The definition of 'customerLandingPageRelayQuery' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), $3dc4ed61a4433ffb$var$_customerLandingPageRelayQuery);
const $3dc4ed61a4433ffb$export$d97c1c828e8e0162 = (location)=>{
    const { locale: locale } = (0, $hu7gH.parseRoute)(location);
    return {
        locale: (0, $kf4PU.WAC_TO_CPAPI_LOCALE_MAP)[locale] || "en-US"
    };
};
const $3dc4ed61a4433ffb$export$4b589896422ec0e0 = (contentfulStories)=>{
    var _contentfulStories_customerStoryCollection_items, _contentfulStories_customerStoryCollection, _contentfulStories_taxonomyIndustryCollection_items, _contentfulStories_taxonomyIndustryCollection, _contentfulStories_taxonomyCompanySizeCollection_items, _contentfulStories_taxonomyCompanySizeCollection, _contentfulStories_productNameCollection_items, _contentfulStories_productNameCollection, _contentfulStories_taxonomyRegionCollection_items, _contentfulStories_taxonomyRegionCollection, _contentfulStories_taxonomySolutionCollection_items, _contentfulStories_taxonomySolutionCollection;
    var _contentfulStories_customerStoryCollection_items_map, _contentfulStories_taxonomyIndustryCollection_items_filter_map, _contentfulStories_taxonomyCompanySizeCollection_items_filter_map, _contentfulStories_productNameCollection_items_filter_map, _contentfulStories_taxonomyRegionCollection_items_filter_map, _contentfulStories_taxonomySolutionCollection_items_filter_map;
    return {
        customerStories: {
            edges: (_contentfulStories_customerStoryCollection_items_map = (_contentfulStories_customerStoryCollection = contentfulStories.customerStoryCollection) === null || _contentfulStories_customerStoryCollection === void 0 ? void 0 : (_contentfulStories_customerStoryCollection_items = _contentfulStories_customerStoryCollection.items) === null || _contentfulStories_customerStoryCollection_items === void 0 ? void 0 : _contentfulStories_customerStoryCollection_items.map((item)=>{
                var _item_customerCompany, _item_customerCompany_logoCollection_items, _item_customerCompany_logoCollection, _item_customerCompany1, _item_customerCompany_industryCollection_items, _item_customerCompany_industryCollection, _item_customerCompany2, _item_customerCompany_region, _item_customerCompany3, _item_customerCompany_organizationSize, _item_customerCompany4, _item_advocateQuotesCollection_items, _item_advocateQuotesCollection, _item_callToActionCollection_items, _item_callToActionCollection, _item_productCollection_items, _item_productCollection, _item_marketplaceAppsCollection_items, _item_marketplaceAppsCollection, _item_solutionCollection_items, _item_solutionCollection, _item_solutionPartnersCollection_items, _item_solutionPartnersCollection;
                return {
                    node: {
                        title: item === null || item === void 0 ? void 0 : item.storyTitleExternal,
                        customerCompany: {
                            name: item === null || item === void 0 ? void 0 : (_item_customerCompany = item.customerCompany) === null || _item_customerCompany === void 0 ? void 0 : _item_customerCompany.organizationNameExternal,
                            logo: item === null || item === void 0 ? void 0 : (_item_customerCompany1 = item.customerCompany) === null || _item_customerCompany1 === void 0 ? void 0 : (_item_customerCompany_logoCollection = _item_customerCompany1.logoCollection) === null || _item_customerCompany_logoCollection === void 0 ? void 0 : (_item_customerCompany_logoCollection_items = _item_customerCompany_logoCollection.items) === null || _item_customerCompany_logoCollection_items === void 0 ? void 0 : _item_customerCompany_logoCollection_items.map((item)=>{
                                return {
                                    description: item === null || item === void 0 ? void 0 : item.description,
                                    contentType: item === null || item === void 0 ? void 0 : item.contentType,
                                    url: item === null || item === void 0 ? void 0 : item.url
                                };
                            }),
                            industry: item === null || item === void 0 ? void 0 : (_item_customerCompany2 = item.customerCompany) === null || _item_customerCompany2 === void 0 ? void 0 : (_item_customerCompany_industryCollection = _item_customerCompany2.industryCollection) === null || _item_customerCompany_industryCollection === void 0 ? void 0 : (_item_customerCompany_industryCollection_items = _item_customerCompany_industryCollection.items) === null || _item_customerCompany_industryCollection_items === void 0 ? void 0 : _item_customerCompany_industryCollection_items.map((item)=>{
                                return {
                                    name: item === null || item === void 0 ? void 0 : item.industryName
                                };
                            }),
                            region: {
                                name: item === null || item === void 0 ? void 0 : (_item_customerCompany3 = item.customerCompany) === null || _item_customerCompany3 === void 0 ? void 0 : (_item_customerCompany_region = _item_customerCompany3.region) === null || _item_customerCompany_region === void 0 ? void 0 : _item_customerCompany_region.regionNameExternal
                            },
                            organizationSize: {
                                name: item === null || item === void 0 ? void 0 : (_item_customerCompany4 = item.customerCompany) === null || _item_customerCompany4 === void 0 ? void 0 : (_item_customerCompany_organizationSize = _item_customerCompany4.organizationSize) === null || _item_customerCompany_organizationSize === void 0 ? void 0 : _item_customerCompany_organizationSize.companySizeTitleExternal
                            }
                        },
                        advocateQuotes: item === null || item === void 0 ? void 0 : (_item_advocateQuotesCollection = item.advocateQuotesCollection) === null || _item_advocateQuotesCollection === void 0 ? void 0 : (_item_advocateQuotesCollection_items = _item_advocateQuotesCollection.items) === null || _item_advocateQuotesCollection_items === void 0 ? void 0 : _item_advocateQuotesCollection_items.map((item)=>{
                            if ((item === null || item === void 0 ? void 0 : item.advocateName) && item.advocateQuote && item.advocateJobTitle && item.advocateHeadshot) return {
                                advocateName: item === null || item === void 0 ? void 0 : item.advocateName,
                                advocateQuote: item === null || item === void 0 ? void 0 : item.advocateQuote,
                                advocateJobTitle: item === null || item === void 0 ? void 0 : item.advocateJobTitle,
                                advocateHeadshot: item === null || item === void 0 ? void 0 : item.advocateHeadshot
                            };
                            return null;
                        }).filter((item)=>item !== null),
                        storyIcon: item === null || item === void 0 ? void 0 : item.storyIcon,
                        callToAction: item === null || item === void 0 ? void 0 : (_item_callToActionCollection = item.callToActionCollection) === null || _item_callToActionCollection === void 0 ? void 0 : (_item_callToActionCollection_items = _item_callToActionCollection.items) === null || _item_callToActionCollection_items === void 0 ? void 0 : _item_callToActionCollection_items.map((item)=>{
                            return {
                                text: item === null || item === void 0 ? void 0 : item.ctaText,
                                url: item === null || item === void 0 ? void 0 : item.ctaUrl
                            };
                        }),
                        products: item === null || item === void 0 ? void 0 : (_item_productCollection = item.productCollection) === null || _item_productCollection === void 0 ? void 0 : (_item_productCollection_items = _item_productCollection.items) === null || _item_productCollection_items === void 0 ? void 0 : _item_productCollection_items.map((item)=>{
                            var _item_productNameReference;
                            return {
                                name: item === null || item === void 0 ? void 0 : (_item_productNameReference = item.productNameReference) === null || _item_productNameReference === void 0 ? void 0 : _item_productNameReference.productName
                            };
                        }),
                        marketplaceApps: item === null || item === void 0 ? void 0 : (_item_marketplaceAppsCollection = item.marketplaceAppsCollection) === null || _item_marketplaceAppsCollection === void 0 ? void 0 : (_item_marketplaceAppsCollection_items = _item_marketplaceAppsCollection.items) === null || _item_marketplaceAppsCollection_items === void 0 ? void 0 : _item_marketplaceAppsCollection_items.map((item)=>{
                            return {
                                name: item === null || item === void 0 ? void 0 : item.title
                            };
                        }),
                        solutions: item === null || item === void 0 ? void 0 : (_item_solutionCollection = item.solutionCollection) === null || _item_solutionCollection === void 0 ? void 0 : (_item_solutionCollection_items = _item_solutionCollection.items) === null || _item_solutionCollection_items === void 0 ? void 0 : _item_solutionCollection_items.map((item)=>{
                            return {
                                name: item === null || item === void 0 ? void 0 : item.solutionNameExternal
                            };
                        }),
                        solutionPartners: item === null || item === void 0 ? void 0 : (_item_solutionPartnersCollection = item.solutionPartnersCollection) === null || _item_solutionPartnersCollection === void 0 ? void 0 : (_item_solutionPartnersCollection_items = _item_solutionPartnersCollection.items) === null || _item_solutionPartnersCollection_items === void 0 ? void 0 : _item_solutionPartnersCollection_items.map((item)=>{
                            return {
                                name: item === null || item === void 0 ? void 0 : item.organizationNameExternal
                            };
                        }),
                        urlSlug: item === null || item === void 0 ? void 0 : item.urlSlug
                    }
                };
            })) !== null && _contentfulStories_customerStoryCollection_items_map !== void 0 ? _contentfulStories_customerStoryCollection_items_map : []
        },
        taxonomyCompanySizeCollection: contentfulStories.taxonomyCompanySizeCollection,
        filters: {
            edges: [
                ...(_contentfulStories_taxonomyIndustryCollection_items_filter_map = contentfulStories === null || contentfulStories === void 0 ? void 0 : (_contentfulStories_taxonomyIndustryCollection = contentfulStories.taxonomyIndustryCollection) === null || _contentfulStories_taxonomyIndustryCollection === void 0 ? void 0 : (_contentfulStories_taxonomyIndustryCollection_items = _contentfulStories_taxonomyIndustryCollection.items) === null || _contentfulStories_taxonomyIndustryCollection_items === void 0 ? void 0 : _contentfulStories_taxonomyIndustryCollection_items.filter((item)=>{
                    var _item_linkedFrom_companyNameInternalCollection_items, _item_linkedFrom_companyNameInternalCollection, _item_linkedFrom;
                    return item === null || item === void 0 ? void 0 : (_item_linkedFrom = item.linkedFrom) === null || _item_linkedFrom === void 0 ? void 0 : (_item_linkedFrom_companyNameInternalCollection = _item_linkedFrom.companyNameInternalCollection) === null || _item_linkedFrom_companyNameInternalCollection === void 0 ? void 0 : (_item_linkedFrom_companyNameInternalCollection_items = _item_linkedFrom_companyNameInternalCollection.items) === null || _item_linkedFrom_companyNameInternalCollection_items === void 0 ? void 0 : _item_linkedFrom_companyNameInternalCollection_items.some((link)=>{
                        var _link_linkedFrom_customerStoryCollection, _link_linkedFrom;
                        return link === null || link === void 0 ? void 0 : (_link_linkedFrom = link.linkedFrom) === null || _link_linkedFrom === void 0 ? void 0 : (_link_linkedFrom_customerStoryCollection = _link_linkedFrom.customerStoryCollection) === null || _link_linkedFrom_customerStoryCollection === void 0 ? void 0 : _link_linkedFrom_customerStoryCollection.total;
                    });
                }).map((element)=>{
                    return {
                        node: {
                            context: {
                                name: element === null || element === void 0 ? void 0 : element.industryName
                            },
                            field: "industry"
                        }
                    };
                })) !== null && _contentfulStories_taxonomyIndustryCollection_items_filter_map !== void 0 ? _contentfulStories_taxonomyIndustryCollection_items_filter_map : [],
                ...(_contentfulStories_taxonomyCompanySizeCollection_items_filter_map = contentfulStories === null || contentfulStories === void 0 ? void 0 : (_contentfulStories_taxonomyCompanySizeCollection = contentfulStories.taxonomyCompanySizeCollection) === null || _contentfulStories_taxonomyCompanySizeCollection === void 0 ? void 0 : (_contentfulStories_taxonomyCompanySizeCollection_items = _contentfulStories_taxonomyCompanySizeCollection.items) === null || _contentfulStories_taxonomyCompanySizeCollection_items === void 0 ? void 0 : _contentfulStories_taxonomyCompanySizeCollection_items.filter((item)=>{
                    var _item_linkedFrom_companyNameInternalCollection_items, _item_linkedFrom_companyNameInternalCollection, _item_linkedFrom;
                    return item === null || item === void 0 ? void 0 : (_item_linkedFrom = item.linkedFrom) === null || _item_linkedFrom === void 0 ? void 0 : (_item_linkedFrom_companyNameInternalCollection = _item_linkedFrom.companyNameInternalCollection) === null || _item_linkedFrom_companyNameInternalCollection === void 0 ? void 0 : (_item_linkedFrom_companyNameInternalCollection_items = _item_linkedFrom_companyNameInternalCollection.items) === null || _item_linkedFrom_companyNameInternalCollection_items === void 0 ? void 0 : _item_linkedFrom_companyNameInternalCollection_items.some((link)=>{
                        var _link_linkedFrom_customerStoryCollection, _link_linkedFrom;
                        return link === null || link === void 0 ? void 0 : (_link_linkedFrom = link.linkedFrom) === null || _link_linkedFrom === void 0 ? void 0 : (_link_linkedFrom_customerStoryCollection = _link_linkedFrom.customerStoryCollection) === null || _link_linkedFrom_customerStoryCollection === void 0 ? void 0 : _link_linkedFrom_customerStoryCollection.total;
                    });
                }).map((element)=>{
                    return {
                        node: {
                            context: {
                                name: element === null || element === void 0 ? void 0 : element.companySizeTitleExternal
                            },
                            field: "organizationSize"
                        }
                    };
                })) !== null && _contentfulStories_taxonomyCompanySizeCollection_items_filter_map !== void 0 ? _contentfulStories_taxonomyCompanySizeCollection_items_filter_map : [],
                ...(_contentfulStories_productNameCollection_items_filter_map = contentfulStories === null || contentfulStories === void 0 ? void 0 : (_contentfulStories_productNameCollection = contentfulStories.productNameCollection) === null || _contentfulStories_productNameCollection === void 0 ? void 0 : (_contentfulStories_productNameCollection_items = _contentfulStories_productNameCollection.items) === null || _contentfulStories_productNameCollection_items === void 0 ? void 0 : _contentfulStories_productNameCollection_items.filter((item)=>{
                    var _item_linkedFrom_productListingCollection_items, _item_linkedFrom_productListingCollection, _item_linkedFrom;
                    return item === null || item === void 0 ? void 0 : (_item_linkedFrom = item.linkedFrom) === null || _item_linkedFrom === void 0 ? void 0 : (_item_linkedFrom_productListingCollection = _item_linkedFrom.productListingCollection) === null || _item_linkedFrom_productListingCollection === void 0 ? void 0 : (_item_linkedFrom_productListingCollection_items = _item_linkedFrom_productListingCollection.items) === null || _item_linkedFrom_productListingCollection_items === void 0 ? void 0 : _item_linkedFrom_productListingCollection_items.some((link)=>{
                        var _link_linkedFrom_customerStoryCollection, _link_linkedFrom;
                        return link === null || link === void 0 ? void 0 : (_link_linkedFrom = link.linkedFrom) === null || _link_linkedFrom === void 0 ? void 0 : (_link_linkedFrom_customerStoryCollection = _link_linkedFrom.customerStoryCollection) === null || _link_linkedFrom_customerStoryCollection === void 0 ? void 0 : _link_linkedFrom_customerStoryCollection.total;
                    });
                }).map((element)=>{
                    return {
                        node: {
                            context: {
                                name: element === null || element === void 0 ? void 0 : element.productName
                            },
                            field: "products"
                        }
                    };
                })) !== null && _contentfulStories_productNameCollection_items_filter_map !== void 0 ? _contentfulStories_productNameCollection_items_filter_map : [],
                ...(_contentfulStories_taxonomyRegionCollection_items_filter_map = contentfulStories === null || contentfulStories === void 0 ? void 0 : (_contentfulStories_taxonomyRegionCollection = contentfulStories.taxonomyRegionCollection) === null || _contentfulStories_taxonomyRegionCollection === void 0 ? void 0 : (_contentfulStories_taxonomyRegionCollection_items = _contentfulStories_taxonomyRegionCollection.items) === null || _contentfulStories_taxonomyRegionCollection_items === void 0 ? void 0 : _contentfulStories_taxonomyRegionCollection_items.filter((item)=>{
                    var _item_linkedFrom_companyNameInternalCollection_items, _item_linkedFrom_companyNameInternalCollection, _item_linkedFrom;
                    return item === null || item === void 0 ? void 0 : (_item_linkedFrom = item.linkedFrom) === null || _item_linkedFrom === void 0 ? void 0 : (_item_linkedFrom_companyNameInternalCollection = _item_linkedFrom.companyNameInternalCollection) === null || _item_linkedFrom_companyNameInternalCollection === void 0 ? void 0 : (_item_linkedFrom_companyNameInternalCollection_items = _item_linkedFrom_companyNameInternalCollection.items) === null || _item_linkedFrom_companyNameInternalCollection_items === void 0 ? void 0 : _item_linkedFrom_companyNameInternalCollection_items.some((link)=>{
                        var _link_linkedFrom_customerStoryCollection, _link_linkedFrom;
                        return link === null || link === void 0 ? void 0 : (_link_linkedFrom = link.linkedFrom) === null || _link_linkedFrom === void 0 ? void 0 : (_link_linkedFrom_customerStoryCollection = _link_linkedFrom.customerStoryCollection) === null || _link_linkedFrom_customerStoryCollection === void 0 ? void 0 : _link_linkedFrom_customerStoryCollection.total;
                    });
                }).map((element)=>{
                    return {
                        node: {
                            context: {
                                name: element === null || element === void 0 ? void 0 : element.regionNameExternal
                            },
                            field: "region"
                        }
                    };
                })) !== null && _contentfulStories_taxonomyRegionCollection_items_filter_map !== void 0 ? _contentfulStories_taxonomyRegionCollection_items_filter_map : [],
                ...(_contentfulStories_taxonomySolutionCollection_items_filter_map = contentfulStories === null || contentfulStories === void 0 ? void 0 : (_contentfulStories_taxonomySolutionCollection = contentfulStories.taxonomySolutionCollection) === null || _contentfulStories_taxonomySolutionCollection === void 0 ? void 0 : (_contentfulStories_taxonomySolutionCollection_items = _contentfulStories_taxonomySolutionCollection.items) === null || _contentfulStories_taxonomySolutionCollection_items === void 0 ? void 0 : _contentfulStories_taxonomySolutionCollection_items.filter((item)=>{
                    var _item_linkedFrom_customerStoryCollection, _item_linkedFrom;
                    return item === null || item === void 0 ? void 0 : (_item_linkedFrom = item.linkedFrom) === null || _item_linkedFrom === void 0 ? void 0 : (_item_linkedFrom_customerStoryCollection = _item_linkedFrom.customerStoryCollection) === null || _item_linkedFrom_customerStoryCollection === void 0 ? void 0 : _item_linkedFrom_customerStoryCollection.total;
                }).map((element)=>{
                    return {
                        node: {
                            context: {
                                name: element === null || element === void 0 ? void 0 : element.solutionNameExternal
                            },
                            field: "solution"
                        }
                    };
                })) !== null && _contentfulStories_taxonomySolutionCollection_items_filter_map !== void 0 ? _contentfulStories_taxonomySolutionCollection_items_filter_map : []
            ]
        }
    };
};

});
parcelRegister("i7ByD", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", function () { return $f9d4831575b28347$export$2e2bcd8739ae039; });
/**
 * @generated SignedSource<<aa76402dc3843fc5341fa58c523e40ae>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f9d4831575b28347$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "locale"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "locale",
        "variableName": "locale"
    }, v2 = [
        {
            "kind": "Literal",
            "name": "limit",
            "value": 200
        },
        v1 /*: any*/ 
    ], v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "storyTitleExternal",
        "storageKey": null
    }, v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "organizationNameExternal",
        "storageKey": null
    }, v5 = {
        "kind": "Literal",
        "name": "limit",
        "value": 5
    }, v6 = [
        v5 /*: any*/ 
    ], v7 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "contentType",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "url",
            "storageKey": null
        }
    ], v8 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "industryName",
        "storageKey": null
    }, v9 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "regionNameExternal",
        "storageKey": null
    }, v10 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "companySizeTitleExternal",
        "storageKey": null
    }, v11 = {
        "alias": null,
        "args": null,
        "concreteType": "CompanyNameInternal",
        "kind": "LinkedField",
        "name": "customerCompany",
        "plural": false,
        "selections": [
            v4 /*: any*/ ,
            {
                "alias": null,
                "args": v6 /*: any*/ ,
                "concreteType": "AssetCollection",
                "kind": "LinkedField",
                "name": "logoCollection",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "Asset",
                        "kind": "LinkedField",
                        "name": "items",
                        "plural": true,
                        "selections": v7 /*: any*/ ,
                        "storageKey": null
                    }
                ],
                "storageKey": "logoCollection(limit:5)"
            },
            {
                "alias": null,
                "args": v6 /*: any*/ ,
                "concreteType": "CompanyNameInternalIndustryCollection",
                "kind": "LinkedField",
                "name": "industryCollection",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "TaxonomyIndustry",
                        "kind": "LinkedField",
                        "name": "items",
                        "plural": true,
                        "selections": [
                            v8 /*: any*/ 
                        ],
                        "storageKey": null
                    }
                ],
                "storageKey": "industryCollection(limit:5)"
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "TaxonomyRegion",
                "kind": "LinkedField",
                "name": "region",
                "plural": false,
                "selections": [
                    v9 /*: any*/ 
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "TaxonomyCompanySize",
                "kind": "LinkedField",
                "name": "organizationSize",
                "plural": false,
                "selections": [
                    v10 /*: any*/ 
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    }, v12 = {
        "alias": null,
        "args": v6 /*: any*/ ,
        "concreteType": "CustomerStoryAdvocateQuotesCollection",
        "kind": "LinkedField",
        "name": "advocateQuotesCollection",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "AdvocateQuote",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "advocateName",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "advocateQuote",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "advocateJobTitle",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "Asset",
                        "kind": "LinkedField",
                        "name": "advocateHeadshot",
                        "plural": false,
                        "selections": v7 /*: any*/ ,
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": "advocateQuotesCollection(limit:5)"
    }, v13 = {
        "alias": null,
        "args": null,
        "concreteType": "Asset",
        "kind": "LinkedField",
        "name": "storyIcon",
        "plural": false,
        "selections": v7 /*: any*/ ,
        "storageKey": null
    }, v14 = {
        "alias": null,
        "args": v6 /*: any*/ ,
        "concreteType": "CustomerStoryCallToActionCollection",
        "kind": "LinkedField",
        "name": "callToActionCollection",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "CallToAction",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "ctaText",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "ctaUrl",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": "callToActionCollection(limit:5)"
    }, v15 = {
        "kind": "Literal",
        "name": "limit",
        "value": 20
    }, v16 = [
        v15 /*: any*/ 
    ], v17 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "productName",
        "storageKey": null
    }, v18 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "ProductName",
                "kind": "LinkedField",
                "name": "productNameReference",
                "plural": false,
                "selections": [
                    v17 /*: any*/ 
                ],
                "storageKey": null
            }
        ],
        "type": "ProductListing",
        "abstractKey": null
    }, v19 = {
        "alias": null,
        "args": v6 /*: any*/ ,
        "concreteType": "CustomerStoryMarketplaceAppsCollection",
        "kind": "LinkedField",
        "name": "marketplaceAppsCollection",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "ContextApp",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "title",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": "marketplaceAppsCollection(limit:5)"
    }, v20 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "solutionNameExternal",
        "storageKey": null
    }, v21 = {
        "alias": null,
        "args": v6 /*: any*/ ,
        "concreteType": "CustomerStorySolutionCollection",
        "kind": "LinkedField",
        "name": "solutionCollection",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "TaxonomySolution",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                    v20 /*: any*/ 
                ],
                "storageKey": null
            }
        ],
        "storageKey": "solutionCollection(limit:5)"
    }, v22 = {
        "alias": null,
        "args": v6 /*: any*/ ,
        "concreteType": "CustomerStorySolutionPartnersCollection",
        "kind": "LinkedField",
        "name": "solutionPartnersCollection",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "CompanyNameInternal",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                    v4 /*: any*/ 
                ],
                "storageKey": null
            }
        ],
        "storageKey": "solutionPartnersCollection(limit:5)"
    }, v23 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "urlSlug",
        "storageKey": null
    }, v24 = [
        v15 /*: any*/ ,
        v1 /*: any*/ 
    ], v25 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "total",
        "storageKey": null
    }, v26 = [
        {
            "kind": "Literal",
            "name": "allowedLocales",
            "value": [
                "en-US",
                "es",
                "ja-JP",
                "pt-BR",
                "fr-FR",
                "de-DE",
                "nl-NL",
                "it-IT",
                "ko-KR",
                "pl-PL",
                "ru-RU",
                "zh-CN"
            ]
        }
    ], v27 = [
        v25 /*: any*/ 
    ], v28 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Literal",
                    "name": "limit",
                    "value": 1
                }
            ],
            "concreteType": "CustomerStoryCollection",
            "kind": "LinkedField",
            "name": "customerStoryCollection",
            "plural": false,
            "selections": v27 /*: any*/ ,
            "storageKey": "customerStoryCollection(limit:1)"
        }
    ], v29 = {
        "alias": null,
        "args": v26 /*: any*/ ,
        "concreteType": "CompanyNameInternalLinkingCollections",
        "kind": "LinkedField",
        "name": "linkedFrom",
        "plural": false,
        "selections": v28 /*: any*/ ,
        "storageKey": "linkedFrom(allowedLocales:[\"en-US\",\"es\",\"ja-JP\",\"pt-BR\",\"fr-FR\",\"de-DE\",\"nl-NL\",\"it-IT\",\"ko-KR\",\"pl-PL\",\"ru-RU\",\"zh-CN\"])"
    }, v30 = {
        "alias": null,
        "args": v24 /*: any*/ ,
        "concreteType": "TaxonomyIndustryCollection",
        "kind": "LinkedField",
        "name": "taxonomyIndustryCollection",
        "plural": false,
        "selections": [
            v25 /*: any*/ ,
            {
                "alias": null,
                "args": null,
                "concreteType": "TaxonomyIndustry",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                    v8 /*: any*/ ,
                    {
                        "alias": null,
                        "args": v26 /*: any*/ ,
                        "concreteType": "TaxonomyIndustryLinkingCollections",
                        "kind": "LinkedField",
                        "name": "linkedFrom",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "CompanyNameInternalCollection",
                                "kind": "LinkedField",
                                "name": "companyNameInternalCollection",
                                "plural": false,
                                "selections": [
                                    v25 /*: any*/ ,
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "CompanyNameInternal",
                                        "kind": "LinkedField",
                                        "name": "items",
                                        "plural": true,
                                        "selections": [
                                            v4 /*: any*/ ,
                                            v29 /*: any*/ 
                                        ],
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "storageKey": "linkedFrom(allowedLocales:[\"en-US\",\"es\",\"ja-JP\",\"pt-BR\",\"fr-FR\",\"de-DE\",\"nl-NL\",\"it-IT\",\"ko-KR\",\"pl-PL\",\"ru-RU\",\"zh-CN\"])"
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    }, v31 = {
        "alias": null,
        "args": [
            {
                "kind": "Literal",
                "name": "limit",
                "value": 25
            },
            v1 /*: any*/ 
        ],
        "concreteType": "ProductNameCollection",
        "kind": "LinkedField",
        "name": "productNameCollection",
        "plural": false,
        "selections": [
            v25 /*: any*/ ,
            {
                "alias": null,
                "args": null,
                "concreteType": "ProductName",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                    v17 /*: any*/ ,
                    {
                        "alias": null,
                        "args": v26 /*: any*/ ,
                        "concreteType": "ProductNameLinkingCollections",
                        "kind": "LinkedField",
                        "name": "linkedFrom",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "ProductListingCollection",
                                "kind": "LinkedField",
                                "name": "productListingCollection",
                                "plural": false,
                                "selections": [
                                    v25 /*: any*/ ,
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ProductListing",
                                        "kind": "LinkedField",
                                        "name": "items",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "alias": null,
                                                "args": v26 /*: any*/ ,
                                                "concreteType": "ProductListingLinkingCollections",
                                                "kind": "LinkedField",
                                                "name": "linkedFrom",
                                                "plural": false,
                                                "selections": v28 /*: any*/ ,
                                                "storageKey": "linkedFrom(allowedLocales:[\"en-US\",\"es\",\"ja-JP\",\"pt-BR\",\"fr-FR\",\"de-DE\",\"nl-NL\",\"it-IT\",\"ko-KR\",\"pl-PL\",\"ru-RU\",\"zh-CN\"])"
                                            }
                                        ],
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "storageKey": "linkedFrom(allowedLocales:[\"en-US\",\"es\",\"ja-JP\",\"pt-BR\",\"fr-FR\",\"de-DE\",\"nl-NL\",\"it-IT\",\"ko-KR\",\"pl-PL\",\"ru-RU\",\"zh-CN\"])"
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    }, v32 = [
        {
            "alias": null,
            "args": null,
            "concreteType": "CompanyNameInternalCollection",
            "kind": "LinkedField",
            "name": "companyNameInternalCollection",
            "plural": false,
            "selections": [
                v25 /*: any*/ ,
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "CompanyNameInternal",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": true,
                    "selections": [
                        v29 /*: any*/ 
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ], v33 = {
        "alias": null,
        "args": [
            {
                "kind": "Literal",
                "name": "limit",
                "value": 10
            },
            v1 /*: any*/ 
        ],
        "concreteType": "TaxonomyRegionCollection",
        "kind": "LinkedField",
        "name": "taxonomyRegionCollection",
        "plural": false,
        "selections": [
            v25 /*: any*/ ,
            {
                "alias": null,
                "args": null,
                "concreteType": "TaxonomyRegion",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                    v9 /*: any*/ ,
                    {
                        "alias": null,
                        "args": v26 /*: any*/ ,
                        "concreteType": "TaxonomyRegionLinkingCollections",
                        "kind": "LinkedField",
                        "name": "linkedFrom",
                        "plural": false,
                        "selections": v32 /*: any*/ ,
                        "storageKey": "linkedFrom(allowedLocales:[\"en-US\",\"es\",\"ja-JP\",\"pt-BR\",\"fr-FR\",\"de-DE\",\"nl-NL\",\"it-IT\",\"ko-KR\",\"pl-PL\",\"ru-RU\",\"zh-CN\"])"
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    }, v34 = {
        "alias": null,
        "args": v24 /*: any*/ ,
        "concreteType": "TaxonomySolutionCollection",
        "kind": "LinkedField",
        "name": "taxonomySolutionCollection",
        "plural": false,
        "selections": [
            v25 /*: any*/ ,
            {
                "alias": null,
                "args": null,
                "concreteType": "TaxonomySolution",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                    v20 /*: any*/ ,
                    {
                        "alias": null,
                        "args": v26 /*: any*/ ,
                        "concreteType": "TaxonomySolutionLinkingCollections",
                        "kind": "LinkedField",
                        "name": "linkedFrom",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "CustomerStoryCollection",
                                "kind": "LinkedField",
                                "name": "customerStoryCollection",
                                "plural": false,
                                "selections": v27 /*: any*/ ,
                                "storageKey": null
                            }
                        ],
                        "storageKey": "linkedFrom(allowedLocales:[\"en-US\",\"es\",\"ja-JP\",\"pt-BR\",\"fr-FR\",\"de-DE\",\"nl-NL\",\"it-IT\",\"ko-KR\",\"pl-PL\",\"ru-RU\",\"zh-CN\"])"
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    }, v35 = {
        "alias": null,
        "args": [
            v5 /*: any*/ ,
            v1 /*: any*/ 
        ],
        "concreteType": "TaxonomyCompanySizeCollection",
        "kind": "LinkedField",
        "name": "taxonomyCompanySizeCollection",
        "plural": false,
        "selections": [
            v25 /*: any*/ ,
            {
                "alias": null,
                "args": null,
                "concreteType": "TaxonomyCompanySize",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                    v10 /*: any*/ ,
                    {
                        "alias": null,
                        "args": v26 /*: any*/ ,
                        "concreteType": "TaxonomyCompanySizeLinkingCollections",
                        "kind": "LinkedField",
                        "name": "linkedFrom",
                        "plural": false,
                        "selections": v32 /*: any*/ ,
                        "storageKey": "linkedFrom(allowedLocales:[\"en-US\",\"es\",\"ja-JP\",\"pt-BR\",\"fr-FR\",\"de-DE\",\"nl-NL\",\"it-IT\",\"ko-KR\",\"pl-PL\",\"ru-RU\",\"zh-CN\"])"
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "metadata": null,
            "name": "customerLandingPageRelayQuery",
            "selections": [
                {
                    "alias": null,
                    "args": v2 /*: any*/ ,
                    "concreteType": "CustomerStoryCollection",
                    "kind": "LinkedField",
                    "name": "customerStoryCollection",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "CustomerStory",
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                {
                                    "alias": null,
                                    "args": v16 /*: any*/ ,
                                    "concreteType": "CustomerStoryProductCollection",
                                    "kind": "LinkedField",
                                    "name": "productCollection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "items",
                                            "plural": true,
                                            "selections": [
                                                v18 /*: any*/ 
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "productCollection(limit:20)"
                                },
                                v19 /*: any*/ ,
                                v21 /*: any*/ ,
                                v22 /*: any*/ ,
                                v23 /*: any*/ 
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                },
                v30 /*: any*/ ,
                v31 /*: any*/ ,
                v33 /*: any*/ ,
                v34 /*: any*/ ,
                v35 /*: any*/ 
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "customerLandingPageRelayQuery",
            "selections": [
                {
                    "alias": null,
                    "args": v2 /*: any*/ ,
                    "concreteType": "CustomerStoryCollection",
                    "kind": "LinkedField",
                    "name": "customerStoryCollection",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "CustomerStory",
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                {
                                    "alias": null,
                                    "args": v16 /*: any*/ ,
                                    "concreteType": "CustomerStoryProductCollection",
                                    "kind": "LinkedField",
                                    "name": "productCollection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "items",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "__typename",
                                                    "storageKey": null
                                                },
                                                v18 /*: any*/ 
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "productCollection(limit:20)"
                                },
                                v19 /*: any*/ ,
                                v21 /*: any*/ ,
                                v22 /*: any*/ ,
                                v23 /*: any*/ 
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                },
                v30 /*: any*/ ,
                v31 /*: any*/ ,
                v33 /*: any*/ ,
                v34 /*: any*/ ,
                v35 /*: any*/ 
            ]
        },
        "params": {
            "cacheID": "fb7371909305d4b09cdd94a5cfde8afb",
            "id": null,
            "metadata": {},
            "name": "customerLandingPageRelayQuery",
            "operationKind": "query",
            "text": "query customerLandingPageRelayQuery(\n  $locale: String!\n) {\n  customerStoryCollection(locale: $locale, limit: 200) {\n    items {\n      storyTitleExternal\n      customerCompany {\n        organizationNameExternal\n        logoCollection(limit: 5) {\n          items {\n            description\n            contentType\n            url\n          }\n        }\n        industryCollection(limit: 5) {\n          items {\n            industryName\n          }\n        }\n        region {\n          regionNameExternal\n        }\n        organizationSize {\n          companySizeTitleExternal\n        }\n      }\n      advocateQuotesCollection(limit: 5) {\n        items {\n          advocateName\n          advocateQuote\n          advocateJobTitle\n          advocateHeadshot {\n            description\n            contentType\n            url\n          }\n        }\n      }\n      storyIcon {\n        description\n        contentType\n        url\n      }\n      callToActionCollection(limit: 5) {\n        items {\n          ctaText\n          ctaUrl\n        }\n      }\n      productCollection(limit: 20) {\n        items {\n          __typename\n          ... on ProductListing {\n            productNameReference {\n              productName\n            }\n          }\n        }\n      }\n      marketplaceAppsCollection(limit: 5) {\n        items {\n          title\n        }\n      }\n      solutionCollection(limit: 5) {\n        items {\n          solutionNameExternal\n        }\n      }\n      solutionPartnersCollection(limit: 5) {\n        items {\n          organizationNameExternal\n        }\n      }\n      urlSlug\n    }\n  }\n  taxonomyIndustryCollection(locale: $locale, limit: 20) {\n    total\n    items {\n      industryName\n      linkedFrom(allowedLocales: [\"en-US\", \"es\", \"ja-JP\", \"pt-BR\", \"fr-FR\", \"de-DE\", \"nl-NL\", \"it-IT\", \"ko-KR\", \"pl-PL\", \"ru-RU\", \"zh-CN\"]) {\n        companyNameInternalCollection {\n          total\n          items {\n            organizationNameExternal\n            linkedFrom(allowedLocales: [\"en-US\", \"es\", \"ja-JP\", \"pt-BR\", \"fr-FR\", \"de-DE\", \"nl-NL\", \"it-IT\", \"ko-KR\", \"pl-PL\", \"ru-RU\", \"zh-CN\"]) {\n              customerStoryCollection(limit: 1) {\n                total\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n  productNameCollection(locale: $locale, limit: 25) {\n    total\n    items {\n      productName\n      linkedFrom(allowedLocales: [\"en-US\", \"es\", \"ja-JP\", \"pt-BR\", \"fr-FR\", \"de-DE\", \"nl-NL\", \"it-IT\", \"ko-KR\", \"pl-PL\", \"ru-RU\", \"zh-CN\"]) {\n        productListingCollection {\n          total\n          items {\n            linkedFrom(allowedLocales: [\"en-US\", \"es\", \"ja-JP\", \"pt-BR\", \"fr-FR\", \"de-DE\", \"nl-NL\", \"it-IT\", \"ko-KR\", \"pl-PL\", \"ru-RU\", \"zh-CN\"]) {\n              customerStoryCollection(limit: 1) {\n                total\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n  taxonomyRegionCollection(locale: $locale, limit: 10) {\n    total\n    items {\n      regionNameExternal\n      linkedFrom(allowedLocales: [\"en-US\", \"es\", \"ja-JP\", \"pt-BR\", \"fr-FR\", \"de-DE\", \"nl-NL\", \"it-IT\", \"ko-KR\", \"pl-PL\", \"ru-RU\", \"zh-CN\"]) {\n        companyNameInternalCollection {\n          total\n          items {\n            linkedFrom(allowedLocales: [\"en-US\", \"es\", \"ja-JP\", \"pt-BR\", \"fr-FR\", \"de-DE\", \"nl-NL\", \"it-IT\", \"ko-KR\", \"pl-PL\", \"ru-RU\", \"zh-CN\"]) {\n              customerStoryCollection(limit: 1) {\n                total\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n  taxonomySolutionCollection(locale: $locale, limit: 20) {\n    total\n    items {\n      solutionNameExternal\n      linkedFrom(allowedLocales: [\"en-US\", \"es\", \"ja-JP\", \"pt-BR\", \"fr-FR\", \"de-DE\", \"nl-NL\", \"it-IT\", \"ko-KR\", \"pl-PL\", \"ru-RU\", \"zh-CN\"]) {\n        customerStoryCollection {\n          total\n        }\n      }\n    }\n  }\n  taxonomyCompanySizeCollection(locale: $locale, limit: 5) {\n    total\n    items {\n      companySizeTitleExternal\n      linkedFrom(allowedLocales: [\"en-US\", \"es\", \"ja-JP\", \"pt-BR\", \"fr-FR\", \"de-DE\", \"nl-NL\", \"it-IT\", \"ko-KR\", \"pl-PL\", \"ru-RU\", \"zh-CN\"]) {\n        companyNameInternalCollection {\n          total\n          items {\n            linkedFrom(allowedLocales: [\"en-US\", \"es\", \"ja-JP\", \"pt-BR\", \"fr-FR\", \"de-DE\", \"nl-NL\", \"it-IT\", \"ko-KR\", \"pl-PL\", \"ru-RU\", \"zh-CN\"]) {\n              customerStoryCollection(limit: 1) {\n                total\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"
        }
    };
}();
$f9d4831575b28347$var$node.hash = "8c843ab041f86aaa1c91e2fdfd9f9c32";
var $f9d4831575b28347$export$2e2bcd8739ae039 = $f9d4831575b28347$var$node;

});


parcelRegister("3t7DW", function(module, exports) {
$parcel$export(module.exports, "init", function () { return $be9c067c7be4fda0$export$2cd8252107eb640b; });

var $dypTs = parcelRequire("dypTs");
parcelRequire("gljCV");

var $yhhhl = parcelRequire("yhhhl");

var $ix1ma = parcelRequire("ix1ma");

var $f3gS9 = parcelRequire("f3gS9");

var $fuLgT = parcelRequire("fuLgT");

var $eQyIx = parcelRequire("eQyIx");

var $g0QpW = parcelRequire("g0QpW");

var $6mvtm = parcelRequire("6mvtm");

var $eRzlV = parcelRequire("eRzlV");

var $hgaI1 = parcelRequire("hgaI1");

var $7mHQv = parcelRequire("7mHQv");

var $i2Oi2 = parcelRequire("i2Oi2");

var $hp3ar = parcelRequire("hp3ar");

var $gLm0b = parcelRequire("gLm0b");

var $6gQvZ = parcelRequire("6gQvZ");

var $idVA4 = parcelRequire("idVA4");

var $hu7gH = parcelRequire("hu7gH");
window.BUILD_KEY = "p-572ad4de7d";
window.featureGateBootstrapValues = window.featureGateBootstrapValues || {
    identifiers: {
        analyticsAnonymousId: (0, $fuLgT.default)()
    }
};
const $be9c067c7be4fda0$var$BASE_URL = "https://www.atlassian.com";
const $be9c067c7be4fda0$var$SUPPORTED_LOCALES = [
    {
        hrefLang: "ja",
        langRoute: "ja"
    },
    {
        hrefLang: "fr",
        langRoute: "fr"
    },
    {
        hrefLang: "de",
        langRoute: "de"
    },
    {
        hrefLang: "es",
        langRoute: "es"
    },
    {
        hrefLang: "pt-BR",
        langRoute: "br"
    },
    {
        hrefLang: "zh-Hans",
        langRoute: "zh"
    },
    {
        hrefLang: "ko",
        langRoute: "ko"
    },
    {
        hrefLang: "ru",
        langRoute: "ru"
    },
    {
        hrefLang: "pl",
        langRoute: "pl"
    },
    {
        hrefLang: "it",
        langRoute: "it"
    },
    {
        hrefLang: "nl",
        langRoute: "nl"
    }
];
const $be9c067c7be4fda0$export$2cd8252107eb640b = (Component, query, queryVars, relayApi)=>{
    const analyticsWebClient = (0, $g0QpW.getAnalyticsWebClient)();
    const { locale: locale, path: path } = (0, $hu7gH.parseRoute)(window.location);
    const route = path !== "" ? "/" + path : "";
    // Get location data for experiments and feature gates from server-provided data
    let locationData;
    // Use server-provided data (no client-side API calls)
    if (typeof window !== "undefined") locationData = {
        countryIsoCode: window.countryCode || "",
        regionIsoCode: window.regionIsoCode || ""
    };
    const isPerfOnetrustEnabled = (0, $gLm0b.isPerformanceOnetrustEnabled)(typeof window !== "undefined" ? window.optanonConsentCookie : (0, $gLm0b.extractOptanonConsentCookie)(document.cookie), locationData);
    isPerfOnetrustEnabled && (0, $eQyIx.initUFO)(analyticsWebClient, path);
    const parsedClientCookies = document.cookie ? (0, $yhhhl.parse)(document.cookie) : {};
    const userAgent = typeof window !== "undefined" ? window.navigator.userAgent : "";
    const { finalExperimentOverrides: finalExperimentOverrides, finalFeatureGateOverrides: finalFeatureGateOverrides } = (0, $idVA4.processExperimentAndFeatureGateOverrides)(parsedClientCookies, userAgent, isPerfOnetrustEnabled);
    if ((0, $hp3ar.isEdgeCachingPath)(window.location.pathname)) {
        // Override for Edge Caching
        (0, $hp3ar.overrideAjsAnonIdFromCookie)();
        (0, $hp3ar.overrideCustomAttributes)();
    }
    (0, $hgaI1.initializeFeatureGatesClient)(window.featureGateBootstrapValues, {
        overrideValues: {
            experimentOverrides: finalExperimentOverrides,
            featureGateOverrides: finalFeatureGateOverrides
        },
        // if performance cookies are disabled, we will skip exposures
        localMode: !isPerfOnetrustEnabled
    }).then(()=>{
        const isStatic = typeof window !== "undefined" && window.IS_STATIC;
        const snapshot = window.relayStoreSnapshot;
        let relayBaseUrl = undefined;
        let relayAuthKey = undefined;
        if (relayApi === (0, $6mvtm.RELAY_API_CONTENTFUL)) {
            relayBaseUrl = (0, $eRzlV.CONTENTFUL_GRAPHQL_API_URL);
            relayAuthKey = window.CONTENTFUL_DELIVERY_KEY_PRODUCT_TEMPLATES;
        }
        const relayEnvironment = (0, $i2Oi2.initRelayEnvironment)(snapshot, relayBaseUrl, relayAuthKey);
        const queryRef = (0, $f3gS9.loadQuery)(relayEnvironment, query, queryVars);
        const page = /*#__PURE__*/ (0, $dypTs.jsx)((0, $6gQvZ.SentryIntlProvider), {
            locale: locale,
            messages: window.SSR_languagePack,
            cookies: document.cookie,
            children: /*#__PURE__*/ (0, $dypTs.jsxs)((0, $f3gS9.RelayEnvironmentProvider), {
                environment: relayEnvironment,
                children: [
                    isStatic && /*#__PURE__*/ (0, $dypTs.jsx)("link", {
                        rel: "canonical",
                        href: `${$be9c067c7be4fda0$var$BASE_URL}${route}`
                    }),
                    isStatic && /*#__PURE__*/ (0, $dypTs.jsx)("link", {
                        rel: "alternate",
                        href: `${$be9c067c7be4fda0$var$BASE_URL}${route}`,
                        hrefLang: "x-default"
                    }),
                    isStatic && $be9c067c7be4fda0$var$SUPPORTED_LOCALES.map(({ hrefLang: hrefLang, langRoute: langRoute })=>/*#__PURE__*/ (0, $dypTs.jsx)("link", {
                            rel: "alternate",
                            href: `${$be9c067c7be4fda0$var$BASE_URL}/${langRoute}${route}`,
                            hrefLang: hrefLang
                        }, hrefLang)),
                    /*#__PURE__*/ (0, $dypTs.jsx)((0, $7mHQv.PageWrapper), {
                        analyticsWebClient: analyticsWebClient,
                        location: window.location,
                        pricing: window.prices,
                        availableProducts: window.availableProducts,
                        userProfile: window.userProfile,
                        userProfileStatus: window.userProfileStatus,
                        userContext: window.userContext,
                        userContextStatus: window.userContextStatus,
                        loggedOutContext: window.loggedOutContext,
                        loggedOutContextStatus: window.loggedOutContextStatus,
                        loggedInContext: window.loggedInContext,
                        loggedInContextStatus: window.loggedInContextStatus,
                        countryCode: window.countryCode,
                        mlTemplateIds: window.mlTemplateIds,
                        keyword: window.keyword,
                        subAnchor: window.subAnchor,
                        queryRef: queryRef,
                        PageComponent: Component,
                        transactionAccounts: window.transactionAccounts,
                        userAgent: userAgent
                    })
                ]
            })
        });
        if (isStatic) {
            // @ts-ignore
            const root = (0, $ix1ma.createRoot)(document.getElementById("wac"));
            root.render(page);
        } else (0, $ix1ma.hydrateRoot)(// @ts-ignore
        document.getElementById("wac-root"), page, {
            onRecoverableError: (error, errorInfo)=>{
                var _document_getElementById;
                (_document_getElementById = document.getElementById("wac-root")) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.setAttribute("hydration-error", "true");
            }
        });
    });
};

});
parcelRegister("6mvtm", function(module, exports) {
$parcel$export(module.exports, "RELAY_API_CONTENTFUL", function () { return $e62c9da570d0cc47$export$7b31a9938ec3ba75; });
const $e62c9da570d0cc47$export$7b31a9938ec3ba75 = "contentful";

});

parcelRegister("i2Oi2", function(module, exports) {
$parcel$export(module.exports, "initRelayEnvironment", function () { return $36b5b9e576032b2f$export$1456be3de97c862f; });

var $gRpMo = parcelRequire("gRpMo");
(0, $gRpMo.RelayFeatureFlags).ENABLE_LOAD_QUERY_REQUEST_DEDUPING = true;
// TODO: Lift this into environment
const $36b5b9e576032b2f$var$GATEWAY_URL = "https://www.atlassian.com/gateway/api/graphql";
function $36b5b9e576032b2f$var$createRelayEnvironment(initialRecords, baseUrlOverride, authToken) {
    const baseUrl = baseUrlOverride !== null && baseUrlOverride !== void 0 ? baseUrlOverride : $36b5b9e576032b2f$var$GATEWAY_URL;
    let headers = {
        "Content-Type": "application/json"
    };
    if (authToken) headers = Object.assign({}, headers, {
        Authorization: `Bearer ${authToken}`
    });
    const fetchResponse = (params, variables)=>{
        const startTime = Date.now();
        const response = fetch(baseUrl, {
            method: "POST",
            headers: headers,
            // Contentful uses an authToken, and Access-Control-Allow-Origin = "*",
            // therefore we cannot include credentials for Contentful queries
            credentials: authToken ? "same-origin" : "include",
            body: JSON.stringify({
                query: params.text,
                variables: variables
            })
        });
        return (0, $gRpMo.Observable).from(response.then(async (res)=>{
            const duration = Date.now() - startTime;
            // @ts-ignore
            if (!globalThis.IS_STATIC) try {
                // @ts-ignore
                globalThis.metrics.histogram(`contentful.duration`, "10_100_500_1000_2000_3000_5000_10000_30000", duration, {
                    gqlOperationName: params.name,
                    cacheStatus: res.headers.get("x-cache"),
                    status: res.status
                });
            } catch (e) {
                console.error(`Failed to track ${params.name} call`, e);
            }
            return res.json();
        }));
    };
    const network = (0, $gRpMo.Network).create(fetchResponse);
    const store = new (0, $gRpMo.Store)(new (0, $gRpMo.RecordSource)(initialRecords));
    return new (0, $gRpMo.Environment)({
        network: network,
        store: store
    });
}
let $36b5b9e576032b2f$var$clientSideRelayEnvironment;
function $36b5b9e576032b2f$export$1456be3de97c862f(initialRecords, baseUrlOverride, authToken) {
    const environment = $36b5b9e576032b2f$var$clientSideRelayEnvironment !== null && $36b5b9e576032b2f$var$clientSideRelayEnvironment !== void 0 ? $36b5b9e576032b2f$var$clientSideRelayEnvironment : $36b5b9e576032b2f$var$createRelayEnvironment(initialRecords, baseUrlOverride, authToken);
    if (typeof window === "undefined") return environment;
    if (!$36b5b9e576032b2f$var$clientSideRelayEnvironment) $36b5b9e576032b2f$var$clientSideRelayEnvironment = environment;
    else if (initialRecords) environment.getStore().publish(new (0, $gRpMo.RecordSource)(initialRecords));
    return $36b5b9e576032b2f$var$clientSideRelayEnvironment;
}

});


parcelRegister("1mtK6", function(module, exports) {
$parcel$export(module.exports, "CustomersLandingPage", function () { return $b5b303b3fe3c05f9$export$ba23a27a05802abe; });

var $dypTs = parcelRequire("dypTs");

var $f3gS9 = parcelRequire("f3gS9");

var $4ccia = parcelRequire("4ccia");

var $4EfnG = parcelRequire("4EfnG");
parcelRequire("h6Ndq");
var $2Aj98 = parcelRequire("2Aj98");
const $b5b303b3fe3c05f9$export$ba23a27a05802abe = ({ queryRef: queryRef })=>{
    const preloadedQueryResult = (0, $f3gS9.usePreloadedQuery)((0, $4ccia.CustomerLandingPageRelayQuery), queryRef || null);
    const contentfulResponse = (0, $4ccia.CustomerLandingPageContentfulResponse)(preloadedQueryResult);
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $4EfnG.default), {
        children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $2Aj98.CustomersLandingPageRelayTemplate), {
            // @ts-ignore
            customerLanding: contentfulResponse
        })
    });
};

});
parcelRegister("h6Ndq", function(module, exports) {
$parcel$export(module.exports, "CustomersLandingPageRelayTemplate", function () { return (parcelRequire("2Aj98")).CustomersLandingPageRelayTemplate; });

var $2Aj98 = parcelRequire("2Aj98");

});
parcelRegister("2Aj98", function(module, exports) {
$parcel$export(module.exports, "CustomersLandingPageRelayTemplate", function () { return $2ac8f5f1195b6d64$export$1d3625540e7063b8; });
/* eslint-disable complexity */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dypTs = parcelRequire("dypTs");

var $gljCV = parcelRequire("gljCV");

var $eY3N6 = parcelRequire("eY3N6");

var $bQjAr = parcelRequire("bQjAr");

var $jMhSx = parcelRequire("jMhSx");

var $8LaTa = parcelRequire("8LaTa");

var $l2QYX = parcelRequire("l2QYX");
parcelRequire("90Lnj");
var $h8xfN = parcelRequire("h8xfN");
var $5bCKL = parcelRequire("5bCKL");
var $9K8X0 = parcelRequire("9K8X0");
var $lksJ1 = parcelRequire("lksJ1");
var $03nan = parcelRequire("03nan");
parcelRequire("gD5LF");
var $hBvFS = parcelRequire("hBvFS");
var $1ODGq = parcelRequire("1ODGq");
var $6eXit = parcelRequire("6eXit");

var $4U3Z4 = parcelRequire("4U3Z4");
const $2ac8f5f1195b6d64$var$STORIES_AT_A_TIME = 10;
const $2ac8f5f1195b6d64$var$productOrder = [
    "Jira",
    "Jira Service Management",
    "Jira Align",
    "Jira Product Discovery",
    "Confluence",
    "Trello",
    "Bitbucket",
    "Atlassian Access",
    "Guard",
    "Statuspage",
    "Compass",
    "Bamboo"
];
const $2ac8f5f1195b6d64$var$orgSizeOrder = [
    "Small/Medium",
    // Small/Medium
    "Enterprise",
    // Enterprise
    "Large Enterprise" // Large Enterprise
];
const $2ac8f5f1195b6d64$var$prioritizedSlugMap = {
    "adesso": true,
    "airties": true,
    "arvato-systems": true,
    "avalara": true,
    "canva": true,
    "celonis": true,
    "clearwater-analytics": true,
    "dhcs": true,
    "dish-wireless": true,
    "doodle": true,
    "dropbox": true,
    "edenred": true,
    "fath": true,
    "fiona": true,
    "glovo": true,
    "hy-vee": true,
    "ifood": true,
    "interpark": true,
    "iress": true,
    "kiva": true,
    "lumen": true,
    "mercedes-benz": true,
    "mettle": true,
    "ossur": true,
    "reddit": true,
    "riverty": true,
    "rivian": true,
    "roblox": true,
    "royal-caribbean": true,
    "softwareag": true,
    "sonymusic-publishing": true,
    "state-of-utah": true,
    "sunlife": true,
    "the-very-group": true,
    "united-airlines": true,
    "united": true,
    "us-space-force": true,
    "voith": true
};
const $2ac8f5f1195b6d64$export$1b8a19b49348996e = (customers, filterByEnterprise)=>{
    var _customers_filters, _customers_filters1, _customers_filters2, _customers_filters3, _customers_filters4;
    const industry = (0, $hBvFS.getFilterOptions)((_customers_filters = customers.filters) === null || _customers_filters === void 0 ? void 0 : _customers_filters.industries);
    const region = (0, $hBvFS.getFilterOptions)((_customers_filters1 = customers.filters) === null || _customers_filters1 === void 0 ? void 0 : _customers_filters1.regions, "region");
    const product = (0, $hBvFS.getFilterOptions)((_customers_filters2 = customers.filters) === null || _customers_filters2 === void 0 ? void 0 : _customers_filters2.products);
    const solution = (0, $hBvFS.getFilterOptions)((_customers_filters3 = customers.filters) === null || _customers_filters3 === void 0 ? void 0 : _customers_filters3.solutions);
    let teamSize = (0, $hBvFS.getFilterOptions)((_customers_filters4 = customers.filters) === null || _customers_filters4 === void 0 ? void 0 : _customers_filters4.teamSizes, "team size");
    const defaulted = (0, $6ogO3._)({}, (0, $1ODGq.defaultCustomerStoryFilterOptionsObject));
    if (Object.keys(industry).length) defaulted.industry = industry;
    if (Object.keys(region).length) defaulted["more filters"] = (0, $6ogO3._)({}, defaulted["more filters"], region);
    const teamEnterpriseOverride = {
        Enterprise: {
            committedActive: true,
            stagedActive: true,
            grouping: "team size"
        }
    };
    if (filterByEnterprise) teamSize = (0, $6ogO3._)({}, teamSize, teamEnterpriseOverride);
    if (Object.keys(teamSize).length) defaulted["more filters"] = (0, $6ogO3._)({}, defaulted["more filters"], teamSize);
    if (Object.keys(solution).length) defaulted.solution = solution;
    if (Object.keys(product).length) defaulted.product = product;
    return defaulted;
};
const $2ac8f5f1195b6d64$export$970674147b1999f = (data)=>{
    var _data_filters, _data_customerStories;
    const filters = data === null || data === void 0 ? void 0 : (_data_filters = data.filters) === null || _data_filters === void 0 ? void 0 : _data_filters.edges.sort((a, b)=>a.node.context.name < b.node.context.name ? -1 : 1);
    const result = {
        customerStories: data === null || data === void 0 ? void 0 : (_data_customerStories = data.customerStories) === null || _data_customerStories === void 0 ? void 0 : _data_customerStories.edges.filter((story)=>{
            var _story_node_title, _story_node;
            return (_story_node = story.node) === null || _story_node === void 0 ? void 0 : (_story_node_title = _story_node.title) === null || _story_node_title === void 0 ? void 0 : _story_node_title.trim();
        }).sort((storyA, storyB)=>{
            var _a_advocateQuotes_, _a_advocateQuotes, _a_storyIcon, _b_advocateQuotes_, _b_advocateQuotes, _b_storyIcon, _a_customerCompany, _b_customerCompany;
            // Stories with a quote or a spot illustration are featured and appear first,
            // otherwise we use a secondary sort (alphabetical)
            const a = storyA.node;
            const b = storyB.node;
            if (b.urlSlug && $2ac8f5f1195b6d64$var$prioritizedSlugMap[b.urlSlug]) return 1;
            if (a.urlSlug && $2ac8f5f1195b6d64$var$prioritizedSlugMap[a.urlSlug] || (a === null || a === void 0 ? void 0 : (_a_advocateQuotes = a.advocateQuotes) === null || _a_advocateQuotes === void 0 ? void 0 : (_a_advocateQuotes_ = _a_advocateQuotes[0]) === null || _a_advocateQuotes_ === void 0 ? void 0 : _a_advocateQuotes_.advocateName) || (a === null || a === void 0 ? void 0 : (_a_storyIcon = a.storyIcon) === null || _a_storyIcon === void 0 ? void 0 : _a_storyIcon.url)) return -1;
            else if ((b === null || b === void 0 ? void 0 : (_b_advocateQuotes = b.advocateQuotes) === null || _b_advocateQuotes === void 0 ? void 0 : (_b_advocateQuotes_ = _b_advocateQuotes[0]) === null || _b_advocateQuotes_ === void 0 ? void 0 : _b_advocateQuotes_.advocateName) || (b === null || b === void 0 ? void 0 : (_b_storyIcon = b.storyIcon) === null || _b_storyIcon === void 0 ? void 0 : _b_storyIcon.url)) return 1;
            var _a_customerCompany_name;
            const aName = (_a_customerCompany_name = a === null || a === void 0 ? void 0 : (_a_customerCompany = a.customerCompany) === null || _a_customerCompany === void 0 ? void 0 : _a_customerCompany.name) !== null && _a_customerCompany_name !== void 0 ? _a_customerCompany_name : "";
            var _b_customerCompany_name;
            const bName = (_b_customerCompany_name = b === null || b === void 0 ? void 0 : (_b_customerCompany = b.customerCompany) === null || _b_customerCompany === void 0 ? void 0 : _b_customerCompany.name) !== null && _b_customerCompany_name !== void 0 ? _b_customerCompany_name : "";
            return aName < bName ? -1 : 1;
        }).map((story)=>(0, $4U3Z4.flattenTemplateImageAssets)(story.node)),
        // Get lists to populate filters, by category
        filters: {
            industries: filters === null || filters === void 0 ? void 0 : filters.filter((filter)=>{
                var _filter_node;
                return (filter === null || filter === void 0 ? void 0 : (_filter_node = filter.node) === null || _filter_node === void 0 ? void 0 : _filter_node.field) === "industry";
            }).map((filter)=>{
                var _filter_node;
                return filter === null || filter === void 0 ? void 0 : (_filter_node = filter.node) === null || _filter_node === void 0 ? void 0 : _filter_node.context;
            }),
            regions: filters === null || filters === void 0 ? void 0 : filters.filter((filter)=>{
                var _filter_node;
                return (filter === null || filter === void 0 ? void 0 : (_filter_node = filter.node) === null || _filter_node === void 0 ? void 0 : _filter_node.field) === "region";
            }).map((filter)=>{
                var _filter_node;
                return filter === null || filter === void 0 ? void 0 : (_filter_node = filter.node) === null || _filter_node === void 0 ? void 0 : _filter_node.context;
            }),
            solutions: filters === null || filters === void 0 ? void 0 : filters.filter((filter)=>{
                var _filter_node;
                return (filter === null || filter === void 0 ? void 0 : (_filter_node = filter.node) === null || _filter_node === void 0 ? void 0 : _filter_node.field) === "solution";
            }).map((filter)=>{
                var _filter_node;
                return filter === null || filter === void 0 ? void 0 : (_filter_node = filter.node) === null || _filter_node === void 0 ? void 0 : _filter_node.context;
            }),
            teamSizes: filters === null || filters === void 0 ? void 0 : filters.filter((filter)=>{
                var _filter_node;
                return (filter === null || filter === void 0 ? void 0 : (_filter_node = filter.node) === null || _filter_node === void 0 ? void 0 : _filter_node.field) === "organizationSize";
            }).map((filter)=>{
                var _filter_node;
                return filter === null || filter === void 0 ? void 0 : (_filter_node = filter.node) === null || _filter_node === void 0 ? void 0 : _filter_node.context;
            }).sort((a, b)=>{
                const aIndex = $2ac8f5f1195b6d64$var$orgSizeOrder.indexOf(a.name);
                const bIndex = $2ac8f5f1195b6d64$var$orgSizeOrder.indexOf(b.name);
                if (aIndex < 0) return 1;
                else if (bIndex < 0) return -1;
                return aIndex - bIndex;
            }),
            products: filters === null || filters === void 0 ? void 0 : filters.filter((filter)=>{
                var _filter_node;
                return (filter === null || filter === void 0 ? void 0 : (_filter_node = filter.node) === null || _filter_node === void 0 ? void 0 : _filter_node.field) === "products";
            }).map((filter)=>{
                var _filter_node;
                return filter === null || filter === void 0 ? void 0 : (_filter_node = filter.node) === null || _filter_node === void 0 ? void 0 : _filter_node.context;
            }).sort((a, b)=>{
                const aIndex = $2ac8f5f1195b6d64$var$productOrder.indexOf(a.name);
                const bIndex = $2ac8f5f1195b6d64$var$productOrder.indexOf(b.name);
                if (aIndex < 0) return 1;
                else if (bIndex < 0) return -1;
                return aIndex - bIndex;
            })
        }
    };
    return result;
};
const $2ac8f5f1195b6d64$export$1d3625540e7063b8 = ({ customerLanding: customerLanding })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const filterByEnterpriseParam = $2ac8f5f1195b6d64$var$getFilterByEnterpriseParam();
    const [filterByEnterprise, setFilterByEnterprise] = (0, $gljCV.useState)(filterByEnterpriseParam);
    const customers = $2ac8f5f1195b6d64$export$970674147b1999f(customerLanding);
    const [filterObjectValue, setFilterObjectValue] = (0, $gljCV.useState)($2ac8f5f1195b6d64$export$1b8a19b49348996e(customers, filterByEnterprise));
    const [searchFilterString, setSearchString] = (0, $gljCV.useState)("");
    const [searchInputFieldFocused, setSearchInputFieldFocused] = (0, $gljCV.useState)(false);
    const [filterSearchhasRun, setFilterSearchHasRun] = (0, $gljCV.useState)(false);
    const [customerStoryList, updateCustomerStoryList] = (0, $gljCV.useState)(customers.customerStories);
    const [numberOfCustomerStories, setNumberOfCustomerStories] = (0, $gljCV.useState)(customerStoryList === null || customerStoryList === void 0 ? void 0 : customerStoryList.length);
    const [numberOfVisibleStories, setNumberOfVisibleStories] = (0, $gljCV.useState)($2ac8f5f1195b6d64$var$STORIES_AT_A_TIME);
    (0, $gljCV.useEffect)(()=>{
        setNumberOfCustomerStories(customerStoryList === null || customerStoryList === void 0 ? void 0 : customerStoryList.length);
    }, [
        customerStoryList
    ]);
    (0, $gljCV.useEffect)(()=>{
        // if the URL parameter `filterByEnterprise` is true, and we have received customer stories
        // proceed to run a search with the enterprise filter
        if (filterByEnterprise && customers.customerStories.length > 0) {
            runSearchWithFilters(filterObjectValue, "");
            //set to false so that getDefaultFilterObject() ignores overriding the teamSize filter
            setFilterByEnterprise(false);
        }
    // Reason: Tech Debt - Disable needed to migrate from wac-ufo-segment to ufo-segment
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        customers
    ]);
    const clearAllFilters = ()=>{
        setFilterObjectValue($2ac8f5f1195b6d64$export$1b8a19b49348996e(customers, filterByEnterprise));
        updateCustomerStoryList(customers.customerStories);
        setSearchString("");
        setSearchInputFieldFocused(false);
        setFilterSearchHasRun(false);
    };
    const clearSearchField = ()=>{
        setSearchString("");
        setSearchInputFieldFocused(false);
        runSearchWithFilters(filterObjectValue, "");
    };
    const setSearchStringWrapper = (searchString)=>{
        setSearchString(searchString);
    };
    const loadMoreStories = ()=>{
        setNumberOfVisibleStories(numberOfVisibleStories + $2ac8f5f1195b6d64$var$STORIES_AT_A_TIME);
    };
    const runSearchWithFilters = (filterObject, searchString)=>{
        var _customers_customerStories;
        var _searchString_toLowerCase;
        const normalizedSearchString = (_searchString_toLowerCase = searchString.toLowerCase()) !== null && _searchString_toLowerCase !== void 0 ? _searchString_toLowerCase : "";
        const filtersAreActive = (0, $hBvFS.areFiltersAreActive)(filterObject);
        if (!filtersAreActive && normalizedSearchString.length === 0) {
            setFilterSearchHasRun(false);
            if (customers.customerStories.length !== numberOfCustomerStories) updateCustomerStoryList(customers.customerStories);
            return;
        }
        // Initial text based search
        const searchResults = (_customers_customerStories = customers.customerStories) === null || _customers_customerStories === void 0 ? void 0 : _customers_customerStories.filter((story)=>{
            var _story_title_toLowerCase, _story_title, _story_customerCompany_name_toLowerCase, _story_customerCompany_name, _story_customerCompany, _story_urlSlug_toLowerCase, _story_urlSlug, _story_customerCompany_region_name_toLowerCase, _story_customerCompany_region_name, _story_customerCompany_region, _story_customerCompany1, // @ts-ignore
            _story_customerCompany_industry_filter, _story_customerCompany_industry, _story_customerCompany2, // @ts-ignore
            _story_products_filter, _story_products, _story_customerCompany_organizationSize_name_toLowerCase, _story_customerCompany_organizationSize_name, _story_customerCompany_organizationSize, _story_customerCompany3;
            if (searchFilterString === null || searchFilterString === void 0 ? void 0 : searchFilterString.length) return ((_story_title = story.title) === null || _story_title === void 0 ? void 0 : (_story_title_toLowerCase = _story_title.toLowerCase()) === null || _story_title_toLowerCase === void 0 ? void 0 : _story_title_toLowerCase.includes(normalizedSearchString)) || ((_story_customerCompany = story.customerCompany) === null || _story_customerCompany === void 0 ? void 0 : (_story_customerCompany_name = _story_customerCompany.name) === null || _story_customerCompany_name === void 0 ? void 0 : (_story_customerCompany_name_toLowerCase = _story_customerCompany_name.toLowerCase()) === null || _story_customerCompany_name_toLowerCase === void 0 ? void 0 : _story_customerCompany_name_toLowerCase.includes(normalizedSearchString)) || ((_story_urlSlug = story.urlSlug) === null || _story_urlSlug === void 0 ? void 0 : (_story_urlSlug_toLowerCase = _story_urlSlug.toLowerCase()) === null || _story_urlSlug_toLowerCase === void 0 ? void 0 : _story_urlSlug_toLowerCase.includes(normalizedSearchString)) || ((_story_customerCompany1 = story.customerCompany) === null || _story_customerCompany1 === void 0 ? void 0 : (_story_customerCompany_region = _story_customerCompany1.region) === null || _story_customerCompany_region === void 0 ? void 0 : (_story_customerCompany_region_name = _story_customerCompany_region.name) === null || _story_customerCompany_region_name === void 0 ? void 0 : (_story_customerCompany_region_name_toLowerCase = _story_customerCompany_region_name.toLowerCase()) === null || _story_customerCompany_region_name_toLowerCase === void 0 ? void 0 : _story_customerCompany_region_name_toLowerCase.includes(normalizedSearchString)) || ((_story_customerCompany2 = story.customerCompany) === null || _story_customerCompany2 === void 0 ? void 0 : (_story_customerCompany_industry = _story_customerCompany2.industry) === null || _story_customerCompany_industry === void 0 ? void 0 : (_story_customerCompany_industry_filter = _story_customerCompany_industry.filter((industry)=>{
                var _industry_name_toLowerCase, _industry_name;
                return (_industry_name = industry.name) === null || _industry_name === void 0 ? void 0 : (_industry_name_toLowerCase = _industry_name.toLowerCase()) === null || _industry_name_toLowerCase === void 0 ? void 0 : _industry_name_toLowerCase.includes(normalizedSearchString);
            })) === null || _story_customerCompany_industry_filter === void 0 ? void 0 : _story_customerCompany_industry_filter.length) || ((_story_products = story.products) === null || _story_products === void 0 ? void 0 : (_story_products_filter = _story_products.filter((product)=>{
                var _product_name_toLowerCase, _product_name;
                return (_product_name = product.name) === null || _product_name === void 0 ? void 0 : (_product_name_toLowerCase = _product_name.toLowerCase()) === null || _product_name_toLowerCase === void 0 ? void 0 : _product_name_toLowerCase.includes(normalizedSearchString);
            })) === null || _story_products_filter === void 0 ? void 0 : _story_products_filter.length) || ((_story_customerCompany3 = story.customerCompany) === null || _story_customerCompany3 === void 0 ? void 0 : (_story_customerCompany_organizationSize = _story_customerCompany3.organizationSize) === null || _story_customerCompany_organizationSize === void 0 ? void 0 : (_story_customerCompany_organizationSize_name = _story_customerCompany_organizationSize.name) === null || _story_customerCompany_organizationSize_name === void 0 ? void 0 : (_story_customerCompany_organizationSize_name_toLowerCase = _story_customerCompany_organizationSize_name.toLowerCase()) === null || _story_customerCompany_organizationSize_name_toLowerCase === void 0 ? void 0 : _story_customerCompany_organizationSize_name_toLowerCase.includes(normalizedSearchString));
            return true;
        });
        const filterResults = (0, $6eXit.filterCustomerStories)(searchResults, filterObject, "committedActive");
        updateCustomerStoryList(filterResults);
        setFilterSearchHasRun(true);
        createAnalyticsEvent({
            eventComponent: "customerFilter",
            eventType: "ui",
            action: "clicked",
            actionSubject: "component",
            attributes: {
                filtersApplied: (0, $hBvFS.getFilterEventProps)(filterObject),
                page_path: "/customers"
            }
        }).fire();
    };
    // In order to get the number of Customer Stories matching the stagedActive filter
    // we need to we'll call the filterCustomerStories function with the stagedActive flag
    const numberOfCustomerStoriesFilteredByStagedActive = (0, $gljCV.useMemo)(()=>{
        var _filterCustomerStories;
        return (_filterCustomerStories = (0, $6eXit.filterCustomerStories)(customers.customerStories, filterObjectValue, "stagedActive")) === null || _filterCustomerStories === void 0 ? void 0 : _filterCustomerStories.length;
    }, [
        filterObjectValue,
        customers.customerStories
    ]);
    let fallbackCustomerStoryList = (0, $gljCV.useMemo)(()=>{
        return [];
    }, []);
    fallbackCustomerStoryList = (0, $gljCV.useMemo)(()=>{
        return (0, $hBvFS.handleFallbackCustomerStories)(customers.customerStories);
    }, [
        customers.customerStories
    ]);
    return /*#__PURE__*/ (0, $dypTs.jsxs)((0, $bQjAr.default), {
        name: "customers-page",
        children: [
            /*#__PURE__*/ (0, $dypTs.jsx)((0, $l2QYX.default), {
                isShowTryNowLink: true,
                productKey: "customers"
            }),
            /*#__PURE__*/ (0, $dypTs.jsxs)((0, $jMhSx.TypographyStyles), {
                children: [
                    /*#__PURE__*/ (0, $dypTs.jsx)((0, $h8xfN.CarouselSection), {}),
                    /*#__PURE__*/ (0, $dypTs.jsx)((0, $9K8X0.CustomerStoryFilters), {
                        filterObject: filterObjectValue,
                        clearAllFilterButtonClickHandler: clearAllFilters,
                        setFilterObjectValue: setFilterObjectValue,
                        runSearchWithFilters: runSearchWithFilters,
                        numberOfCustomerStoriesByCommittedValues: numberOfCustomerStories,
                        numberOfCustomerStoriesByStagedValues: numberOfCustomerStoriesFilteredByStagedActive,
                        searchStringValue: searchFilterString,
                        searchInputFieldFocused: searchInputFieldFocused,
                        setSearchInputFieldFocused: setSearchInputFieldFocused,
                        clearSearchField: clearSearchField,
                        setSearchString: setSearchStringWrapper,
                        hasFilterSearchRun: filterSearchhasRun
                    }),
                    /*#__PURE__*/ (0, $dypTs.jsx)((0, $5bCKL.CustomerStoriesSection), {
                        totalNumberOfCustomerStories: numberOfCustomerStories,
                        customerStoryList: customerStoryList === null || customerStoryList === void 0 ? void 0 : customerStoryList.slice(0, numberOfVisibleStories),
                        fallbackCustomerStoryList: fallbackCustomerStoryList,
                        filterSearchHasRun: filterSearchhasRun,
                        loadMoreStories: loadMoreStories
                    }),
                    /*#__PURE__*/ (0, $dypTs.jsx)((0, $03nan.GlobalStatsSection), {}),
                    /*#__PURE__*/ (0, $dypTs.jsx)((0, $lksJ1.FutureOfTeamwork), {})
                ]
            }),
            /*#__PURE__*/ (0, $dypTs.jsx)((0, $8LaTa.GlobalFooter), {})
        ]
    });
};
const $2ac8f5f1195b6d64$var$getFilterByEnterpriseParam = ()=>{
    const { searchParams: searchParams } = new URL(window.location.href);
    const enterpriseParam = searchParams.get("filterByEnterprise");
    return enterpriseParam === "true";
};

});
parcelRegister("90Lnj", function(module, exports) {
$parcel$export(module.exports, "CarouselSection", function () { return (parcelRequire("h8xfN")).CarouselSection; });
$parcel$export(module.exports, "CustomerStoriesSection", function () { return (parcelRequire("5bCKL")).CustomerStoriesSection; });
$parcel$export(module.exports, "CustomerStoryFilters", function () { return (parcelRequire("9K8X0")).CustomerStoryFilters; });
$parcel$export(module.exports, "GlobalStatsSection", function () { return (parcelRequire("03nan")).GlobalStatsSection; });
$parcel$export(module.exports, "FutureOfTeamwork", function () { return (parcelRequire("lksJ1")).FutureOfTeamwork; });
parcelRequire("h8xfN");
parcelRequire("i0sZk");
parcelRequire("5bCKL");
parcelRequire("9K8X0");
parcelRequire("03nan");
parcelRequire("lksJ1");

});
parcelRegister("h8xfN", function(module, exports) {
$parcel$export(module.exports, "CarouselSection", function () { return $7494b97c76b7cdcf$export$5edf3752a9da9c72; });
/* carousel-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");
parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $kooLp = parcelRequire("kooLp");

var $jMhSx = parcelRequire("jMhSx");

var $7rz8I = parcelRequire("7rz8I");

var $dweoU = parcelRequire("dweoU");
const $7494b97c76b7cdcf$export$5edf3752a9da9c72 = ()=>{
    return /*#__PURE__*/ (0, $dypTs.jsxs)((0, $bQjAr.default), {
        name: "customers-page-testimonial",
        children: [
            /*#__PURE__*/ (0, $dypTs.jsxs)((0, $jMhSx.Row), {
                layout: "8-4",
                children: [
                    /*#__PURE__*/ (0, $dypTs.jsx)("h1", {
                        className: (0, $2jatx.default)([
                            "_1kd31nn1"
                        ]),
                        children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $iVyKn.default), {
                            id: "CustomersLandingPage.CustomerStoriesCarouselSection.header",
                            values: {
                                span: (chunks)=>{
                                    return /*#__PURE__*/ (0, $dypTs.jsx)("span", {
                                        children: chunks
                                    });
                                }
                            },
                            defaultMessage: "Customer stories <span>driven by the power of teamwork</span>"
                        })
                    }),
                    /*#__PURE__*/ (0, $dypTs.jsx)((0, $dypTs.Fragment), {})
                ]
            }),
            /*#__PURE__*/ (0, $dypTs.jsx)((0, $7rz8I.ADG4CustomerTestimonials), {
                testimonials: $7494b97c76b7cdcf$var$Testimonials(),
                className: "customer-stories-carousel"
            })
        ]
    });
};
const $7494b97c76b7cdcf$var$h1Styles = null;
const $7494b97c76b7cdcf$var$Testimonials = ()=>{
    const intl = (0, $8e22h.default)();
    const testimonials = [
        {
            eyebrow: "Enterprise",
            name: "Joe Cotant",
            logo: /*#__PURE__*/ (0, $dypTs.jsx)((0, $dweoU.TestimonialRoblox), {}),
            title: intl.formatMessage({
                id: "CustomersLandingPage.testimonial1.title",
                defaultMessage: "Senior Technical Program Manager, Roblox"
            }),
            image: "https://wac-cdn.atlassian.com/misc-assets/webp-images/Robloxcustomerspage-394635826.webp",
            quote: intl.formatMessage({
                id: "CustomersLandingPage.testimonial1.quote",
                defaultMessage: "For the two teams we've already migrated from Wrike to Jira, each of those will amount to $150,000/year in savings."
            }),
            link: {
                text: intl.formatMessage({
                    id: "CustomersLandingPage.testimonial1.link.text",
                    defaultMessage: "Read customer story"
                }),
                url: (0, $kooLp.useLocalizedHref)("/customers/roblox")
            },
            label: "Roblox"
        },
        {
            name: "Wais Mojaddidi",
            logo: /*#__PURE__*/ (0, $dypTs.jsx)((0, $dweoU.TestimonialRoyalCaribbean), {}),
            title: intl.formatMessage({
                id: "CustomersLandingPage.testimonial2.title",
                defaultMessage: "Director of Agile Delivery, Global E-commerce, Royal Caribbean"
            }),
            image: "https://wac-cdn.atlassian.com/misc-assets/webp-images/RoyalCaribbeancustomerspage-711769836.webp",
            quote: intl.formatMessage({
                id: "CustomersLandingPage.testimonial2.quote",
                defaultMessage: "By leveraging Jira and Confluence for automated reporting, we\u2019re saving over 800 hours and $500k per year in management consulting costs."
            }),
            link: {
                text: intl.formatMessage({
                    id: "CustomersLandingPage.testimonial2.link.text",
                    defaultMessage: "Read customer story"
                }),
                url: (0, $kooLp.useLocalizedHref)("/customers/royal-caribbean")
            },
            label: "Royal Caribbean International"
        },
        {
            name: "Mehmet Sari",
            logo: /*#__PURE__*/ (0, $dypTs.jsx)((0, $dweoU.TestimonialMercedesBenz), {}),
            title: intl.formatMessage({
                id: "CustomersLandingPage.testimonial3.title",
                defaultMessage: "Modern Collaboration Platform Team, Mercedes-Benz"
            }),
            image: "https://wac-cdn.atlassian.com/misc-assets/webp-images/MercedesBenzcustomerspage-666640299.webp",
            quote: intl.formatMessage({
                id: "CustomersLandingPage.testimonial3.quote",
                defaultMessage: "With Atlassian cloud, everything regarding server maintenance is done for us, and there\u2019s less downtime and better performance."
            }),
            link: {
                text: intl.formatMessage({
                    id: "CustomersLandingPage.testimonial3.link.text",
                    defaultMessage: "Read customer story"
                }),
                url: (0, $kooLp.useLocalizedHref)("/customers/mercedes-benz")
            },
            label: "Mercedes Benz"
        },
        {
            name: "Stephanie Leue",
            logo: /*#__PURE__*/ (0, $dypTs.jsx)((0, $dweoU.TestimonialDoodle), {}),
            title: intl.formatMessage({
                id: "CustomersLandingPage.testimonial4.title",
                defaultMessage: "Former Chief Product Officer, Doodle"
            }),
            image: "https://wac-cdn.atlassian.com/misc-assets/webp-images/Doodlecustomerspage-541108127.webp",
            quote: intl.formatMessage({
                id: "CustomersLandingPage.testimonial4.quote",
                defaultMessage: "Jira Product Discovery translated our entire process into a highly transparent workflow, connected to the work we were already doing in Jira. That was a mind-blowing moment."
            }),
            link: {
                text: intl.formatMessage({
                    id: "CustomersLandingPage.testimonial4.link.text",
                    defaultMessage: "Read customer story"
                }),
                url: (0, $kooLp.useLocalizedHref)("/customers/doodle")
            },
            label: "Doodle"
        },
        {
            name: "Ryan Mosley",
            logo: /*#__PURE__*/ (0, $dypTs.jsx)((0, $dweoU.TestimonialDHCS), {}),
            title: intl.formatMessage({
                id: "CustomersLandingPage.testimonial5.title",
                defaultMessage: "Chief of Factory & Engineering Modernization, DHCS"
            }),
            image: "https://wac-cdn.atlassian.com/misc-assets/webp-images/DHCScustomerspage-1081811850.webp",
            quote: intl.formatMessage({
                id: "CustomersLandingPage.testimonial5.quote",
                defaultMessage: "By tracking everything in Jira and all of our developer tools, we reduced the cost to get the team set up and deliver the product from $2.8 million to $600,000."
            }),
            link: {
                text: intl.formatMessage({
                    id: "CustomersLandingPage.testimonial5.link.text",
                    defaultMessage: "Read customer story"
                }),
                url: (0, $kooLp.useLocalizedHref)("/customers/dhcs")
            },
            label: "DHCS California Department of Health Care Services"
        }
    ];
    return testimonials;
};

});

parcelRegister("i0sZk", function(module, exports) {
/* cta-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");
parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");

var $kooLp = parcelRequire("kooLp");

var $en8Bw = parcelRequire("en8Bw");
const $6d446c09912dd76e$export$5faac140015d325f = ()=>{
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $en8Bw.Adg4CtaWithArrows), {
        header: /*#__PURE__*/ (0, $dypTs.jsx)((0, $iVyKn.default), {
            id: "CustomersLandingPage.cta.header",
            defaultMessage: "<startWriting>Start writing your <teamWorkStory>teamwork story</teamWorkStory> <gestureLines>today</gestureLines></startWriting>",
            values: {
                startWriting: (str)=>/*#__PURE__*/ (0, $dypTs.jsx)("span", {
                        className: "h1 reduced-font-weight",
                        children: str
                    }),
                teamWorkStory: (str)=>/*#__PURE__*/ (0, $dypTs.jsx)("span", {
                        className: "h1",
                        children: str
                    }),
                gestureLines: (str)=>/*#__PURE__*/ (0, $dypTs.jsxs)("span", {
                        children: [
                            str,
                            /*#__PURE__*/ (0, $dypTs.jsx)("img", {
                                src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/yellow-gestural-lines-2995366884.webp",
                                alt: "",
                                className: (0, $2jatx.default)([
                                    "_kqswstnw _1bsb4bvh _4t3i4bvh _1pfh14id _ahbq14id _1hr21qjk _15951a70 _12rrd4y9 _1vkh14no _1rfmd4y9 _tnru14no"
                                ])
                            })
                        ]
                    })
            }
        }),
        ctaProps: {
            ctaText: /*#__PURE__*/ (0, $dypTs.jsx)((0, $iVyKn.default), {
                id: "CustomersLandingPage.cta.buttonText",
                defaultMessage: "Become an advocate"
            }),
            href: (0, $kooLp.useLocalizedHref)("/advocacy"),
            dataEventProps: {
                "data-event": "clicked",
                "data-event-component": "linkButton",
                "data-event-container": "ctaSection",
                "data-product-key": "customers"
            }
        }
    });
};
const $6d446c09912dd76e$var$customerStoryCTAGestureStyle = null;

});
parcelRegister("en8Bw", function(module, exports) {
$parcel$export(module.exports, "Adg4CtaWithArrows", function () { return $3a3422ff2bda2984$export$23afe6443f3f8d50; });
/* cta-with-arrows.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");
parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");

var $jKShK = parcelRequire("jKShK");

var $5qUgh = parcelRequire("5qUgh");

var $jMhSx = parcelRequire("jMhSx");
const $3a3422ff2bda2984$var$ArrowPencilPointRight = (props)=>{
    return /*#__PURE__*/ (0, $dypTs.jsx)("svg", {
        className: props.className,
        style: {
            color: props.color ? props.color : "currentColor",
            transform: `rotate(${props.rotate ? props.rotate : "0"}deg)`
        },
        width: "72",
        height: "25",
        viewBox: "0 0 72 25",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $dypTs.jsx)("path", {
            d: "M59.9377 15.3992C59.0173 14.9197 58.1224 14.8026 57.2375 14.6506C56.2764 14.4847 55.3298 14.5122 54.3661 14.6939C53.5179 14.8575 52.6572 14.756 51.8548 14.5047C50.3545 14.0308 48.8161 13.9548 47.2581 13.9487C46.2852 13.9435 45.2992 13.8949 44.3421 13.7474C43.6788 13.6425 43.0503 13.3313 42.3766 13.1053C41.985 13.7302 41.3847 13.7038 40.7654 13.4715C39.4868 12.9907 38.1709 12.9018 36.8181 12.9291C36.0821 12.9425 35.3546 12.7709 34.7504 12.2942C34.6729 12.2382 34.5745 12.21 34.4827 12.1765C33.8726 12.7787 33.1602 12.7406 32.4202 12.5737C31.2308 12.3121 30.0329 12.0735 28.8435 11.8119C28.0392 11.6324 27.2369 11.435 26.434 11.2435C25.6375 11.0468 24.8746 10.7635 24.004 10.9669C22.9249 11.2205 21.8431 10.958 20.7692 10.7864C19.5431 10.5869 18.3301 10.2689 17.1034 10.1833C15.0061 10.0312 12.9448 9.66091 10.8685 9.37304C9.87464 9.2337 8.87682 9.12994 7.89344 8.94972C6.89235 8.76766 5.89651 8.53817 4.91509 8.28619C3.86938 8.02152 2.82958 7.7035 1.79371 7.40388C1.12194 7.21408 0.740116 6.67063 0.443572 6.11206C0.359595 5.95341 0.591152 5.53371 0.780077 5.33746C1.3744 4.71561 2.13013 4.41639 2.99148 4.35003C4.92541 4.19732 6.85018 4.28953 8.7651 4.47067C10.4852 4.63154 12.1902 4.92878 13.8886 5.23134C15.8515 5.57338 17.8274 5.79684 19.8165 5.95571C21.368 6.07507 22.9135 6.30175 24.4618 6.45076C25.9089 6.59525 27.3614 6.69231 28.8151 6.83149C30.4224 6.98663 32.0303 7.13584 33.6388 7.3331C35.9198 7.60628 38.1897 7.92627 40.47 8.20538C42.0904 8.40386 43.7114 8.59642 45.3646 8.49847C46.3027 8.4401 47.2618 8.62379 48.1927 8.79256C49.5336 9.03394 50.885 9.07253 52.239 9.14136C53.8902 9.22311 55.5421 9.29894 57.1985 9.38723C57.6735 9.41263 58.1432 9.48547 58.6182 9.51087C58.7481 9.52438 58.8865 9.46081 59.0203 9.43874C58.9685 9.31341 58.9514 9.14372 58.8583 9.06807C58.3052 8.61476 57.7305 8.19518 57.1775 7.74187C55.7106 6.53386 54.2437 5.32585 52.784 4.1066C52.2211 3.63427 51.8989 2.98308 51.5571 2.34784C51.3492 1.9604 51.5341 1.63781 51.7218 1.34547C51.9021 1.06438 52.0235 0.669208 52.4453 0.635111C52.7346 0.611222 53.0239 0.587334 53.3159 0.593703C54.7643 0.618392 56.0541 1.16031 57.3235 1.77807C58.2302 2.22017 59.1204 2.70255 60.0415 3.12217C60.4279 3.30028 60.6627 3.55259 60.8241 3.92919C60.9383 4.19293 61.0275 4.52005 61.4388 4.203C61.6212 4.06605 61.8429 4.11309 62.0102 4.32839C62.2563 4.64183 62.5469 4.92992 62.7922 5.24929C62.9589 5.47051 63.1498 5.52635 63.422 5.54866C64.448 5.61337 65.2517 6.12273 65.8284 6.95631C66.199 7.4926 66.6963 7.85616 67.2599 8.10666C67.9146 8.39663 68.5004 8.76939 68.9623 9.29118C69.8119 10.2491 70.6155 11.2442 71.4126 12.2446C71.7531 12.6758 71.6567 13.4934 71.2651 13.9024C70.5625 14.639 69.8337 15.3428 69.1476 16.093C68.7802 16.4986 68.4883 16.978 68.1472 17.4163C68.0081 17.5937 67.8625 17.8305 67.6703 17.8944C66.9192 18.1522 66.4311 18.7311 65.8676 19.2362C65.6354 19.4459 65.3887 19.6782 65.1073 19.7928C64.1935 20.1716 63.2705 20.5253 62.3343 20.8358C62.0614 20.9274 61.7282 20.8087 61.4231 20.813C61.2854 20.8167 61.0794 20.8432 61.0217 20.9332C60.5146 21.738 59.7602 22.1333 58.8588 22.1835C57.4825 22.2623 56.1856 22.7031 54.8565 23.0027C53.3253 23.3472 51.7949 23.6858 50.267 24.0547C49.0888 24.34 47.9008 24.4443 46.6976 24.4151C46.1853 24.4038 45.8133 24.1493 45.6316 23.7406C45.2412 22.8424 45.1435 22.8622 45.7706 22.0519C45.8893 21.8963 46.0244 21.7544 46.1209 21.5846C46.4935 20.9157 47.1521 20.7922 47.8029 20.5781C48.9181 20.2143 50.011 19.7822 51.0986 19.3436C52.5241 18.7662 53.93 18.1508 55.345 17.5603C56.1092 17.2379 56.8866 16.959 57.6358 16.6111C58.3849 16.2632 59.1046 15.8583 59.9219 15.4335L59.9377 15.3992Z",
            fill: "currentColor"
        })
    });
};
const $3a3422ff2bda2984$var$ArrowPencilPointLeft = (props)=>{
    return /*#__PURE__*/ (0, $dypTs.jsx)("svg", {
        className: props.className,
        style: {
            color: props.color ? props.color : "currentColor",
            transform: `rotate(${props.rotate ? props.rotate : "0"}deg)`
        },
        width: "72",
        height: "24",
        viewBox: "0 0 72 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $dypTs.jsx)("path", {
            d: "M11.9227 9.89136C12.8559 10.3198 13.7536 10.3994 14.6425 10.5132C15.6079 10.6375 16.5536 10.5757 17.5121 10.3645C18.3557 10.175 19.219 10.2409 20.0279 10.4536C21.5408 10.855 23.0808 10.8711 24.6387 10.819C25.6115 10.7878 26.5986 10.7979 27.5595 10.9047C28.2255 10.9812 28.8622 11.2582 29.5419 11.4511C29.9165 10.8335 30.5174 10.8367 31.1428 11.0378C32.4341 11.4541 33.7522 11.4909 35.1039 11.4143C35.8394 11.3739 36.5714 11.5124 37.1884 11.9499C37.2673 12.001 37.3665 12.0246 37.4592 12.0536C38.0528 11.4497 38.7662 11.46 39.5105 11.5935C40.7067 11.8016 41.9108 11.9872 43.107 12.1954C43.9159 12.3387 44.7234 12.4993 45.5314 12.6542C46.3329 12.8144 47.1034 13.0593 47.9682 12.8307C49.0403 12.5458 50.1289 12.7587 51.2072 12.8844C52.4385 13.0312 53.6598 13.293 54.8886 13.3299C56.9895 13.3986 59.0603 13.6792 61.1439 13.8797C62.1414 13.9771 63.1418 14.0401 64.1298 14.1774C65.1356 14.3158 66.1374 14.5002 67.1254 14.7068C68.1781 14.9233 69.2262 15.1914 70.27 15.442C70.9467 15.6001 71.3431 16.1103 71.6547 16.6383C71.743 16.7882 71.5228 17.2018 71.3392 17.3982C70.7618 18.0204 70.0144 18.3373 69.155 18.4334C67.2256 18.6528 65.2988 18.6354 63.3794 18.5319C61.6553 18.4407 59.9427 18.2174 58.2364 17.9886C56.2648 17.7317 54.2832 17.5896 52.2903 17.5103C50.7359 17.4529 49.1846 17.2917 47.6327 17.2056C46.1819 17.12 44.7272 17.0804 43.27 17.0002C41.6589 16.9103 40.0473 16.8262 38.4337 16.6958C36.1459 16.5171 33.8679 16.2928 31.5805 16.1083C29.9551 15.9771 28.3292 15.8517 26.6791 16.0077C25.7428 16.099 24.7789 15.9574 23.8437 15.8292C22.4965 15.6462 21.1444 15.6593 19.7888 15.6433C18.1357 15.6259 16.4822 15.6142 14.8237 15.5907C14.3482 15.5838 13.8766 15.531 13.4011 15.5242C13.2708 15.516 13.1342 15.5825 13.001 15.6088C13.0562 15.7278 13.0778 15.8909 13.173 15.9604C13.7382 16.3773 14.3241 16.7607 14.8892 17.1776C16.3885 18.2886 17.8877 19.3997 19.38 20.5219C19.9556 20.9567 20.2952 21.5731 20.6541 22.1733C20.8725 22.5395 20.6963 22.8576 20.5166 23.1467C20.3439 23.4247 20.2332 23.8105 19.8124 23.8591C19.5238 23.8929 19.2352 23.9268 18.9432 23.9315C17.4944 23.9616 16.1902 23.4867 14.9044 22.9378C13.986 22.545 13.0829 22.1126 12.1507 21.742C11.7596 21.5845 11.518 21.3498 11.3464 20.9924C11.2252 20.7421 11.1271 20.4298 10.7245 20.7511C10.5458 20.89 10.3229 20.8529 10.1498 20.6513C9.89537 20.358 9.59702 20.0909 9.34308 19.7918C9.1705 19.5846 8.97812 19.5378 8.70533 19.5264C7.67779 19.5021 6.86056 19.0405 6.26148 18.2576C5.87639 17.7539 5.3694 17.4216 4.79922 17.2009C4.13681 16.9455 3.54102 16.6076 3.06516 16.1213C2.18987 15.2285 1.35949 14.2982 0.535518 13.3625C0.183447 12.9591 0.257735 12.1666 0.638219 11.7573C1.32072 11.0204 2.03035 10.3142 2.69609 9.56467C3.0524 9.15964 3.33129 8.68618 3.66048 8.25055C3.79472 8.07415 3.93392 7.8403 4.12436 7.77141C4.86836 7.49476 5.34066 6.91795 5.89038 6.40956C6.11689 6.19853 6.35721 5.96526 6.63547 5.84414C7.53885 5.44466 8.45209 5.06891 9.37962 4.73449C9.64998 4.63598 9.98638 4.73803 10.2912 4.72256C10.4289 4.7139 10.6341 4.68061 10.6894 4.59166C11.1746 3.79615 11.9181 3.38661 12.818 3.30462C14.1919 3.17737 15.4766 2.7037 16.7973 2.36515C18.3188 1.9757 19.8398 1.59199 21.3573 1.17919C22.5275 0.860049 23.7125 0.715138 24.9162 0.698488C25.4287 0.690319 25.8075 0.922123 26.0002 1.30974C26.4148 2.16189 26.512 2.13913 25.9069 2.94442C25.7924 3.09896 25.6611 3.24088 25.5693 3.4084C25.2149 4.06773 24.5597 4.21134 23.9149 4.44224C22.8097 4.8348 21.7288 5.29241 20.6532 5.75615C19.2436 6.36638 17.8547 7.01257 16.456 7.63504C15.7006 7.97452 14.9309 8.27266 14.1914 8.63624C13.4518 8.99982 12.7432 9.41734 11.9375 9.85763L11.9227 9.89136Z",
            fill: "currentColor"
        })
    });
};
const $3a3422ff2bda2984$export$23afe6443f3f8d50 = ({ header: header, paragraph: paragraph, ctaProps: ctaProps })=>{
    const { ref: scrollRef, inView: sectionIsVisible } = (0, $jKShK.useInView)();
    const noParagraphSpacing = !paragraph ? "var(--ds-space-400, 32px)" : "var(--ds-space-200, 16px)";
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $jMhSx.TypographyStyles), {
        children: /*#__PURE__*/ (0, $dypTs.jsxs)("section", {
            ref: scrollRef,
            className: (0, $2jatx.default)([
                "_kqswh2mm _1reo15vq _18m915vq _y3gn1h6o _ca0q53f4 _u5f3idpf _n3td53f4 _19bvidpf _1e0c1txw _1n261g80 _f5vqudic _zci31l2x _1t48oqhq _1n4lnrqp _zzvs5wpz _1azozpb8 _apb77mmw _1uezt77u _17nbrleh _txzv1cbv _9ptdmgh4 _12bi1mht _qcpm6o8t _fdgfstnw _t9uvidpf _1vllidpf _iejih2mm _1mwq1ssb _lt79p2n4 _5gswidpf _s3i1idpf _4qqm1u1b _14y8idpf _1bcxjyd4 _1y27zk8b _k98bidpf _1nspidpf _5vlustnw _ncds12o8 _ekvjkb7n _1ljpq7pw _1nt81hy9 _1mon1osq _jw8hpxbi _1aynxy5q _2trp1nn1",
                sectionIsVisible ? "is-visible" : ""
            ]),
            children: [
                /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
                    className: "arrows arrows-left",
                    children: [
                        /*#__PURE__*/ (0, $dypTs.jsx)($3a3422ff2bda2984$var$ArrowPencilPointRight, {
                            className: "arrow1",
                            rotate: 10,
                            color: "1868DB"
                        }),
                        /*#__PURE__*/ (0, $dypTs.jsx)($3a3422ff2bda2984$var$ArrowPencilPointRight, {
                            className: "arrow2",
                            rotate: 8,
                            color: "BC5DF2"
                        }),
                        /*#__PURE__*/ (0, $dypTs.jsx)($3a3422ff2bda2984$var$ArrowPencilPointRight, {
                            className: "arrow3",
                            rotate: -6,
                            color: "101214"
                        }),
                        /*#__PURE__*/ (0, $dypTs.jsx)($3a3422ff2bda2984$var$ArrowPencilPointRight, {
                            className: "arrow4",
                            rotate: -13,
                            color: "101214"
                        }),
                        /*#__PURE__*/ (0, $dypTs.jsx)($3a3422ff2bda2984$var$ArrowPencilPointRight, {
                            className: "arrow5",
                            rotate: -15,
                            color: "FFA900"
                        }),
                        /*#__PURE__*/ (0, $dypTs.jsx)($3a3422ff2bda2984$var$ArrowPencilPointRight, {
                            className: "arrow6",
                            rotate: -15,
                            color: "1868DB"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
                    className: "arrows arrows-right",
                    children: [
                        /*#__PURE__*/ (0, $dypTs.jsx)($3a3422ff2bda2984$var$ArrowPencilPointLeft, {
                            className: "arrow7",
                            rotate: -10,
                            color: "101214"
                        }),
                        /*#__PURE__*/ (0, $dypTs.jsx)($3a3422ff2bda2984$var$ArrowPencilPointLeft, {
                            className: "arrow8",
                            rotate: -20,
                            color: "1868DB"
                        }),
                        /*#__PURE__*/ (0, $dypTs.jsx)($3a3422ff2bda2984$var$ArrowPencilPointLeft, {
                            className: "arrow9",
                            rotate: 5,
                            color: "82B536"
                        }),
                        /*#__PURE__*/ (0, $dypTs.jsx)($3a3422ff2bda2984$var$ArrowPencilPointLeft, {
                            className: "arrow10",
                            rotate: 5,
                            color: "1868DB"
                        }),
                        /*#__PURE__*/ (0, $dypTs.jsx)($3a3422ff2bda2984$var$ArrowPencilPointLeft, {
                            className: "arrow11",
                            rotate: 10,
                            color: "FFA900"
                        }),
                        /*#__PURE__*/ (0, $dypTs.jsx)($3a3422ff2bda2984$var$ArrowPencilPointLeft, {
                            className: "arrow12",
                            rotate: 10,
                            color: "101214"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $dypTs.jsx)((0, $jMhSx.Row), {
                    layout: "8",
                    children: /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
                        className: "row-width",
                        children: [
                            /*#__PURE__*/ (0, $dypTs.jsx)("h2", {
                                style: {
                                    marginBottom: noParagraphSpacing
                                },
                                children: header
                            }),
                            paragraph && /*#__PURE__*/ (0, $dypTs.jsx)((0, $jMhSx.Row), {
                                layout: "8",
                                children: /*#__PURE__*/ (0, $dypTs.jsx)("p", {
                                    className: ".body-lg",
                                    children: paragraph
                                })
                            }),
                            /*#__PURE__*/ (0, $dypTs.jsx)((0, $5qUgh.Adg4Button), {
                                variant: "secondary",
                                color: "black",
                                href: ctaProps.href,
                                dataEventProps: ctaProps.dataEventProps,
                                children: ctaProps.ctaText
                            })
                        ]
                    })
                })
            ]
        })
    });
};
const $3a3422ff2bda2984$var$ctaStyles = null;

});


parcelRegister("5bCKL", function(module, exports) {
$parcel$export(module.exports, "CustomerStoriesSection", function () { return $e854fc08d1c2ace6$export$48ea351ea7a5a012; });
/* customer-stories.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");

var $gljCV = parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $7qFQI = parcelRequire("7qFQI");

var $5qUgh = parcelRequire("5qUgh");

var $jMhSx = parcelRequire("jMhSx");
parcelRequire("6YEiI");
var $2Z9hF = parcelRequire("2Z9hF");
var $fnda5 = parcelRequire("fnda5");
parcelRequire("gD5LF");
var $hBvFS = parcelRequire("hBvFS");
const $e854fc08d1c2ace6$export$48ea351ea7a5a012 = ({ totalNumberOfCustomerStories: totalNumberOfCustomerStories, customerStoryList: customerStoryList, fallbackCustomerStoryList: fallbackCustomerStoryList, filterSearchHasRun: filterSearchHasRun, loadMoreStories: loadMoreStories })=>{
    const intl = (0, $8e22h.default)();
    const [numStories, setNumStories] = (0, $gljCV.useState)(0);
    const { width: width } = (0, $hBvFS.useWindowDimensions)();
    const numColumns = (0, $hBvFS.getNumberOfCustomerStoryColumns)(width);
    let storyGrid = (0, $gljCV.useMemo)(()=>{
        return {};
    }, []);
    storyGrid = (0, $gljCV.useMemo)(()=>{
        if (numStories !== customerStoryList.length) setNumStories(customerStoryList.length);
        // if the number of columns has changed, re-sort the stories
        if (numColumns !== Object.keys(storyGrid).length) return (0, $hBvFS.sortStoriesByHeight)(storyGrid, customerStoryList.slice(0, numStories), numColumns);
        else return (0, $hBvFS.sortStoriesByHeight)(storyGrid, customerStoryList.slice(0, customerStoryList.length), numColumns);
        return storyGrid;
    }, [
        numStories,
        storyGrid,
        customerStoryList,
        numColumns
    ]);
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $bQjAr.default), {
        name: "customers-page-stories-grid",
        children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $jMhSx.TypographyStyles), {
            children: /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_6rth12bs"
                ]),
                children: [
                    customerStoryList.length === 0 && filterSearchHasRun ? /*#__PURE__*/ (0, $dypTs.jsx)((0, $fnda5.CustomerStoryNoResultsFallback), {
                        numColumns: numColumns,
                        fallbackCustomerStories: fallbackCustomerStoryList
                    }) : customerStoryList.length === 0 && !filterSearchHasRun ? /*#__PURE__*/ (0, $dypTs.jsx)((0, $jMhSx.Row), {
                        layout: "12",
                        children: /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _1bah1h6o _4cvr1y6m _1pfh1lit _4t3i1us8"
                            ]),
                            children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $7qFQI.default), {
                                size: "xlarge"
                            })
                        })
                    }) : /*#__PURE__*/ (0, $dypTs.jsx)((0, $2Z9hF.CustomerStoriesGrid), {
                        numColumns: numColumns,
                        storiesGrid: storyGrid
                    }),
                    numStories !== 0 && numStories < totalNumberOfCustomerStories && /*#__PURE__*/ (0, $dypTs.jsx)((0, $jMhSx.Row), {
                        layout: "12",
                        children: /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_19pkzwfg _2hwx1wug _otyridpf _18u01wug _1e0c1txw _1n261g80 _2lx21bp4 _1bah1h6o _4cvr1h6o"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $dypTs.jsx)("p", {
                                    children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $iVyKn.default), {
                                        id: "CustomersLandingPage.showingListOfStories",
                                        defaultMessage: "Showing <numberOfCustomerStories></numberOfCustomerStories> of <totalNumberOfCustomerStories></totalNumberOfCustomerStories> stories",
                                        values: {
                                            numberOfCustomerStories: ()=>customerStoryList.length,
                                            totalNumberOfCustomerStories: ()=>totalNumberOfCustomerStories
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, $dypTs.jsx)((0, $5qUgh.Adg4Button), {
                                    variant: "secondary",
                                    color: "black",
                                    onClick: loadMoreStories,
                                    dataEventProps: {
                                        "data-event": "clicked",
                                        "data-event-component": "button",
                                        "data-event-container": "customerStorySection",
                                        "data-product-key": "customers",
                                        "data-label-english": "Load more stories"
                                    },
                                    children: intl.formatMessage({
                                        id: "CustomersLandingPage.loadMoreStories",
                                        defaultMessage: "Load more stories"
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
const $e854fc08d1c2ace6$var$customerStoryContainerStyles = null;
const $e854fc08d1c2ace6$var$spinnerStyles = null;
const $e854fc08d1c2ace6$var$loadMoreStyles = null;

});
parcelRegister("6YEiI", function(module, exports) {
$parcel$export(module.exports, "CustomerStoryFilterSliderFilter", function () { return (parcelRequire("e6w9W")).CustomerStoryFilterSliderFilter; });
$parcel$export(module.exports, "CustomerStoriesGrid", function () { return (parcelRequire("2Z9hF")).CustomerStoriesGrid; });
$parcel$export(module.exports, "CustomerStoryCard", function () { return (parcelRequire("d1ibd")).CustomerStoryCard; });
$parcel$export(module.exports, "CustomerStoryFilterModalBasic", function () { return (parcelRequire("WxMqy")).CustomerStoryFilterModalBasic; });
$parcel$export(module.exports, "CustomerStoryFilterModalComplex", function () { return (parcelRequire("bk5Uk")).CustomerStoryFilterModalComplex; });
$parcel$export(module.exports, "CustomerStoryFilterModalComplexGrouping", function () { return (parcelRequire("cL5ak")).CustomerStoryFilterModalComplexGrouping; });
$parcel$export(module.exports, "CustomerStoryFilterModalRadioButton", function () { return (parcelRequire("cL5ak")).CustomerStoryFilterModalRadioButton; });
$parcel$export(module.exports, "CustomerStoryNoResultsFallback", function () { return (parcelRequire("fnda5")).CustomerStoryNoResultsFallback; });
$parcel$export(module.exports, "CustomerStorySearchBar", function () { return (parcelRequire("3614I")).CustomerStorySearchBar; });
$parcel$export(module.exports, "SearchButton", function () { return (parcelRequire("4aLWG")).SearchButton; });
$parcel$export(module.exports, "SearchCloseButton", function () { return (parcelRequire("1nITY")).SearchCloseButton; });
parcelRequire("e6w9W");
parcelRequire("2Z9hF");
parcelRequire("d1ibd");
parcelRequire("WxMqy");
parcelRequire("bk5Uk");
parcelRequire("cL5ak");
parcelRequire("fnda5");
parcelRequire("3614I");
parcelRequire("4aLWG");
parcelRequire("1nITY");

});
parcelRegister("e6w9W", function(module, exports) {
$parcel$export(module.exports, "CustomerStoryFilterSliderFilter", function () { return $eb64fda03a5fb4a6$export$4555d391c790a08; });

var $dypTs = parcelRequire("dypTs");
parcelRequire("gD5LF");
var $7u2YB = parcelRequire("7u2YB");
const $eb64fda03a5fb4a6$export$4555d391c790a08 = ({ subFilterName: subFilterName, subFilterDescription: subFilterDescription, active: active, updateFilterObject: updateFilterObject })=>{
    const localizedMap = (0, $7u2YB.LocalizedFilterOptions)();
    const optionId = `filter-checkbox-${subFilterName.replace(/\s/g, "")}`;
    return /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
        className: "filter-slider-button-container",
        children: [
            /*#__PURE__*/ (0, $dypTs.jsx)("h4", {
                children: localizedMap[subFilterName]
            }),
            /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
                className: "filter-slider-content",
                children: [
                    /*#__PURE__*/ (0, $dypTs.jsx)("p", {
                        children: localizedMap[subFilterDescription]
                    }),
                    /*#__PURE__*/ (0, $dypTs.jsxs)("label", {
                        className: "switch",
                        htmlFor: optionId,
                        children: [
                            /*#__PURE__*/ (0, $dypTs.jsx)("input", {
                                type: "checkbox",
                                id: optionId,
                                checked: active,
                                onClick: ()=>updateFilterObject(subFilterName)
                            }),
                            /*#__PURE__*/ (0, $dypTs.jsx)("span", {
                                className: "slider round"
                            })
                        ]
                    })
                ]
            })
        ]
    }, subFilterName);
};

});
parcelRegister("gD5LF", function(module, exports) {
$parcel$export(module.exports, "filterCustomerStories", function () { return (parcelRequire("6eXit")).filterCustomerStories; });
$parcel$export(module.exports, "defaultCustomerStoryFilterOptionsObject", function () { return (parcelRequire("1ODGq")).defaultCustomerStoryFilterOptionsObject; });
$parcel$export(module.exports, "areFiltersAreActive", function () { return (parcelRequire("hBvFS")).areFiltersAreActive; });
$parcel$export(module.exports, "commitAllStagedActiveValues", function () { return (parcelRequire("hBvFS")).commitAllStagedActiveValues; });
$parcel$export(module.exports, "getActiveFiltersByFilterType", function () { return (parcelRequire("hBvFS")).getActiveFiltersByFilterType; });
$parcel$export(module.exports, "getFilterEventProps", function () { return (parcelRequire("hBvFS")).getFilterEventProps; });
$parcel$export(module.exports, "getFilterOptions", function () { return (parcelRequire("hBvFS")).getFilterOptions; });
$parcel$export(module.exports, "getNumberOfCustomerStoryColumns", function () { return (parcelRequire("hBvFS")).getNumberOfCustomerStoryColumns; });
$parcel$export(module.exports, "handleFallbackCustomerStories", function () { return (parcelRequire("hBvFS")).handleFallbackCustomerStories; });
$parcel$export(module.exports, "isContentPlatformFacetAvailable", function () { return (parcelRequire("hBvFS")).isContentPlatformFacetAvailable; });
$parcel$export(module.exports, "resetAllStagedActiveToCommittedActiveValue", function () { return (parcelRequire("hBvFS")).resetAllStagedActiveToCommittedActiveValue; });
$parcel$export(module.exports, "setAllStagedActiveToFalse", function () { return (parcelRequire("hBvFS")).setAllStagedActiveToFalse; });
$parcel$export(module.exports, "sortStoriesByHeight", function () { return (parcelRequire("hBvFS")).sortStoriesByHeight; });
$parcel$export(module.exports, "useWindowDimensions", function () { return (parcelRequire("hBvFS")).useWindowDimensions; });
$parcel$export(module.exports, "LocalizedFilterOptions", function () { return (parcelRequire("7u2YB")).LocalizedFilterOptions; });
parcelRequire("6eXit");
parcelRequire("1ODGq");
parcelRequire("hBvFS");
parcelRequire("7u2YB");
parcelRequire("fcMpu");

});
parcelRegister("6eXit", function(module, exports) {
$parcel$export(module.exports, "filterCustomerStories", function () { return $76b954c90d421ba3$export$e00c2f7823dc318c; });
const $76b954c90d421ba3$export$e00c2f7823dc318c = (results, filters, committedState)=>{
    var _filters_morefilters_Marketplaceapps, _filters_morefilters_Solutionpartner;
    const filteredProducts = Object.entries(filters.product).reduce((acc, [subFilterName, subFilterObject])=>{
        if (subFilterObject[committedState]) acc.push(subFilterName);
        return acc;
    }, []);
    const filteredIndustries = Object.entries(filters.industry).reduce((acc, [subFilterName, subFilterObject])=>{
        if (subFilterObject[committedState]) acc.push(subFilterName);
        return acc;
    }, []);
    const filteredSolutions = Object.entries(filters.solution).reduce((acc, [subFilterName, subFilterObject])=>{
        if (subFilterObject[committedState]) acc.push(subFilterName);
        return acc;
    }, []);
    const filteredRegions = Object.entries(filters["more filters"]).reduce((acc, [subFilterName, subFilterObject])=>{
        if (subFilterObject.grouping === "region") {
            if (subFilterObject[committedState]) acc.push(subFilterName);
        }
        return acc;
    }, []);
    const filteredTeamSize = Object.entries(filters["more filters"]).reduce((acc, [subFilterName, subFilterObject])=>{
        if (subFilterObject.grouping === "team size") {
            if (subFilterObject[committedState]) acc.push(subFilterName);
        }
        return acc;
    }, []);
    const filteredMarketplaceApps = (_filters_morefilters_Marketplaceapps = filters["more filters"]["Marketplace apps"]) === null || _filters_morefilters_Marketplaceapps === void 0 ? void 0 : _filters_morefilters_Marketplaceapps[committedState];
    const filteredSolutionPartner = (_filters_morefilters_Solutionpartner = filters["more filters"]["Solution partner"]) === null || _filters_morefilters_Solutionpartner === void 0 ? void 0 : _filters_morefilters_Solutionpartner[committedState];
    const filterByCategory = (selectedCategoryValues, customerValues = [])=>{
        if (selectedCategoryValues.length > 0) {
            if ((customerValues === null || customerValues === void 0 ? void 0 : customerValues.length) > 0) {
                // Include if filter is applied and this company has that industry
                if (selectedCategoryValues.filter((selected)=>{
                    return customerValues.includes(selected);
                }).length > 0) return true;
            }
            // Remove this item if there is a filter applied but this customer does not have the appropriate value
            return false;
        }
        // Include all items if no filter has been requested
        return true;
    };
    const includeIfExists = (isEnabled = false, customerValues = [])=>{
        if (isEnabled) return (customerValues === null || customerValues === void 0 ? void 0 : customerValues.length) > 0;
        return true;
    };
    const filteredResults = results === null || results === void 0 ? void 0 : results.filter((customerStory)=>{
        var _customerStory_customerCompany_industry, _customerStory_customerCompany;
        return filterByCategory(filteredIndustries, (_customerStory_customerCompany = customerStory.customerCompany) === null || _customerStory_customerCompany === void 0 ? void 0 : (_customerStory_customerCompany_industry = _customerStory_customerCompany.industry) === null || _customerStory_customerCompany_industry === void 0 ? void 0 : _customerStory_customerCompany_industry.map((industry)=>{
            var _industry_name;
            return (_industry_name = industry.name) !== null && _industry_name !== void 0 ? _industry_name : "";
        }));
    }).filter((customerStory)=>{
        var _customerStory_products;
        return filterByCategory(filteredProducts, (_customerStory_products = customerStory.products) === null || _customerStory_products === void 0 ? void 0 : _customerStory_products.map((product)=>{
            var _product_name;
            return (_product_name = product.name) !== null && _product_name !== void 0 ? _product_name : "";
        }));
    }).filter((customerStory)=>{
        var _customerStory_solutions;
        return filterByCategory(filteredSolutions, (_customerStory_solutions = customerStory.solutions) === null || _customerStory_solutions === void 0 ? void 0 : _customerStory_solutions.map((solution)=>{
            var _solution_name;
            return (_solution_name = solution.name) !== null && _solution_name !== void 0 ? _solution_name : "";
        }));
    }).filter((customerStory)=>{
        var _customerStory_customerCompany_region, _customerStory_customerCompany;
        var _customerStory_customerCompany_region_name;
        return filterByCategory(filteredRegions, [
            (_customerStory_customerCompany_region_name = (_customerStory_customerCompany = customerStory.customerCompany) === null || _customerStory_customerCompany === void 0 ? void 0 : (_customerStory_customerCompany_region = _customerStory_customerCompany.region) === null || _customerStory_customerCompany_region === void 0 ? void 0 : _customerStory_customerCompany_region.name) !== null && _customerStory_customerCompany_region_name !== void 0 ? _customerStory_customerCompany_region_name : ""
        ]);
    }).filter((customerStory)=>{
        var _customerStory_customerCompany_organizationSize, _customerStory_customerCompany;
        var _customerStory_customerCompany_organizationSize_name;
        return filterByCategory(filteredTeamSize, [
            (_customerStory_customerCompany_organizationSize_name = (_customerStory_customerCompany = customerStory.customerCompany) === null || _customerStory_customerCompany === void 0 ? void 0 : (_customerStory_customerCompany_organizationSize = _customerStory_customerCompany.organizationSize) === null || _customerStory_customerCompany_organizationSize === void 0 ? void 0 : _customerStory_customerCompany_organizationSize.name) !== null && _customerStory_customerCompany_organizationSize_name !== void 0 ? _customerStory_customerCompany_organizationSize_name : ""
        ]);
    }).filter((customerStory)=>{
        var _customerStory_marketplaceApps;
        return includeIfExists(filteredMarketplaceApps, (_customerStory_marketplaceApps = customerStory.marketplaceApps) === null || _customerStory_marketplaceApps === void 0 ? void 0 : _customerStory_marketplaceApps.map((app)=>{
            var _app_name;
            return (_app_name = app.name) !== null && _app_name !== void 0 ? _app_name : "";
        }));
    }).filter((customerStory)=>{
        var _customerStory_solutionPartners;
        return includeIfExists(filteredSolutionPartner, (_customerStory_solutionPartners = customerStory.solutionPartners) === null || _customerStory_solutionPartners === void 0 ? void 0 : _customerStory_solutionPartners.map((partner)=>{
            var _partner_name;
            return (_partner_name = partner.name) !== null && _partner_name !== void 0 ? _partner_name : "";
        }));
    });
    return filteredResults;
};

});

parcelRegister("1ODGq", function(module, exports) {
$parcel$export(module.exports, "defaultCustomerStoryFilterOptionsObject", function () { return $6096117624169b39$export$6f0fff8c0ca899ac; });
const $6096117624169b39$export$6f0fff8c0ca899ac = {
    "solution": {
    },
    "product": {
    },
    "industry": {
    },
    "more filters": {
        "Marketplace apps": {
            committedActive: false,
            stagedActive: false,
            description: "Only show stories from customers that use marketplace apps"
        },
        "Solution partner": {
            committedActive: false,
            stagedActive: false,
            description: "Only show stories from customers that have a solution partner"
        }
    }
};

});

parcelRegister("hBvFS", function(module, exports) {
$parcel$export(module.exports, "areFiltersAreActive", function () { return $3baf5d614699af5f$export$caf5989571fe03fd; });
$parcel$export(module.exports, "commitAllStagedActiveValues", function () { return $3baf5d614699af5f$export$995b34954b6e3c5d; });
$parcel$export(module.exports, "setAllStagedActiveToFalse", function () { return $3baf5d614699af5f$export$32ef36095a2643ff; });
$parcel$export(module.exports, "resetAllStagedActiveToCommittedActiveValue", function () { return $3baf5d614699af5f$export$6e8eccaa2da87c2a; });
$parcel$export(module.exports, "getActiveFiltersByFilterType", function () { return $3baf5d614699af5f$export$5c95673afb2371b8; });
$parcel$export(module.exports, "handleFallbackCustomerStories", function () { return $3baf5d614699af5f$export$bb39b836f537201; });
$parcel$export(module.exports, "sortStoriesByHeight", function () { return $3baf5d614699af5f$export$bf9342a233bd676b; });
$parcel$export(module.exports, "getNumberOfCustomerStoryColumns", function () { return $3baf5d614699af5f$export$65d9e924579f6503; });
$parcel$export(module.exports, "useWindowDimensions", function () { return $3baf5d614699af5f$export$f715c0e61b2c1a36; });
$parcel$export(module.exports, "isContentPlatformFacetAvailable", function () { return $3baf5d614699af5f$export$f2735cb33092c31f; });
$parcel$export(module.exports, "getFilterOptions", function () { return $3baf5d614699af5f$export$8ba04a2269d8d395; });
$parcel$export(module.exports, "getFilterEventProps", function () { return $3baf5d614699af5f$export$c09429083a9f1f77; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $gljCV = parcelRequire("gljCV");
const $3baf5d614699af5f$var$sizeMap = {
    lg: 4,
    md: 3,
    sm: 2
};
const $3baf5d614699af5f$export$caf5989571fe03fd = (filterObject)=>{
    let isActive = false;
    const filterCategories = Object.values(filterObject);
    let i = 0;
    while(!isActive && i < filterCategories.length){
        const filterCategoryValues = filterCategories[i];
        let j = 0;
        while(!isActive && j < Object.values(filterCategoryValues).length){
            const subFilterObject = Object.values(filterCategoryValues)[j];
            if (subFilterObject["committedActive"]) isActive = true;
            j++;
        }
        i++;
    }
    return isActive;
};
const $3baf5d614699af5f$export$995b34954b6e3c5d = (prevState)=>{
    return Object.keys(prevState).reduce((acc, filterCategory)=>{
        acc[filterCategory] = (0, $6ogO3._)({}, prevState[filterCategory], Object.entries(prevState[filterCategory]).reduce((acc, [filterOptionName, filterOptionValue])=>{
            acc[filterOptionName] = (0, $dPABA._)((0, $6ogO3._)({}, filterOptionValue), {
                committedActive: filterOptionValue.stagedActive
            });
            return acc;
        }, {}));
        return acc;
    }, {});
};
const $3baf5d614699af5f$export$32ef36095a2643ff = (prevState)=>{
    return Object.keys(prevState).reduce((acc, filterCategory)=>{
        acc[filterCategory] = (0, $6ogO3._)({}, prevState[filterCategory], Object.entries(prevState[filterCategory]).reduce((acc, [filterOptionName, filterOptionValue])=>{
            acc[filterOptionName] = (0, $dPABA._)((0, $6ogO3._)({}, filterOptionValue), {
                stagedActive: false
            });
            return acc;
        }, {}));
        return acc;
    }, {});
};
const $3baf5d614699af5f$export$6e8eccaa2da87c2a = (prevState)=>{
    return Object.keys(prevState).reduce((acc, filterCategory)=>{
        acc[filterCategory] = (0, $6ogO3._)({}, prevState[filterCategory], Object.entries(prevState[filterCategory]).reduce((acc, [filterOptionName, filterOptionValue])=>{
            acc[filterOptionName] = (0, $dPABA._)((0, $6ogO3._)({}, filterOptionValue), {
                stagedActive: filterOptionValue.committedActive
            });
            return acc;
        }, {}));
        return acc;
    }, {});
};
const $3baf5d614699af5f$export$b16988f469572eb0 = (event, filter, onClickHandler)=>{
    if (event.key === "Enter") onClickHandler(filter);
};
const $3baf5d614699af5f$export$5c95673afb2371b8 = (filter, filterObject)=>{
    if (filter === "all") return Object.values(filterObject).reduce((acc, filterCategory)=>acc + Object.values(filterCategory).reduce((subacc, filterOption)=>filterOption.committedActive ? subacc + 1 : subacc, 0), 0);
    else return Object.values(filterObject[filter]).reduce((acc, subFilter)=>subFilter.committedActive ? acc + 1 : acc, 0);
};
const $3baf5d614699af5f$var$NUMBER_OF_FALLBACK_STORIES = 3;
const $3baf5d614699af5f$export$bb39b836f537201 = (customerStories)=>{
    const fallbackCustomerStoryList = new Array($3baf5d614699af5f$var$NUMBER_OF_FALLBACK_STORIES);
    const extraFallbackCustomerStoryList = [];
    customerStories.forEach((story)=>{
        switch(story.urlSlug){
            case "the-very-group":
                fallbackCustomerStoryList[0] = story;
                break;
            case "sonymusic-publishing":
                fallbackCustomerStoryList[1] = story;
                break;
            case "lumen":
                fallbackCustomerStoryList[2] = story;
                break;
            case "edenred":
            case "engie":
            case "sunlife":
                extraFallbackCustomerStoryList.push(story);
                break;
            default:
                break;
        }
    });
    let extraFallbackStoriesUsed = 0;
    // If one of the original three are missing,
    // we'll use the extra fallback stories
    fallbackCustomerStoryList.forEach((story, index)=>{
        if (!story && extraFallbackCustomerStoryList[extraFallbackStoriesUsed]) {
            fallbackCustomerStoryList[index] = extraFallbackCustomerStoryList[extraFallbackStoriesUsed];
            extraFallbackStoriesUsed++;
        }
    });
    return fallbackCustomerStoryList;
};
const $3baf5d614699af5f$var$getShortestColumnIndex = (storyList)=>{
    let shortestColumnIndex = 0;
    let shortestHeight = storyList[0].height;
    Object.values(storyList).forEach((story, index)=>{
        if (shortestHeight > story.height) {
            shortestColumnIndex = index;
            shortestHeight = story.height;
        }
    });
    return shortestColumnIndex;
};
const $3baf5d614699af5f$export$bf9342a233bd676b = (storiesList, stories, rows)=>{
    if (Object.keys(storiesList).length === 0) // initialize object
    for(let i = 0; i < rows; i++)storiesList[i] = {
        stories: [],
        height: 0
    };
    else if (Object.keys(storiesList).length !== rows || stories.length !== 0) {
        // clear out existing object, and re-intialize it
        for(const key in storiesList)delete storiesList[key];
        for(let i = 0; i < rows; i++)storiesList[i] = {
            stories: [],
            height: 0
        };
    }
    let shortestColumnIndex = 0;
    stories.forEach((story)=>{
        var _story_advocateQuotes, _story_storyIcon;
        shortestColumnIndex = $3baf5d614699af5f$var$getShortestColumnIndex(storiesList);
        const storyGridItem = storiesList[shortestColumnIndex];
        if ((_story_advocateQuotes = story.advocateQuotes) === null || _story_advocateQuotes === void 0 ? void 0 : _story_advocateQuotes.length) storyGridItem.height += $3baf5d614699af5f$var$sizeMap["lg"];
        else if ((_story_storyIcon = story.storyIcon) === null || _story_storyIcon === void 0 ? void 0 : _story_storyIcon.url) storyGridItem.height += $3baf5d614699af5f$var$sizeMap["md"];
        else storyGridItem.height += $3baf5d614699af5f$var$sizeMap["sm"];
        storyGridItem.stories.push(story);
    });
    return storiesList;
};
const $3baf5d614699af5f$export$65d9e924579f6503 = (width)=>{
    if (width > 1024) return 3;
    else if (width > 768) return 2;
    else if (width <= 768) return 1;
    else return 1;
};
const $3baf5d614699af5f$export$2d18ca8a66126a1d = ()=>{
    const { innerWidth: width } = window;
    return {
        width: width
    };
};
function $3baf5d614699af5f$export$f715c0e61b2c1a36() {
    const [windowDimensions, setWindowDimensions] = (0, $gljCV.useState)($3baf5d614699af5f$export$2d18ca8a66126a1d());
    (0, $gljCV.useEffect)(()=>{
        function handleResize() {
            setWindowDimensions($3baf5d614699af5f$export$2d18ca8a66126a1d());
        }
        window.addEventListener("resize", handleResize);
        return ()=>window.removeEventListener("resize", handleResize);
    }, []);
    return windowDimensions;
}
function $3baf5d614699af5f$export$f2735cb33092c31f(category) {
    return category === "industry" || category === "product" || category === "solution" || category === "region" || category === "team size";
}
const $3baf5d614699af5f$var$defaultCustomerStoryFilterOptionValue = {
    committedActive: false,
    stagedActive: false
};
function $3baf5d614699af5f$export$8ba04a2269d8d395(filters, subFilter) {
    const defaulted = {};
    filters.forEach((filter)=>{
        defaulted[filter.name] = (0, $dPABA._)((0, $6ogO3._)({}, $3baf5d614699af5f$var$defaultCustomerStoryFilterOptionValue), {
            grouping: subFilter === "region" || subFilter === "team size" ? subFilter : undefined
        });
    });
    return defaulted;
}
function $3baf5d614699af5f$export$c09429083a9f1f77(filterObject) {
    const committedActive = Object.keys(filterObject).map((key)=>{
        const map = Object.keys(filterObject[key]).map((key2)=>{
            const root = filterObject[key];
            const value = root[key2];
            var _value_grouping;
            const category = (_value_grouping = value === null || value === void 0 ? void 0 : value.grouping) !== null && _value_grouping !== void 0 ? _value_grouping : key;
            return (value === null || value === void 0 ? void 0 : value.committedActive) ? `${category}=${key2}` : "";
        }).filter((item)=>item === null || item === void 0 ? void 0 : item.length);
        return map;
    });
    return committedActive.flat().join("|");
}

});

parcelRegister("7u2YB", function(module, exports) {
$parcel$export(module.exports, "LocalizedFilterOptions", function () { return $1827895396126f0b$export$1021dd15869d400b; });

var $8e22h = parcelRequire("8e22h");

var $32ng3 = parcelRequire("32ng3");
const $1827895396126f0b$export$1021dd15869d400b = ()=>{
    const intl = (0, $8e22h.default)();
    const gwp7518NavIconUpdates = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp7518NavIconUpdates);
    return {
        "solution": intl.formatMessage({
            id: "CustomersLandingPage.filterCategory.solution",
            defaultMessage: "solution"
        }),
        "product": gwp7518NavIconUpdates ? intl.formatMessage({
            id: "CustomersLandingPage.filterCategory.product-gwp-7518",
            defaultMessage: "App"
        }) : intl.formatMessage({
            id: "CustomersLandingPage.filterCategory.product",
            defaultMessage: "product"
        }),
        "industry": intl.formatMessage({
            id: "CustomersLandingPage.filterCategory.industry",
            defaultMessage: "industry"
        }),
        "more filters": intl.formatMessage({
            id: "CustomersLandingPage.filterCategory.morefilters",
            defaultMessage: "more filters"
        }),
        "Work Management": intl.formatMessage({
            id: "CustomersLandingPage.subFilter.WorkManagement",
            defaultMessage: "Work Management"
        }),
        "Agile / DevOps": intl.formatMessage({
            id: "CustomersLandingPage.subFilter.AgileDevOps",
            defaultMessage: "Agile / DevOps"
        }),
        "ITSM": intl.formatMessage({
            id: "CustomersLandingPage.subFilter.ITSM",
            defaultMessage: "ITSMs"
        }),
        "Cloud Migration": intl.formatMessage({
            id: "CustomersLandingPage.subFilter.CloudMigration",
            defaultMessage: "Cloud Migration"
        }),
        "Jira": intl.formatMessage({
            id: "CustomersLandingPage.subFilter.Jira",
            defaultMessage: "Jira"
        }),
        "Jira Service Management": intl.formatMessage({
            id: "CustomersLandingPage.subFilter.JiraServiceManagement",
            defaultMessage: "Jira Service Management"
        }),
        "Jira Align": intl.formatMessage({
            id: "CustomersLandingPage.subFilter.JiraAlign",
            defaultMessage: "Jira Align"
        }),
        "Jira Product Discovery": intl.formatMessage({
            id: "CustomersLandingPage.subFilter.JiraProductDiscovery",
            defaultMessage: "Jira Product Discovery"
        }),
        "Confluence": intl.formatMessage({
            id: "CustomersLandingPage.subFilter.Confluence",
            defaultMessage: "Confluence"
        }),
        "Trello": intl.formatMessage({
            id: "CustomersLandingPage.subFilter.Trello",
            defaultMessage: "Trello"
        }),
        "Bitbucket": intl.formatMessage({
            id: "CustomersLandingPage.subFilter.Bitbucket",
            defaultMessage: "Bitbucket"
        }),
        "Guard": intl.formatMessage({
            id: "CustomersLandingPage.subFilter.Guard",
            defaultMessage: "Guard"
        }),
        "Statuspage": intl.formatMessage({
            id: "CustomersLandingPage.subFilter.Statuspage",
            defaultMessage: "Statuspage"
        }),
        "Compass": intl.formatMessage({
            id: "CustomersLandingPage.subFilter.Compass",
            defaultMessage: "Compass"
        }),
        "Bamboo": intl.formatMessage({
            id: "CustomersLandingPage.subFilter.Bamboo",
            defaultMessage: "Bamboo"
        }),
        "Automotive": intl.formatMessage({
            id: "CustomersLandingPage.subFilter.Automotive",
            defaultMessage: "Automotive"
        }),
        "Aviation": intl.formatMessage({
            id: "CustomersLandingPage.subFilter.Aviation",
            defaultMessage: "Aviation"
        }),
        "Consumer Goods & Retail": intl.formatMessage({
            id: "CustomersLandingPage.subFilter.ConsumerGoodsRetail",
            defaultMessage: "Consumer Goods & Retail"
        }),
        "Education": intl.formatMessage({
            id: "CustomersLandingPage.subFilter.Education",
            defaultMessage: "Education"
        }),
        "Energy & Utilties": intl.formatMessage({
            id: "CustomersLandingPage.subFilter.EnergyUtilties",
            defaultMessage: "Energy & Utilties"
        }),
        "Entertainment & Media": intl.formatMessage({
            id: "CustomersLandingPage.subFilter.EntertainmentMedia",
            defaultMessage: "Entertainment & Media"
        }),
        "Financial Services": intl.formatMessage({
            id: "CustomersLandingPage.subFilter.FinancialServices",
            defaultMessage: "Financial Services"
        }),
        "Government": intl.formatMessage({
            id: "CustomersLandingPage.subFilter.Government",
            defaultMessage: "Government"
        }),
        "Healthcare & Life Sciences": intl.formatMessage({
            id: "CustomersLandingPage.subFilter.HealthcareLifeSciences",
            defaultMessage: "Healthcare & Life Sciences"
        }),
        "Internet & Telecommunications": intl.formatMessage({
            id: "CustomersLandingPage.subFilter.InternetTelecommunications",
            defaultMessage: "Internet & Telecommunications"
        }),
        "Manufacturing": intl.formatMessage({
            id: "CustomersLandingPage.subFilter.Manufacturing",
            defaultMessage: "Manufacturing"
        }),
        "Non-Profit": intl.formatMessage({
            id: "CustomersLandingPage.subFilter.NonProfit",
            defaultMessage: "Non-Profit"
        }),
        "Real Estate": intl.formatMessage({
            id: "CustomersLandingPage.subFilter.RealEstate",
            defaultMessage: "Real Estate"
        }),
        "Software": intl.formatMessage({
            id: "CustomersLandingPage.subFilter.Software",
            defaultMessage: "Software"
        }),
        "Technology": intl.formatMessage({
            id: "CustomersLandingPage.subFilter.Technology",
            defaultMessage: "Technology"
        }),
        "Marketplace apps": intl.formatMessage({
            id: "CustomersLandingPage.subFilter.MarketplaceApps",
            defaultMessage: "Marketplace apps"
        }),
        "Only show stories from customers that use marketplace apps": intl.formatMessage({
            id: "CustomersLandingPage.subFilter.MarketplaceApps.description",
            defaultMessage: "Only show stories from customers that use Marketplace apps"
        }),
        "Solution partner": intl.formatMessage({
            id: "CustomersLandingPage.subFilter.SolutionPartner",
            defaultMessage: "Solution partner"
        }),
        "Only show stories from customers that have a solution partner": intl.formatMessage({
            id: "CustomersLandingPage.subFilter.SolutionPartner.description",
            defaultMessage: "Only show stories from customers that have a Solution Partner"
        }),
        "Americas": intl.formatMessage({
            id: "CustomersLandingPage.subFilter.Americas",
            defaultMessage: "Americas"
        }),
        "Europe, Middle East, Africa": intl.formatMessage({
            id: "CustomersLandingPage.subFilter.EuropeMiddleEastAfrica",
            defaultMessage: "Europe, Middle East, Africa"
        }),
        "Asia Pacific": intl.formatMessage({
            id: "CustomersLandingPage.subFilter.AsiaPacific",
            defaultMessage: "Asia Pacific"
        }),
        "Global": intl.formatMessage({
            id: "CustomersLandingPage.subFilter.Global",
            defaultMessage: "Global"
        }),
        "Small/Medium Business": intl.formatMessage({
            id: "CustomersLandingPage.subFilter.SmallMediumBusiness",
            defaultMessage: "Small/Medium Business"
        }),
        "Enterprise": intl.formatMessage({
            id: "CustomersLandingPage.subFilter.Enterprise",
            defaultMessage: "Enterprise"
        }),
        "Large Enterprise": intl.formatMessage({
            id: "CustomersLandingPage.subFilter.LargeEnterprise",
            defaultMessage: "Large Enterprise"
        })
    };
};

});

parcelRegister("fcMpu", function(module, exports) {

});



parcelRegister("2Z9hF", function(module, exports) {
$parcel$export(module.exports, "CustomerStoriesGrid", function () { return $e2a07677b6faccb5$export$630103427516de50; });
/* customer-stories-grid.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dypTs = parcelRequire("dypTs");
parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");

var $jMhSx = parcelRequire("jMhSx");
parcelRequire("6YEiI");
var $d1ibd = parcelRequire("d1ibd");
const $e2a07677b6faccb5$export$630103427516de50 = ({ storiesGrid: storiesGrid, numColumns: numColumns })=>{
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $dypTs.Fragment), {
        children: numColumns === 1 ? /*#__PURE__*/ (0, $dypTs.jsx)((0, $jMhSx.Row), {
            layout: "12",
            children: /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _zulpzwfg"
                ]),
                children: storiesGrid[0] && storiesGrid[0].stories.map((story, index)=>{
                    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $d1ibd.CustomerStoryCard), (0, $6ogO3._)({}, story), index);
                })
            })
        }) : numColumns === 2 ? /*#__PURE__*/ (0, $dypTs.jsxs)((0, $jMhSx.Row), {
            layout: "6-6",
            children: [
                /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx21bp4 _zulpzwfg"
                    ]),
                    children: storiesGrid[0] && storiesGrid[0].stories.map((story, index)=>{
                        return /*#__PURE__*/ (0, $dypTs.jsx)((0, $d1ibd.CustomerStoryCard), (0, $6ogO3._)({}, story), index);
                    })
                }),
                /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx21bp4 _zulpzwfg"
                    ]),
                    children: storiesGrid[1] && storiesGrid[1].stories.map((story, index)=>{
                        return /*#__PURE__*/ (0, $dypTs.jsx)((0, $d1ibd.CustomerStoryCard), (0, $6ogO3._)({}, story), index);
                    })
                })
            ]
        }) : /*#__PURE__*/ (0, $dypTs.jsxs)((0, $jMhSx.Row), {
            layout: "4-4-4",
            children: [
                /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx21bp4 _zulpzwfg"
                    ]),
                    children: storiesGrid[0] && storiesGrid[0].stories.map((story, index)=>{
                        return /*#__PURE__*/ (0, $dypTs.jsx)((0, $d1ibd.CustomerStoryCard), (0, $6ogO3._)({}, story), index);
                    })
                }),
                /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx21bp4 _zulpzwfg"
                    ]),
                    children: storiesGrid[1] && storiesGrid[1].stories.map((story, index)=>{
                        return /*#__PURE__*/ (0, $dypTs.jsx)((0, $d1ibd.CustomerStoryCard), (0, $6ogO3._)({}, story), index);
                    })
                }),
                /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx21bp4 _zulpzwfg"
                    ]),
                    children: storiesGrid[2] && storiesGrid[2].stories.map((story, index)=>{
                        return /*#__PURE__*/ (0, $dypTs.jsx)((0, $d1ibd.CustomerStoryCard), (0, $6ogO3._)({}, story), index);
                    })
                })
            ]
        })
    });
};
const $e2a07677b6faccb5$var$columnStyles = null;

});

parcelRegister("d1ibd", function(module, exports) {
$parcel$export(module.exports, "CustomerStoryCard", function () { return $98c69aee85a5c0ed$export$ec4bed50821b5168; });
/* customer-story-card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");
parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");
parcelRequire("HMZ3r");
var $ftgEA = parcelRequire("ftgEA");

var $5HK05 = parcelRequire("5HK05");

var $2fk4i = parcelRequire("2fk4i");

var $kooLp = parcelRequire("kooLp");
const $98c69aee85a5c0ed$export$ec4bed50821b5168 = ({ title: title, urlSlug: urlSlug, customerCompany: customerCompany, advocateQuotes: advocateQuotes, storyIcon: storyIcon, callToAction: callToAction })=>{
    var _callToAction_, _advocateQuote_advocateHeadshot, _customerCompany_logo_, _customerCompany_logo, _advocateQuote_advocateHeadshot1;
    var _callToAction__url;
    const href = (0, $kooLp.useLocalizedHref)((_callToAction__url = callToAction === null || callToAction === void 0 ? void 0 : (_callToAction_ = callToAction[0]) === null || _callToAction_ === void 0 ? void 0 : _callToAction_.url) !== null && _callToAction__url !== void 0 ? _callToAction__url : `/customers/${urlSlug}`);
    const isExternalHref = href.startsWith("https://");
    const advocateQuote = advocateQuotes === null || advocateQuotes === void 0 ? void 0 : advocateQuotes[0];
    const isQuote = !!(advocateQuote === null || advocateQuote === void 0 ? void 0 : (_advocateQuote_advocateHeadshot = advocateQuote.advocateHeadshot) === null || _advocateQuote_advocateHeadshot === void 0 ? void 0 : _advocateQuote_advocateHeadshot.url);
    var _customerCompany_name, _ref;
    return /*#__PURE__*/ (0, $dypTs.jsxs)("a", {
        href: href,
        target: isExternalHref ? "_blank" : undefined,
        rel: isExternalHref ? "noreferrer noopener" : undefined,
        className: (0, $2jatx.default)([
            "_311tkb7n _1dbzjojz _1vpokb7n _ca0q1tcg _u5f31tcg _n3tdzwfg _19bv1tcg _bfhku67f _2rkogktf _16qs1yxe _v56416gf _r57hidpf _zy2nm7ou"
        ]),
        children: [
            customerCompany && ((customerCompany === null || customerCompany === void 0 ? void 0 : (_customerCompany_logo = customerCompany.logo) === null || _customerCompany_logo === void 0 ? void 0 : (_customerCompany_logo_ = _customerCompany_logo[0]) === null || _customerCompany_logo_ === void 0 ? void 0 : _customerCompany_logo_.url) ? /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_6rth1tcg _rtysmlf1 _bna71ylp _1jpx1f51"
                ]),
                children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $ftgEA.ContentPlatformImage), {
                    alt: (_ref = (_customerCompany_name = customerCompany.name) !== null && _customerCompany_name !== void 0 ? _customerCompany_name : customerCompany.logo[0].description) !== null && _ref !== void 0 ? _ref : " ",
                    src: customerCompany.logo[0].url,
                    contentType: customerCompany.logo[0].contentType,
                    baseWidth: 200,
                    height: "40px"
                })
            }) : /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_6rth1tcg _rtysmlf1 _bna71ylp _1jpx1f51"
                ]),
                children: /*#__PURE__*/ (0, $dypTs.jsx)("p", {
                    children: (0, $5HK05.expectContent)(customerCompany.name)
                })
            })),
            (storyIcon === null || storyIcon === void 0 ? void 0 : storyIcon.url) && !isQuote && /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_6rth1tcg _1e0c1txw _mezj1osq _rtys163v _salg1wug _18zxkb7n"
                ]),
                children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $ftgEA.ContentPlatformImage), {
                    alt: " " /* we consider these illustrations decorative */ ,
                    src: storyIcon.url,
                    contentType: storyIcon.contentType,
                    baseWidth: 300
                })
            }),
            /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c11p5 _zulp1k8s _19pkidpf _2hwxidpf _otyr1tcg _18u0idpf _1b4didpf _vo4eidpf _wotzidpf _1ugbidpf _mezj1osq _rtys1ltq _clfdidpf _11pqidpf _q0a5idpf _c3k8idpf _czr612u0 _xx1w1lzr _btqhidpf _1tadidpf _1ejbidpf _1ahqidpf"
                ]),
                children: (advocateQuote === null || advocateQuote === void 0 ? void 0 : (_advocateQuote_advocateHeadshot1 = advocateQuote.advocateHeadshot) === null || _advocateQuote_advocateHeadshot1 === void 0 ? void 0 : _advocateQuote_advocateHeadshot1.url) ? /*#__PURE__*/ (0, $dypTs.jsxs)((0, $dypTs.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $dypTs.jsx)((0, $ftgEA.ContentPlatformImage), {
                            alt: " " /* details here would duplicate information elsewhere on the card */ ,
                            src: advocateQuote.advocateHeadshot.url,
                            contentType: advocateQuote.advocateHeadshot.contentType,
                            baseWidth: 400
                        }),
                        /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $dypTs.jsx)("h4", {
                                    children: advocateQuote.advocateName
                                }),
                                /*#__PURE__*/ (0, $dypTs.jsx)("p", {
                                    className: "eyebrow-md",
                                    children: advocateQuote.advocateJobTitle
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $dypTs.jsx)("blockquote", {
                            children: /*#__PURE__*/ (0, $dypTs.jsx)("p", {
                                className: "body-lg",
                                children: advocateQuote.advocateQuote
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0, $dypTs.jsx)("p", {
                    className: "body-lg",
                    children: title
                })
            }),
            callToAction && callToAction[0] && callToAction[0].text && /*#__PURE__*/ (0, $dypTs.jsx)((0, $2fk4i.Link), {
                className: "customer-story-link-container",
                href: href,
                text: callToAction[0].text,
                type: "primary",
                isStyleOnly: true
            })
        ]
    });
};
const $98c69aee85a5c0ed$var$customerStoryCardsStyles = null;
const $98c69aee85a5c0ed$var$customerLogoStyles = null;
const $98c69aee85a5c0ed$var$spotIllustrationStyles = null;
const $98c69aee85a5c0ed$var$storyTitleStyles = null;

});
parcelRegister("HMZ3r", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("ftgEA")).ContentPlatformImage; });

var $ftgEA = parcelRequire("ftgEA");

});
parcelRegister("ftgEA", function(module, exports) {
$parcel$export(module.exports, "ContentPlatformImage", function () { return $93bafa18ccb06246$export$f8e4eb6f7b9af79c; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $aPnCa = parcelRequire("aPnCa");

var $dypTs = parcelRequire("dypTs");

var $imIsw = parcelRequire("imIsw");
const $93bafa18ccb06246$export$f8e4eb6f7b9af79c = (_param)=>{
    var { contentType: contentType, src: src, alt: alt, baseWidth: baseWidth } = _param, rest = (0, $aPnCa._)(_param, [
        "contentType",
        "src",
        "alt",
        "baseWidth"
    ]);
    const queryPairs = [];
    let srcSet = [];
    if (contentType === "image/png") {
        queryPairs.push("fm=webp");
        if (baseWidth) {
            srcSet = (0, $imIsw.getSrcSet)(src, baseWidth, queryPairs, "w");
            queryPairs.push(`w=${baseWidth}`);
        }
    }
    const queryString = queryPairs.length > 0 ? `?${queryPairs.join("&")}` : "";
    return(// eslint-disable-next-line no-restricted-syntax
    /*#__PURE__*/ (0, $dypTs.jsx)("img", (0, $dPABA._)((0, $6ogO3._)({
        loading: "lazy"
    }, rest), {
        src: `${src}${queryString}`,
        srcSet: srcSet.length > 0 ? srcSet.join(",") : undefined,
        alt: alt
    })));
};

});



parcelRegister("WxMqy", function(module, exports) {
$parcel$export(module.exports, "CustomerStoryFilterModalBasic", function () { return $aa5052a10495e1ad$export$bcad7e14b9c41118; });
/* customer-story-filter-modal-basic.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");
parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");

var $jMhSx = parcelRequire("jMhSx");
parcelRequire("gD5LF");
var $hBvFS = parcelRequire("hBvFS");
var $7u2YB = parcelRequire("7u2YB");
const $aa5052a10495e1ad$export$bcad7e14b9c41118 = ({ subFilter: subFilter, subFilterObject: subFilterObject, updateFilterObject: updateFilterObject })=>{
    const localizedMap = (0, $7u2YB.LocalizedFilterOptions)();
    return /*#__PURE__*/ (0, $dypTs.jsx)("div", {
        className: (0, $2jatx.default)([
            "_kqswstnw _bfhku67f _2rkogktf _1pbycs5v _152t4bvh _ca0q7vkz _u5f31tcg _n3td1tcg _19bv1tcg _2lx21bp4 _16qsjojz _11ko1txw _rs1e1bp4 _m0njftgi _13qeidpf _1esjidpf _lnxxidpf _1yn0tlke _1m5y1txw _6xef1q9c _5red1h6o _53691y6m _130f1oen _un46gktf _1ebcgktf _tmbl1l7b _ghxb16z6 _ym6vgktf _118yftgi _otnau67f _1jfy1txw _vjdb1h6o _16db1h6o _1mpgidpf _94z6doyu _1srq1oen _sj1jkb7n",
            subFilter
        ]),
        id: "customer-story-modal-component-parent",
        children: /*#__PURE__*/ (0, $dypTs.jsx)("div", {
            children: Object.keys(subFilterObject).map((filterOptionName, index)=>{
                const filterObject = subFilterObject[filterOptionName];
                const active = filterObject.stagedActive;
                const optionId = `option-${subFilter.replace(/\s/g, "")}-${index}`;
                return /*#__PURE__*/ (0, $dypTs.jsxs)("label", {
                    htmlFor: optionId,
                    className: "filter-radio-button-container",
                    children: [
                        /*#__PURE__*/ (0, $dypTs.jsx)("input", {
                            id: optionId,
                            type: "checkbox",
                            onClick: ()=>updateFilterObject(filterOptionName),
                            className: (0, $2jatx.default)([
                                "_kqswstnw _1pby1mrw _tzy4idpf"
                            ])
                        }),
                        /*#__PURE__*/ (0, $dypTs.jsx)("span", {
                            className: active ? "checked" : "",
                            children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $jMhSx.Icon), {
                                name: "featurecheckmark",
                                size: "xs",
                                color: "#FFFFFF"
                            })
                        }),
                        (0, $hBvFS.isContentPlatformFacetAvailable)(subFilter) ? filterOptionName : localizedMap[filterOptionName]
                    ]
                }, filterOptionName);
            })
        })
    });
};
const $aa5052a10495e1ad$var$customerStoryFilterModalBasicStyle = null;
const $aa5052a10495e1ad$var$actualInputStyle = null;

});

parcelRegister("bk5Uk", function(module, exports) {
$parcel$export(module.exports, "CustomerStoryFilterModalComplex", function () { return $89e92ba9b8ccd01b$export$2f70c3bf84c20631; });
/* customer-story-filter-modal-complex.tsx generated by @compiled/babel-plugin v0.28.8 */ // This file has tons of nested selector errors that should be fixed.
// eslint-disable-next-line local/no-block-disable-of-nested-eslint
/* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $dypTs = parcelRequire("dypTs");
parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $5qUgh = parcelRequire("5qUgh");

var $jMhSx = parcelRequire("jMhSx");

var $dOxmj = parcelRequire("dOxmj");
parcelRequire("6YEiI");
var $cL5ak = parcelRequire("cL5ak");
const $89e92ba9b8ccd01b$export$2f70c3bf84c20631 = ({ numberOfCustomerStories: numberOfCustomerStories, filterObject: filterObject, onlyShowMoreFiltersCategory: onlyShowMoreFiltersCategory, updateFilterObject: updateFilterObject, closeModal: closeModal, resetFilters: resetFilters, clearMoreFilters: clearMoreFilters, clearFilters: clearFilters, runSearch: runSearch })=>{
    const intl = (0, $8e22h.default)();
    // Handle clicking outside the modal
    const handleClickingOutsideModal = (event)=>{
        if (event.target === event.currentTarget) {
            resetFilters();
            closeModal();
        }
    };
    // Handle "esc" key being pressed to close the modal
    const handleKeyDownOutsideModal = (event)=>{
        if (event.key === "Escape") {
            resetFilters();
            closeModal();
        }
    };
    // Handle click on the close button
    const handleClickingCloseModal = ()=>{
        resetFilters();
        closeModal();
    };
    const handleClearFilterClick = ()=>{
        if (onlyShowMoreFiltersCategory && clearMoreFilters) clearMoreFilters();
        else clearFilters();
    };
    let filterObjectKeys = Object.keys(filterObject);
    if (onlyShowMoreFiltersCategory) filterObjectKeys = [
        "more filters"
    ];
    return /*#__PURE__*/ (0, $dypTs.jsx)("div", {
        id: "customer-story-modal-component-parent",
        onKeyDown: handleKeyDownOutsideModal,
        onClick: handleClickingOutsideModal,
        className: (0, $2jatx.default)([
            "_kqsw1n9t _bfhk1ebw _1e02idpf _rjxpidpf _152tidpf _u7coidpf _1pbyouyt _1bsb1osq _4t3i1osq"
        ]),
        children: /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1rfm1osq _1rkb1osq _476didpf _123r1osq _a5ztidpf _gltephn8 _10jxphn8 _1mt1vbgk _kqswh2mm _1e0c1txw _2lx21bp4 _1reo15vq _18m915vq _bfhku67f _2rkogktf _16qsjojz _ca0qzwfg _u5f3zwfg _n3tdzwfg _19bvzwfg _19pkzwfg _2hwx1wug _otyrzwfg _18u01wug _1bsb1vuk _c71l1vuk _5mp0zwfg _uoe41txw _3p8m1yb4 _1f3a1h6o _xg3n1hjg _1eapidpf _feifidpf _1ul1idpf _c6iridpf _g0kv1fw0 _1d8aviql _1ys6tlke _1cpiqlpt _9xq715zi _xxjoglyw _pz8qglyw _1ydrglyw _br967vkz _ek7didpf _1xe37vkz _1gn8idpf _maetidpf _j5v9idpf _gnleidpf _l0efidpf _btwe1nn1 _1htt1k8s _1tnn1dk0 _ojp91tcg _1map1hjg _z5h1glyw _16ng1txw _1t661q9c _hy5i1yb4 _4pizidpf _13tl1osq _1wfif1ug _irdu1txw _1xae1bp4 _ikai1g80 _h2051y6m _1qitidpf _6dklidpf _yzz41ssb _7gqi1ssb _e3ic1tcg _1a66idpf _1eehidpf _mmhcidpf _119utlke _1yuw1txw _17zw1q9c _32f11h6o _1o5g1y6m _1shw1oen _9hinglyw _11w4gktf _1m9jgktf _ivy21l7b _1nsa16z6 _w3o2gktf _1p0lftgi _larvu67f _g1v11txw _1ggp1h6o _c2211h6o _1yr2doyu _1kdj1oen _1jezidpf _1sc3idpf _1xbzidpf _1fnuidpf _1y6a1txw _cj8a1g80 _7mj11yb4 _1a8f1osq _117t1tcg _yitridpf _1s8v1tcg _bwjgidpf _12u91tcg _1ur61txw _1drn1q9c _e9uk1yb4 _f1q21h6o _icc91hjg _kqdu12it _xtvnidpf _1a8gidpf _1579idpf _4cxwidpf _1jpwh2mm _t2ds1o8l _12kv1ylp _14rtgktf _1rhyidpf _hijaidpf _1srsidpf _1fj8doyu _1qzh1k0w _1ld0stnw _1f8ttlke _1jwpidpf _qqok1fkg _7l1y1cqc _7nn21u1b _cnocstnw _19tvb3bt _1mm47vkz _p98b7vkz _1qpgyh40 _13p3yh40 _w8ksu67f _hess1cqc _w28t1ssb _euwfdoyu _158b1k0w _1ab91tcg _1vva1ssb _1bqyzwfg _1hi7idpf _1bklidpf _3lyjidpf _18hj1txw _1x8i1yb4 _1b3v1h6o _i5ni1hjg _16xodoyu"
            ]),
            children: [
                /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
                    className: "filter-modal-header",
                    children: [
                        /*#__PURE__*/ (0, $dypTs.jsx)("h3", {
                            children: "Filters"
                        }),
                        /*#__PURE__*/ (0, $dypTs.jsx)("button", {
                            type: "button",
                            onClick: handleClickingCloseModal,
                            className: (0, $2jatx.default)([
                                "_19itglyw _bfhk1j28 _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1wyb1j6v _ect48q0o _80omtlke _syazalr3"
                            ]),
                            children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $jMhSx.Icon), {
                                name: "cross",
                                size: "small"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                    className: "filter-modal-body",
                    children: filterObjectKeys.map((filterCategory, index)=>{
                        const filterCategoryTyped = filterCategory;
                        if (filterCategoryTyped === "more filters") return /*#__PURE__*/ (0, $dypTs.jsx)((0, $cL5ak.CustomerStoryFilterModalComplexGrouping), {
                            filterCategory: "more filters",
                            filterObject: filterObject,
                            updateFilterObject: (subFilterName)=>updateFilterObject(filterCategoryTyped, subFilterName)
                        }, index);
                        return /*#__PURE__*/ (0, $dypTs.jsx)((0, $dOxmj.ComplexModalFilterCategorySection), {
                            filterCategory: filterCategoryTyped,
                            filterObject: filterObject,
                            updateFilterObject: updateFilterObject
                        }, index);
                    })
                }),
                /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
                    className: "filter-modal-footer",
                    children: [
                        /*#__PURE__*/ (0, $dypTs.jsx)("button", {
                            type: "button",
                            className: (0, $2jatx.default)([
                                "_19itglyw _bfhk1j28 _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1wyb1j6v _ect48q0o _80omtlke _syazalr3",
                                "filter-modal-clear-all"
                            ]),
                            onClick: handleClearFilterClick,
                            children: intl.formatMessage({
                                id: "CustomersLandingPage.clearAll",
                                defaultMessage: "Clear all"
                            })
                        }),
                        /*#__PURE__*/ (0, $dypTs.jsx)((0, $5qUgh.Adg4Button), {
                            className: "filter-apply-button",
                            variant: "primary",
                            size: "small",
                            color: "blue",
                            onClick: runSearch,
                            children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $iVyKn.default), {
                                id: "CustomersLandingPage.showResults",
                                defaultMessage: "Show <numberOfCustomerStories></numberOfCustomerStories> results",
                                values: {
                                    numberOfCustomerStories: ()=>numberOfCustomerStories
                                }
                            })
                        })
                    ]
                })
            ]
        })
    });
};
const $89e92ba9b8ccd01b$var$customerStoryFilterModalBackgroundStyle = null;
const $89e92ba9b8ccd01b$var$customerStoryFilterModalStyle = null;
const $89e92ba9b8ccd01b$var$buttonBaselineStyle = null;

});
parcelRegister("dOxmj", function(module, exports) {
$parcel$export(module.exports, "ComplexModalFilterCategorySection", function () { return $89699be1bf153c27$export$7e2a92574800a5cf; });
/* complex-modal-filter-category-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");

var $gljCV = parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");
parcelRequire("gD5LF");
var $hBvFS = parcelRequire("hBvFS");
parcelRequire("6YEiI");
var $cL5ak = parcelRequire("cL5ak");
const $89699be1bf153c27$var$MAX_SUBFILTERS_BEFORE_EXPAND = 8;
const $89699be1bf153c27$var$MAX_COLUMN_ENTRIES_BEFORE_EXPAND = 4;
const $89699be1bf153c27$var$MAX_SUBFILTERS_BEFORE_TWO_COLUMNS = 5;
const $89699be1bf153c27$var$NUMBER_OF_COLUMNS = 2;
const $89699be1bf153c27$export$7e2a92574800a5cf = ({ filterCategory: filterCategory, filterObject: filterObject, updateFilterObject: updateFilterObject })=>{
    const intl = (0, $8e22h.default)();
    const [showingMore, setShowingMore] = (0, $gljCV.useState)(false);
    const { width: width } = (0, $hBvFS.useWindowDimensions)();
    const FilterColumnOne = [];
    const FilterColumnTwo = [];
    // List of keys to see how many subfilters are in the category
    const keys = Object.keys(filterObject[filterCategory]);
    const expandSubsection = ()=>{
        setShowingMore(!showingMore);
    };
    Object.entries(filterObject[filterCategory]).forEach(([subFilterName, subFilterObject], index)=>{
        // On tablet and desktop, split the subfilters into two columns
        if (width > 768) {
            // If there are less than 5 subfilters,
            // or if the current subfilter is in the first half of the list,
            // Then add it to the first column
            if (keys.length < $89699be1bf153c27$var$MAX_SUBFILTERS_BEFORE_TWO_COLUMNS || keys.length / $89699be1bf153c27$var$NUMBER_OF_COLUMNS > index) {
                const isSubFilterHidden = FilterColumnOne.length >= $89699be1bf153c27$var$MAX_COLUMN_ENTRIES_BEFORE_EXPAND && keys.length > $89699be1bf153c27$var$MAX_SUBFILTERS_BEFORE_EXPAND && !showingMore;
                FilterColumnOne.push(/*#__PURE__*/ (0, $dypTs.jsx)((0, $cL5ak.CustomerStoryFilterModalRadioButton), {
                    index: index,
                    filterCategory: filterCategory,
                    subFilterName: subFilterName,
                    grouping: subFilterObject.grouping,
                    active: subFilterObject.stagedActive,
                    isSubFilterHidden: isSubFilterHidden,
                    updateFilterObject: updateFilterObject
                }, index));
            // if the current subfilter is in the first half of the list,
            // Then add it to the first column
            } else {
                const isSubFilterHidden = FilterColumnTwo.length >= $89699be1bf153c27$var$MAX_COLUMN_ENTRIES_BEFORE_EXPAND && keys.length > $89699be1bf153c27$var$MAX_SUBFILTERS_BEFORE_EXPAND && !showingMore;
                FilterColumnTwo.push(/*#__PURE__*/ (0, $dypTs.jsx)((0, $cL5ak.CustomerStoryFilterModalRadioButton), {
                    index: index,
                    filterCategory: filterCategory,
                    subFilterName: subFilterName,
                    grouping: subFilterObject.grouping,
                    active: subFilterObject.stagedActive,
                    isSubFilterHidden: isSubFilterHidden,
                    updateFilterObject: updateFilterObject
                }, index));
            }
        } else {
            // On mobile, add all subfilters to the first column
            const isSubFilterHidden = FilterColumnOne.length >= $89699be1bf153c27$var$MAX_COLUMN_ENTRIES_BEFORE_EXPAND && !showingMore;
            FilterColumnOne.push(/*#__PURE__*/ (0, $dypTs.jsx)((0, $cL5ak.CustomerStoryFilterModalRadioButton), {
                index: index,
                filterCategory: filterCategory,
                subFilterName: subFilterName,
                grouping: subFilterObject.grouping,
                active: subFilterObject.stagedActive,
                isSubFilterHidden: isSubFilterHidden,
                updateFilterObject: updateFilterObject
            }, index));
        }
    });
    return /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $dypTs.jsx)("h4", {
                children: filterCategory
            }),
            /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
                className: "filter-modal-grouping-container",
                children: [
                    /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                        className: "filter-modal-grouping-column filter-column-1",
                        children: FilterColumnOne
                    }),
                    /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                        className: "filter-modal-grouping-column filter-column-2",
                        children: FilterColumnTwo
                    })
                ]
            }),
            keys.length > $89699be1bf153c27$var$MAX_SUBFILTERS_BEFORE_EXPAND && /*#__PURE__*/ (0, $dypTs.jsx)("button", {
                type: "button",
                onClick: expandSubsection,
                className: (0, $2jatx.default)([
                    "_19itglyw _bfhk1j28 _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1wyb1j6v _ect48q0o _80omtlke _syazalr3 _1pfh1k8s"
                ]),
                children: !showingMore ? intl.formatMessage({
                    id: "CustomersLandingPage.showMore",
                    defaultMessage: "Show more"
                }) : intl.formatMessage({
                    id: "CustomersLandingPage.showLess",
                    defaultMessage: "Show less"
                })
            })
        ]
    });
};
const $89699be1bf153c27$var$showButtonStyle = null;

});


parcelRegister("cL5ak", function(module, exports) {
$parcel$export(module.exports, "CustomerStoryFilterModalRadioButton", function () { return $b2b472dc266838e9$export$ab592b785f13f9e8; });
$parcel$export(module.exports, "CustomerStoryFilterModalComplexGrouping", function () { return $b2b472dc266838e9$export$6ceba011e8ba7c3e; });
/* customer-story-filter-modal-grouping.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");
parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $jMhSx = parcelRequire("jMhSx");
parcelRequire("gD5LF");
var $hBvFS = parcelRequire("hBvFS");
var $7u2YB = parcelRequire("7u2YB");
parcelRequire("6YEiI");
var $e6w9W = parcelRequire("e6w9W");
const $b2b472dc266838e9$var$actualInputStyle = null;
const $b2b472dc266838e9$export$ab592b785f13f9e8 = ({ index: index, filterCategory: filterCategory, subFilterName: subFilterName, grouping: grouping, active: active, isSubFilterHidden: isSubFilterHidden, updateFilterObject: updateFilterObject })=>{
    const localizedMap = (0, $7u2YB.LocalizedFilterOptions)();
    const optionId = `option-${(grouping !== null && grouping !== void 0 ? grouping : filterCategory).replace(/\s/g, "")}-${index}`;
    return /*#__PURE__*/ (0, $dypTs.jsxs)("label", {
        htmlFor: optionId,
        className: `filter-radio-button-container ${isSubFilterHidden ? "hide-subfilter" : ""}`,
        children: [
            /*#__PURE__*/ (0, $dypTs.jsx)("input", {
                id: optionId,
                type: "checkbox",
                onClick: ()=>updateFilterObject(filterCategory, subFilterName),
                className: (0, $2jatx.default)([
                    "_kqswstnw _1pby1mrw _tzy4idpf"
                ])
            }),
            /*#__PURE__*/ (0, $dypTs.jsx)("span", {
                className: active ? "checked" : "",
                children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $jMhSx.Icon), {
                    name: "featurecheckmark",
                    size: "xs",
                    color: "#FFFFFF"
                })
            }),
            (0, $hBvFS.isContentPlatformFacetAvailable)(grouping !== null && grouping !== void 0 ? grouping : filterCategory) ? subFilterName : localizedMap[subFilterName]
        ]
    });
};
const $b2b472dc266838e9$export$6ceba011e8ba7c3e = ({ filterCategory: filterCategory, filterObject: filterObject, updateFilterObject: updateFilterObject })=>{
    const intl = (0, $8e22h.default)();
    const sliderFilterContainer = [];
    const regionFilterContainer = [];
    const teamSizeFilterContainer = [];
    Object.keys(filterObject[filterCategory]).map((subFilter, index)=>{
        const subFilterObject = filterObject[filterCategory][subFilter];
        if (subFilterObject.description) sliderFilterContainer.push(/*#__PURE__*/ (0, $dypTs.jsx)((0, $e6w9W.CustomerStoryFilterSliderFilter), {
            subFilterName: subFilter,
            active: subFilterObject.stagedActive,
            updateFilterObject: ()=>updateFilterObject(subFilter),
            subFilterDescription: subFilterObject.description
        }, subFilter));
        else if (subFilterObject.grouping === "region") regionFilterContainer.push(/*#__PURE__*/ (0, $dypTs.jsx)($b2b472dc266838e9$export$ab592b785f13f9e8, {
            index: index,
            filterCategory: filterCategory,
            subFilterName: subFilter,
            grouping: subFilterObject.grouping,
            active: subFilterObject.stagedActive,
            isSubFilterHidden: false,
            updateFilterObject: ()=>updateFilterObject(subFilter)
        }, index));
        else teamSizeFilterContainer.push(/*#__PURE__*/ (0, $dypTs.jsx)($b2b472dc266838e9$export$ab592b785f13f9e8, {
            index: index,
            filterCategory: filterCategory,
            subFilterName: subFilter,
            grouping: subFilterObject.grouping,
            active: subFilterObject.stagedActive,
            isSubFilterHidden: false,
            updateFilterObject: ()=>updateFilterObject(subFilter)
        }, index));
    });
    return /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
        className: "filter-modal-body-more-filters",
        children: [
            sliderFilterContainer.map((sliderFilter)=>{
                return sliderFilter;
            }),
            /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1bsb1osq _179r1hjg _85i51tcg"
                ]),
                children: [
                    /*#__PURE__*/ (0, $dypTs.jsx)("h4", {
                        children: intl.formatMessage({
                            id: "CustomersLandingPage.filterGrouping.region",
                            defaultMessage: "Region"
                        })
                    }),
                    /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                        className: "filter-modal-grouping-container",
                        children: /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                            className: "filter-modal-grouping-column",
                            children: regionFilterContainer.map((regionFilter)=>{
                                return regionFilter;
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1pfh1tcg _1bsb1osq"
                ]),
                children: [
                    /*#__PURE__*/ (0, $dypTs.jsx)("h4", {
                        children: intl.formatMessage({
                            id: "CustomersLandingPage.filterGrouping.TeamSize",
                            defaultMessage: "Team size"
                        })
                    }),
                    /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                        className: "filter-modal-grouping-container",
                        children: /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                            className: "filter-modal-grouping-column",
                            children: teamSizeFilterContainer.map((regionFilter)=>{
                                return regionFilter;
                            })
                        })
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("fnda5", function(module, exports) {
$parcel$export(module.exports, "CustomerStoryNoResultsFallback", function () { return $4e8f8f3882fb2389$export$bdcbebb305fb33c3; });
/* customer-story-no-results-fallback-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");
parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $jMhSx = parcelRequire("jMhSx");
parcelRequire("gD5LF");
var $hBvFS = parcelRequire("hBvFS");
parcelRequire("6YEiI");
var $2Z9hF = parcelRequire("2Z9hF");
const $4e8f8f3882fb2389$export$bdcbebb305fb33c3 = ({ numColumns: numColumns, fallbackCustomerStories: fallbackCustomerStories })=>{
    const intl = (0, $8e22h.default)();
    const fallbackStoriesGrid = (0, $hBvFS.sortStoriesByHeight)({}, fallbackCustomerStories, numColumns);
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $jMhSx.Row), {
        layout: "12",
        children: /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1e0c1txw _2lx21bp4 _y3gn1e5h _amuvangw _1li31tcg"
            ]),
            children: [
                /*#__PURE__*/ (0, $dypTs.jsx)("p", {
                    className: "eyebrow-md",
                    children: intl.formatMessage({
                        id: "CustomersLandingPage.recommendedStories",
                        defaultMessage: "Recommended stories you may like"
                    })
                }),
                /*#__PURE__*/ (0, $dypTs.jsx)((0, $2Z9hF.CustomerStoriesGrid), {
                    storiesGrid: fallbackStoriesGrid,
                    numColumns: numColumns
                })
            ]
        })
    });
};
const $4e8f8f3882fb2389$var$customerStoryRecommendedStoriesStyles = null;

});

parcelRegister("3614I", function(module, exports) {
$parcel$export(module.exports, "CustomerStorySearchBar", function () { return $4849c25cac7de132$export$b6376e21a285c40b; });
/* customer-story-search-bar.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");

var $gljCV = parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");
parcelRequire("6YEiI");
var $4aLWG = parcelRequire("4aLWG");
var $1nITY = parcelRequire("1nITY");
const $4849c25cac7de132$export$b6376e21a285c40b = ({ searchStringValue: searchStringValue, searchInputFieldFocused: searchInputFieldFocused, setSearchString: setSearchString, setSearchInputFieldFocused: setSearchInputFieldFocused, clearSearchField: clearSearchField, runSearch: runSearch })=>{
    const intl = (0, $8e22h.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const searchRef = (0, $gljCV.useRef)(null);
    const onSearchInputChange = (event)=>{
        setSearchString(event.target.value);
    };
    const handleSearchBarFocus = ()=>{
        setSearchInputFieldFocused(true);
        createAnalyticsEvent({
            origin: "web",
            platform: "web",
            product: "marketing",
            source: "none",
            userIdType: "atlassianAccount",
            eventComponent: "searchInput",
            event: "clicked",
            eventType: "ui",
            action: "clicked",
            actionSubject: "component",
            attributes: {
                url: location.href,
                page_path: location.pathname,
                eventComponent: "customerStorysearchInput"
            }
        }).fire();
    };
    const handleOnBlur = ()=>{
        if (searchStringValue === "") setSearchInputFieldFocused(false);
        else setSearchInputFieldFocused(true);
    };
    const handleSearchButtonClick = (0, $gljCV.useCallback)(()=>{
        if (searchRef.current) searchRef.current.focus();
        runSearch();
    }, [
        runSearch
    ]);
    const handleClearSearchButtonClick = ()=>{
        clearSearchField();
        if (searchRef.current) searchRef.current.focus();
    };
    const searchClassName = searchInputFieldFocused ? "search-active" : "";
    return /*#__PURE__*/ (0, $dypTs.jsxs)("form", {
        onSubmit: (evt)=>{
            evt.preventDefault();
            handleSearchButtonClick();
        },
        className: (0, $2jatx.default)([
            "_4t3ior1b _1bsb1osq _bfhk17fj _2rko1ylp _1e0c1txw _1n261q9c _1bah1yb4 _ca0qidpf _u5f37vkz _n3tdidpf _19bv7vkz _scffglyw _1rwq1j28 _xmji1r31 _gxxuglyw _34ir1o36 _5hv91osq _17ea1vuk _125xdlk8 _psgkqlpt _yizh1fw0 _ggg71nn1 _1owa1w8u _4u6k1j28 _10709by0 _1f021txw _1vh3esu3 _dier1q9c _1b10idpf _cpccftgi _1s5lidpf _18asftgi _1sku1h6o _12nmbz2e _1d2m1f4h _11vy1dfy _p2rgx19p"
        ]),
        children: [
            /*#__PURE__*/ (0, $dypTs.jsx)("input", {
                className: searchClassName,
                type: "text",
                placeholder: intl.formatMessage({
                    id: "CustomersLandingPage.searchPlaceholder",
                    defaultMessage: "Search customer stories"
                }),
                onFocus: handleSearchBarFocus,
                onBlur: handleOnBlur,
                onChange: onSearchInputChange,
                value: searchStringValue,
                ref: searchRef
            }),
            /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
                className: `search-buttons-container ${searchClassName}`,
                children: [
                    searchInputFieldFocused && /*#__PURE__*/ (0, $dypTs.jsxs)((0, $dypTs.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $dypTs.jsx)((0, $1nITY.SearchCloseButton), {
                                onClick: handleClearSearchButtonClick
                            }),
                            /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                                className: "search-buttons-divider"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $dypTs.jsx)((0, $4aLWG.SearchButton), {})
                ]
            })
        ]
    });
};
const $4849c25cac7de132$var$searchBarContainerStyle = null;

});

parcelRegister("4aLWG", function(module, exports) {
$parcel$export(module.exports, "SearchButton", function () { return $734196fc18409da9$export$690bcf3a1f1e9f2f; });
/* customer-story-search-button.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");
parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $bk4Ud = parcelRequire("bk4Ud");
const $734196fc18409da9$var$searchIconStyle = null;
const $734196fc18409da9$export$690bcf3a1f1e9f2f = ()=>{
    const intl = (0, $8e22h.default)();
    const translated = {
        searchLabel: intl.formatMessage({
            id: "CustomerLandingPage.search.label",
            defaultMessage: "Search"
        })
    };
    return /*#__PURE__*/ (0, $dypTs.jsx)("button", {
        type: "submit",
        id: "customer-story-search-icon",
        "aria-label": translated.searchLabel,
        "data-event": "clicked",
        "data-event-component": "button",
        "data-event-container": "customerStorySearchButton",
        "data-product-key": "customer",
        className: (0, $2jatx.default)([
            "_ahbqftgi _bfhk1j28 _19itidpf _80omtlke _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _syaz14rb _ql0oj1oc _1nj1qlpt _11vn1ssb _17521wug _i2i314y2 _uhas14y2 _5jw914y2 _7wy914y2 _w8l5zwfg _xwbjzwfg"
        ]),
        children: /*#__PURE__*/ (0, $dypTs.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bk4Ud))), {
            label: translated.searchLabel,
            primaryColor: "#101214"
        })
    });
};

});

parcelRegister("1nITY", function(module, exports) {
$parcel$export(module.exports, "SearchCloseButton", function () { return $56c61533edb3940c$export$c5139e00bcad35c8; });
/* customer-story-search-close-button.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");
parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $dE0sS = parcelRequire("dE0sS");
const $56c61533edb3940c$var$searchIconStyle = null;
const $56c61533edb3940c$export$c5139e00bcad35c8 = (props)=>{
    const intl = (0, $8e22h.default)();
    const translated = {
        searchCloseLabel: intl.formatMessage({
            id: "CustomerLandingPage.search.close.label",
            defaultMessage: "Search close"
        })
    };
    return /*#__PURE__*/ (0, $dypTs.jsx)("button", {
        type: "button",
        onClick: props.onClick,
        id: "customer-story-search-icon",
        "aria-label": translated.searchCloseLabel,
        "data-event": "clicked",
        "data-event-component": "button",
        "data-event-container": "customerStorySearchCloseButton",
        "data-product-key": "customer",
        className: (0, $2jatx.default)([
            "_1pfh1y44 _12l2ftgi _bfhk1j28 _19itidpf _80omtlke _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _syaz14rb _ql0oj1oc _1nj1qlpt _11vn1ssb _17521wug _i2i314y2 _uhas14y2 _5jw914y2 _7wy914y2 _w8l51ul9"
        ]),
        children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $dE0sS.Cross), {
            size: "24"
        })
    });
};

});



parcelRegister("9K8X0", function(module, exports) {
$parcel$export(module.exports, "CustomerStoryFilters", function () { return $22c8d2a2ca3fb814$export$801647fac331cbf3; });
/* customer-story-filters.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $dypTs = parcelRequire("dypTs");

var $gljCV = parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $bQjAr = parcelRequire("bQjAr");

var $5qUgh = parcelRequire("5qUgh");

var $jMhSx = parcelRequire("jMhSx");
parcelRequire("6YEiI");
var $WxMqy = parcelRequire("WxMqy");
var $bk5Uk = parcelRequire("bk5Uk");
var $3614I = parcelRequire("3614I");
parcelRequire("gD5LF");
var $hBvFS = parcelRequire("hBvFS");
var $7u2YB = parcelRequire("7u2YB");
const $22c8d2a2ca3fb814$export$801647fac331cbf3 = ({ filterObject: filterObject, numberOfCustomerStoriesByCommittedValues: numberOfCustomerStoriesByCommittedValues, numberOfCustomerStoriesByStagedValues: numberOfCustomerStoriesByStagedValues, searchStringValue: searchStringValue, searchInputFieldFocused: searchInputFieldFocused, hasFilterSearchRun: hasFilterSearchRun, setFilterObjectValue: setFilterObjectValue, setSearchInputFieldFocused: setSearchInputFieldFocused, setSearchString: setSearchString, clearAllFilterButtonClickHandler: clearAllFilterButtonClickHandler, clearSearchField: clearSearchField, runSearchWithFilters: runSearchWithFilters })=>{
    const intl = (0, $8e22h.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const localizedMap = (0, $7u2YB.LocalizedFilterOptions)();
    const whichFilterModalIsOpenObjectDefaultState = {
        "solution": false,
        "product": false,
        "industry": false,
        "more filters": false
    };
    const { width: width } = (0, $hBvFS.useWindowDimensions)();
    Object.freeze(whichFilterModalIsOpenObjectDefaultState);
    const [whichFilterModalIsOpenObject, updateWhichFilterModalIsOpenObject] = (0, $gljCV.useState)(whichFilterModalIsOpenObjectDefaultState);
    // Updates the state of which filter modal is open
    // If a modal is closing, we commit all the stagedActive values
    const updateWhichFilterModalIsShown = (subFilter)=>{
        const isModalClosing = Object.keys(whichFilterModalIsOpenObject).filter((key)=>whichFilterModalIsOpenObject[key]);
        updateWhichFilterModalIsOpenObject(()=>(0, $dPABA._)((0, $6ogO3._)({}, whichFilterModalIsOpenObjectDefaultState), {
                [subFilter]: !whichFilterModalIsOpenObject[subFilter]
            }));
        if (isModalClosing.length > 0) setFilterObjectValue((prevState)=>{
            filterObject = (0, $6ogO3._)({}, prevState, (0, $hBvFS.commitAllStagedActiveValues)(prevState));
            runSearchWithFilters(filterObject, searchStringValue);
            return filterObject;
        });
    };
    // Updates the stagedActive value of the filter
    const updateSubFilterStagedValue = (subFilterName, filterOptionName)=>{
        setFilterObjectValue((prevState)=>{
            return (0, $dPABA._)((0, $6ogO3._)({}, prevState), {
                [subFilterName]: (0, $dPABA._)((0, $6ogO3._)({}, prevState[subFilterName]), {
                    [filterOptionName]: (0, $dPABA._)((0, $6ogO3._)({}, prevState[subFilterName][filterOptionName]), {
                        stagedActive: !prevState[subFilterName][filterOptionName].stagedActive
                    })
                })
            });
        });
    };
    const clearAllStagedValues = ()=>{
        setFilterObjectValue((prevState)=>{
            return (0, $6ogO3._)({}, prevState, (0, $hBvFS.setAllStagedActiveToFalse)(prevState));
        });
    };
    // Clears all stagedActive values in the more filters section
    const clearMoreFilterStagedValues = ()=>{
        setFilterObjectValue((prevState)=>{
            const updatedFilterState = Object.entries(prevState["more filters"]).reduce((acc, [filterOptionName, filterOptionValue])=>{
                acc[filterOptionName] = (0, $dPABA._)((0, $6ogO3._)({}, filterOptionValue), {
                    stagedActive: false
                });
                return acc;
            }, {});
            return (0, $dPABA._)((0, $6ogO3._)({}, prevState), {
                ["more filters"]: (0, $6ogO3._)({}, prevState["more filters"], updatedFilterState)
            });
        });
    };
    // resets all stagedActive values to their committedActive value
    const resetAllStagedValues = ()=>{
        setFilterObjectValue((prevState)=>{
            const updatedFilterState = (0, $hBvFS.resetAllStagedActiveToCommittedActiveValue)(prevState);
            return (0, $6ogO3._)({}, prevState, updatedFilterState);
        });
    };
    // Closes complex modal and runs search
    const runSearchWithFiltersWrapper = ()=>{
        updateWhichFilterModalIsShown("more filters");
        runSearchWithFilters(filterObject, searchStringValue);
    };
    // Handles logic for determining which filter modal to show
    const getFilterModal = (showFilter, filterKey)=>{
        if (!showFilter || !whichFilterModalIsOpenObject[filterKey]) return null;
        const numCols = (0, $hBvFS.getNumberOfCustomerStoryColumns)(width);
        if (numCols === 3) {
            if (filterKey === "more filters") return /*#__PURE__*/ (0, $dypTs.jsx)((0, $bk5Uk.CustomerStoryFilterModalComplex), {
                numberOfCustomerStories: numberOfCustomerStoriesByStagedValues,
                filterObject: filterObject,
                onlyShowMoreFiltersCategory: true,
                updateFilterObject: updateSubFilterStagedValue,
                closeModal: ()=>updateWhichFilterModalIsShown("more filters"),
                resetFilters: resetAllStagedValues,
                clearMoreFilters: clearMoreFilterStagedValues,
                clearFilters: clearAllStagedValues,
                runSearch: runSearchWithFiltersWrapper
            });
            else return /*#__PURE__*/ (0, $dypTs.jsx)((0, $WxMqy.CustomerStoryFilterModalBasic), {
                subFilter: filterKey,
                subFilterObject: filterObject[filterKey],
                updateFilterObject: (filterOptionName)=>updateSubFilterStagedValue(filterKey, filterOptionName)
            });
        } else return /*#__PURE__*/ (0, $dypTs.jsx)((0, $bk5Uk.CustomerStoryFilterModalComplex), {
            numberOfCustomerStories: numberOfCustomerStoriesByStagedValues,
            filterObject: filterObject,
            onlyShowMoreFiltersCategory: false,
            updateFilterObject: updateSubFilterStagedValue,
            closeModal: ()=>updateWhichFilterModalIsShown("more filters"),
            resetFilters: resetAllStagedValues,
            clearFilters: clearAllStagedValues,
            runSearch: runSearchWithFiltersWrapper
        });
    };
    const filterButtonClickWrapper = (ev, filterCategory)=>{
        ev.preventDefault();
        createAnalyticsEvent({
            origin: "web",
            platform: "web",
            product: "marketing",
            source: "none",
            userIdType: "atlassianAccount",
            eventComponent: "customerFilterButton",
            event: "clicked",
            eventType: "ui",
            action: "clicked",
            actionSubject: "component",
            attributes: {
                labelEnglish: filterCategory,
                url: location.href,
                page_path: location.pathname,
                eventComponent: "customerFilterButton"
            }
        }).fire();
        updateWhichFilterModalIsShown(filterCategory);
    };
    const buttonPropsList = [
        {
            variant: "primary",
            color: "light_grey",
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            onClick: (ev)=>filterButtonClickWrapper(ev, "solution")
        },
        {
            variant: "primary",
            color: "light_grey",
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            onClick: (ev)=>filterButtonClickWrapper(ev, "product")
        },
        {
            variant: "primary",
            color: "light_grey",
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            onClick: (ev)=>filterButtonClickWrapper(ev, "industry")
        },
        {
            variant: "secondary",
            color: "light_grey",
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            onClick: (ev)=>filterButtonClickWrapper(ev, "more filters")
        }
    ];
    const totalNumberOfActiveFilters = (0, $gljCV.useMemo)(()=>{
        return (0, $hBvFS.getActiveFiltersByFilterType)("all", filterObject) || 0;
    }, [
        filterObject
    ]);
    // If any filter modal is open, show the modal
    const showModal = Object.values(whichFilterModalIsOpenObject).filter((isActiveValue)=>isActiveValue).length > 0;
    const handleDocumentClick = (0, $gljCV.useCallback)((event)=>{
        if (showModal) {
            let parentNode = event.target;
            while(parentNode && parentNode.nodeName !== "BODY"){
                if (parentNode.id === "customer-story-modal-component-parent") return;
                parentNode = parentNode.parentNode;
            }
        }
        // If we are here, it means the click was outside the modal
        const isModalClosing = Object.keys(whichFilterModalIsOpenObject).filter((key)=>whichFilterModalIsOpenObject[key]);
        if (isModalClosing.length > 0) {
            updateWhichFilterModalIsOpenObject(()=>(0, $6ogO3._)({}, whichFilterModalIsOpenObjectDefaultState));
            setFilterObjectValue((prevState)=>{
                // eslint-disable-next-line react-hooks/exhaustive-deps
                filterObject = (0, $6ogO3._)({}, prevState, (0, $hBvFS.commitAllStagedActiveValues)(prevState));
                runSearchWithFilters(filterObject, searchStringValue);
                return filterObject;
            });
        }
    }, [
        showModal
    ]);
    // Attach and detach the event listener for the document click
    // This is used to determine if there is a click outside of the filter modals
    (0, $gljCV.useEffect)(()=>{
        // Attach the listeners on component mount.
        document.addEventListener("click", handleDocumentClick, false);
        // Detach the listeners on component unmount.
        return ()=>{
            document.removeEventListener("click", handleDocumentClick, false);
        };
    }, [
        handleDocumentClick
    ]);
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $bQjAr.default), {
        name: "customers-page-filters",
        children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $jMhSx.TypographyStyles), {
            children: /*#__PURE__*/ (0, $dypTs.jsxs)("section", {
                className: (0, $2jatx.default)([
                    "_19pkys9h _2hwxidpf _otyrzwfg _18u0idpf _12eoidpf _1mg17vkz"
                ]),
                children: [
                    /*#__PURE__*/ (0, $dypTs.jsx)((0, $jMhSx.Row), {
                        layout: "12",
                        children: /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _1n261q9c _1bah1yb4"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
                                    className: (0, $2jatx.default)([
                                        "_kqswh2mm _1e0c1txw _1n261q9c _i0dl1ns9 _v5646lqh _1a8lka7h _1vn5glyw",
                                        Object.keys(filterObject.industry).length === 0 && "_tzy4idpf"
                                    ]),
                                    children: [
                                        buttonPropsList.map((buttonProp, index)=>{
                                            const filterKey = Object.keys(filterObject)[index];
                                            // Inefficient, we should look into memoizing this
                                            const numFiltersActive = (0, $hBvFS.getActiveFiltersByFilterType)(filterKey, filterObject);
                                            const buttonClassNameBuilder = `customer-story-filter-button-adg4 ${numFiltersActive ? "filter-active" : ""} ${whichFilterModalIsOpenObject[filterKey] ? "selected" : ""} ${filterKey === "more filters" ? "more-filters" : ""}`;
                                            const filterModal = getFilterModal(showModal, filterKey);
                                            return /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
                                                className: "customer-story-filter-button",
                                                children: [
                                                    /*#__PURE__*/ (0, $dypTs.jsxs)((0, $5qUgh.Adg4Button), (0, $dPABA._)((0, $6ogO3._)({}, buttonProp), {
                                                        className: (0, $2jatx.default)([
                                                            "_bja41dk0 _lf657vkz _1edd7vkz _1yprtlke _5pbz1j6v _1ffa1ipv _10tp1nn1 _1mjbglyw _qjacf1gs _12rgftgi _inqm18ms _3smh17fj _irr317fj _kasp1vpm _s9qi1vpm _1pmm1vpm _1il01o8l _pnatglyw _18csplmo",
                                                            buttonClassNameBuilder
                                                        ]),
                                                        id: "customer-story-modal-component-parent",
                                                        children: [
                                                            localizedMap[filterKey],
                                                            " ",
                                                            $22c8d2a2ca3fb814$var$filterDropDownArrowSVG,
                                                            /*#__PURE__*/ (0, $dypTs.jsx)("span", {
                                                                className: (0, $2jatx.default)([
                                                                    "_1e0cglyw _ae4v1h6o _bfhkshej _2rko1ssb _ahbqftgi _syazqlpt _1bsbgktf _4t3igktf _k48pni7l"
                                                                ]),
                                                                children: numFiltersActive
                                                            })
                                                        ]
                                                    })),
                                                    filterModal
                                                ]
                                            }, index);
                                        }),
                                        /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
                                            id: "customer-story-modal-component-parent",
                                            className: (0, $2jatx.default)([
                                                "_1e0cglyw _1mjb1ule"
                                            ]),
                                            children: [
                                                /*#__PURE__*/ (0, $dypTs.jsxs)("button", {
                                                    id: "more filters",
                                                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                                    onClick: (ev)=>filterButtonClickWrapper(ev, "more filters"),
                                                    className: (0, $2jatx.default)([
                                                        "_80omtlke _1e0c1txw _1bah1h6o _4cvr1h6o _11q7glyw _19itglyw _2rko53f4 _4t3i1ylp _1bsb1osq _syazqlpt _ca0qftgi _u5f37vkz _n3tdftgi _19bv7vkz _zulpftgi _irr317fj",
                                                        totalNumberOfActiveFilters && "_ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _bfhk1vpm _3smh1vpm _irr31vpm"
                                                    ]),
                                                    children: [
                                                        /*#__PURE__*/ (0, $dypTs.jsx)("img", {
                                                            src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/customer-story-filter-icon-3367749555.webp",
                                                            alt: "Filter icon",
                                                            className: (0, $2jatx.default)([
                                                                "_1bsb1tcg _4t3i1tcg"
                                                            ])
                                                        }),
                                                        /*#__PURE__*/ (0, $dypTs.jsx)("span", {
                                                            className: (0, $2jatx.default)([
                                                                "_1e0c1o8l",
                                                                totalNumberOfActiveFilters && "_1e0cglyw"
                                                            ]),
                                                            children: intl.formatMessage({
                                                                id: "CustomersLandingPage.button.filters",
                                                                defaultMessage: "Filters"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $dypTs.jsx)("span", {
                                                            className: (0, $2jatx.default)([
                                                                "_1e0cglyw _1bah1h6o _4cvr1h6o _bfhkshej _2rko1ssb _19pkidpf _2hwxidpf _otyridpf _18u0idpf _syazqlpt _1bsb1tcg _4t3i1tcg _k48pni7l",
                                                                totalNumberOfActiveFilters && "_1e0c1txw"
                                                            ]),
                                                            children: totalNumberOfActiveFilters
                                                        })
                                                    ]
                                                }),
                                                getFilterModal(showModal, "more filters")
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                                    className: (0, $2jatx.default)([
                                        "_1e0c1txw _1n261q9c _p12f1jax _i0dlmko7 _1bahesu3 _8fz61w8u _1a8l1w8u _o5kcesu3"
                                    ]),
                                    children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $3614I.CustomerStorySearchBar), {
                                        searchStringValue: searchStringValue,
                                        setSearchString: setSearchString,
                                        runSearch: ()=>runSearchWithFilters(filterObject, searchStringValue),
                                        searchInputFieldFocused: searchInputFieldFocused,
                                        setSearchInputFieldFocused: setSearchInputFieldFocused,
                                        clearSearchField: clearSearchField
                                    })
                                })
                            ]
                        })
                    }),
                    hasFilterSearchRun && /*#__PURE__*/ (0, $dypTs.jsx)((0, $jMhSx.Row), {
                        layout: "12",
                        children: /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _1n261q9c _1bsbzqdx _p12f1osq _19pkqslr _2hwx1wug _otyridpf _18u01wug _1bah1y6m _4cvr1h6o _4t3i1f4h _y3gn1e5h"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $dypTs.jsx)("h5", {
                                    className: (0, $2jatx.default)([
                                        "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _12l27vkz _1wybgktf _k48p1fw0 _syazqlpt"
                                    ]),
                                    children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $iVyKn.default), {
                                        id: "CustomersLandingPage.numberOfResults",
                                        defaultMessage: "<numberOfCustomerStories></numberOfCustomerStories> results",
                                        values: {
                                            numberOfCustomerStories: ()=>numberOfCustomerStoriesByCommittedValues
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, $dypTs.jsx)("button", {
                                    type: "button",
                                    onClick: clearAllFilterButtonClickHandler,
                                    className: (0, $2jatx.default)([
                                        "_4bfu1r31 _1hms8stv _ajmmnqa1 _ect48q0o _80omtlke _syazoelr _1wybdlk8 _11q7glyw _19itidpf"
                                    ]),
                                    children: intl.formatMessage({
                                        id: "CustomersLandingPage.clear",
                                        defaultMessage: "Clear"
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
const $22c8d2a2ca3fb814$var$filterDropDownArrowSVG = /*#__PURE__*/ (0, $dypTs.jsx)("svg", {
    width: "10",
    height: "6",
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "customer-story-filter-dropdown-arrow",
    children: /*#__PURE__*/ (0, $dypTs.jsx)("path", {
        d: "M9 1.18164L5 4.818L1 1.18164",
        stroke: "#101214",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    })
});
const $22c8d2a2ca3fb814$var$customerStoriesSectionContainerStyle = null;
const $22c8d2a2ca3fb814$var$customerStoriesFilterContainerStyle = null;
const $22c8d2a2ca3fb814$var$filterButtonContainerStyle = null;
const $22c8d2a2ca3fb814$var$mobileFilterButtonContainerStyles = null;
const $22c8d2a2ca3fb814$var$mobileFilterButtonStyles = null;
const $22c8d2a2ca3fb814$var$mobileFilterButtonActiveStyles = null;
const $22c8d2a2ca3fb814$var$mobileFilterButtonImgStyles = null;
const $22c8d2a2ca3fb814$var$mobileFilterButtonTextStyles = null;
const $22c8d2a2ca3fb814$var$mobileFilterInnerStyles = null;
const $22c8d2a2ca3fb814$var$mobileFilterHiddenStyles = null;
const $22c8d2a2ca3fb814$var$mobileFilterButtonTextActiveStyles = null;
const $22c8d2a2ca3fb814$var$filterButtonStyles = null;
const $22c8d2a2ca3fb814$var$filterButtonCountStyles = null;
const $22c8d2a2ca3fb814$var$searchButtonContainerStyle = null;
const $22c8d2a2ca3fb814$var$filterResultStyle = null;
const $22c8d2a2ca3fb814$var$filterResultLabelStyle = null;
const $22c8d2a2ca3fb814$var$filterClearStyle = null;

});

parcelRegister("03nan", function(module, exports) {
$parcel$export(module.exports, "GlobalStatsSection", function () { return $3e272949ffdb8f8e$export$844b01b63b4da82f; });

var $6ogO3 = parcelRequire("6ogO3");

var $dypTs = parcelRequire("dypTs");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $kbpa7 = parcelRequire("kbpa7");

var $4Fnxt = parcelRequire("4Fnxt");
const $3e272949ffdb8f8e$export$844b01b63b4da82f = ()=>{
    const intl = (0, $8e22h.default)();
    const statsProps = {
        headerText: intl.formatMessage({
            id: "CustomersLandingPage.stats.header",
            defaultMessage: "Teams across the globe run on Atlassian"
        }),
        bigStat: {
            stat: "300000",
            statText: intl.formatMessage({
                id: "CustomersLandingPage.numberOfCustomersTxt",
                defaultMessage: "companies power team collaboration with Atlassian"
            }),
            statColor: (0, $kbpa7.wacToken)("color.primary.blue"),
            statSymbol: {
                symbolCharacter: "+",
                symbolCharacterColor: (0, $kbpa7.wacToken)("color.primary.blue")
            }
        },
        littleStats: [
            {
                stat: "200",
                statText: intl.formatMessage({
                    id: "CustomersLandingPage.numberOfCountriesTxt",
                    defaultMessage: "countries and territories have companies that use Atlassian"
                }),
                statColor: (0, $kbpa7.wacToken)("color.primary.blue"),
                statSymbol: {
                    symbolCharacter: "+",
                    symbolCharacterColor: (0, $kbpa7.wacToken)("color.primary.blue")
                }
            },
            {
                stat: "80",
                statText: intl.formatMessage({
                    id: "CustomersLandingPage.fortune500CompaniesTxt",
                    defaultMessage: "of Fortune 500 companies use Atlassian products"
                }),
                statColor: (0, $kbpa7.wacToken)("color.primary.blue"),
                statSymbol: {
                    symbolCharacter: "%",
                    symbolCharacterColor: (0, $kbpa7.wacToken)("color.primary.blue")
                }
            }
        ]
    };
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $bQjAr.default), {
        name: "customers-page-stats",
        children: /*#__PURE__*/ (0, $dypTs.jsx)("section", {
            children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $4Fnxt.Stats), (0, $6ogO3._)({}, statsProps))
        })
    });
};

});

parcelRegister("lksJ1", function(module, exports) {
$parcel$export(module.exports, "FutureOfTeamwork", function () { return $892822865e707dc4$export$a40f2b95cdffc95c; });
/* future-of-teamwork.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");
parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");

var $jKShK = parcelRequire("jKShK");

var $iVyKn = parcelRequire("iVyKn");

var $bQjAr = parcelRequire("bQjAr");

var $5qUgh = parcelRequire("5qUgh");

var $kooLp = parcelRequire("kooLp");

var $jMhSx = parcelRequire("jMhSx");
const $892822865e707dc4$export$a40f2b95cdffc95c = ()=>{
    const { ref: scrollRef, inView: sectionIsVisible } = (0, $jKShK.useInView)();
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $bQjAr.default), {
        name: "customers-page-futureOfTeamwork",
        children: /*#__PURE__*/ (0, $dypTs.jsx)("section", {
            ref: scrollRef,
            className: (0, $2jatx.default)([
                "_kqswh2mm _1reo15vq _18m915vq _y3gn1h6o _ca0q53f4 _u5f3idpf _n3td53f4 _19bvidpf _p12f1git _19pk1wqb _2hwx1wug _otyridpf _18u01wug _gtagoshw _1k3j12qd _mzmgihc0 _1kmx11ux _1ggmidpf _1ykz1wqb _1maeidpf _dqkyoza4 _1n46idpf _if5yidpf _1gnpidpf _7e5bidpf _w77hr5sb _clfdidpf _11pqidpf _q0a5idpf _c3k8idpf _2trp1nn1",
                sectionIsVisible ? "is-visible" : ""
            ]),
            children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $jMhSx.Row), {
                layout: "8",
                children: /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_19pkidpf _2hwx1wug _otyridpf _18u01wug _1e0c1txw _2lx21bp4 _4cvr1h6o _zulpzwfg _p12f1oh5 _kqswh2mm _11wmstnw _tf4iidpf _mp8c15ko _98ph1e0x _7xg24bvh _1oli1wte _19zd183y _1fqc5gyx _1r4k11ux _ynmi101a _r7byckbl _1i6qljo4 _3iilglyw",
                        "content-wrapper"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $dypTs.jsx)("svg", {
                            width: "93",
                            height: "91",
                            viewBox: "0 0 93 91",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            className: "big-star",
                            children: /*#__PURE__*/ (0, $dypTs.jsx)("g", {
                                id: "Gestural Line/star 1",
                                children: /*#__PURE__*/ (0, $dypTs.jsx)("path", {
                                    id: "star 1",
                                    d: "M63.1582 46.7878C65.7082 46.5678 99.8282 38.3178 90.8782 36.5278C87.5582 37.4578 84.9782 36.5178 83.3182 39.0378C82.8382 36.0678 76.3282 40.8078 75.3282 40.9878C74.8782 38.7378 64.6782 44.5278 66.1682 42.4378C61.5382 42.4978 55.7882 44.1177 49.8082 46.0177C46.8782 44.0277 59.4382 29.8278 54.1582 32.8978C54.5282 32.0978 55.9482 28.6378 55.7582 30.9278C57.4282 28.9678 75.6082 -1.03222 68.0482 4.04778C62.9482 10.2378 59.1182 20.6078 54.7982 25.7278C50.5982 27.4578 47.6882 42.3178 43.0082 40.8378C40.2782 37.4978 33.2382 -3.40217 28.2382 0.227831C29.1082 3.40783 28.3182 6.25777 30.7482 7.78777C27.7782 8.26777 32.5182 14.7778 32.6982 15.7778C30.4982 16.1978 36.1982 26.4378 34.1482 24.9378C34.1882 27.8278 34.8382 31.1678 35.7782 34.7178C34.5282 33.7678 33.1582 31.5978 32.3682 31.2778C23.9482 27.8678 17.5682 20.0278 8.7982 15.7778C1.4282 25.1678 66.5982 48.8577 26.1882 52.3978C18.5882 57.3577 8.48819 58.1177 0.00819142 62.8877C-0.721809 73.2177 47.6182 44.7178 33.6682 61.0878C31.4982 68.0078 28.2782 75.7778 23.8282 82.5978C20.9882 108.608 45.1382 37.9478 44.1382 64.9078C47.4682 71.3478 50.6882 79.1078 52.3382 87.0978C64.1482 104.418 48.0282 58.5978 46.3382 52.1078C52.7382 49.3778 77.4782 80.3378 81.9582 75.4578C82.1682 74.7678 78.6082 70.9378 77.5282 70.5278C76.7982 70.8978 76.4282 71.1977 75.9982 70.5177C78.1682 68.4277 70.5582 65.7878 69.8382 65.0678C71.4382 63.4778 60.8482 58.3077 63.4182 58.3877C61.4382 55.6177 58.4082 52.8277 54.9582 50.0177C61.0782 48.8377 63.7382 44.5177 63.1782 46.7677L63.1582 46.7878Z",
                                    fill: "#FCA700"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $dypTs.jsx)("svg", {
                            width: "49",
                            height: "51",
                            viewBox: "0 0 49 51",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            className: "sm-star",
                            children: /*#__PURE__*/ (0, $dypTs.jsx)("g", {
                                id: "Gestural Line/star 3",
                                children: /*#__PURE__*/ (0, $dypTs.jsx)("path", {
                                    id: "Vector",
                                    d: "M47.4104 41.8537C47.4404 41.8037 47.4404 41.7137 47.5004 41.6437C45.7504 40.7637 45.5504 38.6038 44.2005 37.3138L44.1504 37.2637C42.7804 36.8237 43.1505 35.4538 41.4505 35.4438C41.4505 35.4438 41.8904 35.2237 41.9004 35.2237C39.1404 32.4837 32.3204 25.7537 32.3204 25.7537C32.1704 26.3637 33.4104 25.3037 34.6604 25.4837C34.6604 25.4837 34.7503 25.2538 34.8403 25.4338C38.0303 22.3238 41.6205 21.1338 45.7005 19.6538C47.7405 19.1038 48.0504 13.3337 44.5604 15.7237C44.5204 15.6837 44.4304 15.6538 44.3904 15.5838C43.1704 17.0038 41.1404 16.4837 39.6004 17.2237L39.5404 17.2537L36.9804 18.5037C35.5904 19.0737 33.9403 19.5238 32.2103 19.9638C32.2603 19.9138 32.3104 19.8638 32.3604 19.8138C32.3604 19.8138 32.5404 17.0438 32.4904 15.6738C32.4904 15.6738 34.2404 13.4738 33.6604 11.9638C34.6504 10.1938 38.1703 6.3237 34.9703 5.2237C33.9203 5.2237 33.1004 4.31373 32.7404 6.00373C32.6804 5.99373 32.6004 6.01371 32.5204 5.98371C32.3304 7.73371 30.2604 8.97374 29.6904 10.6337L29.6704 10.7038C29.8104 12.1238 28.7105 13.5238 28.7005 13.5238C28.1805 14.8238 27.5004 16.2437 26.7804 17.7237C26.4804 16.9237 26.1504 16.2138 25.8204 15.7038C24.6204 14.4038 25.1304 -3.35621 20.6904 0.56379C20.9004 3.91379 21.9604 7.40374 21.1004 10.3837C20.6804 10.6137 21.3203 11.8038 21.8403 12.7738C21.8003 14.0037 21.5504 14.6638 21.4804 16.4238C19.2804 14.8338 9.6804 6.7838 10.2704 12.2038C11.3004 12.7538 12.0503 13.3838 12.5903 14.6638C13.0903 15.2138 17.5004 17.6938 17.6404 18.3138C17.3504 19.1738 22.5605 19.8637 20.4505 20.5037C20.7605 21.1837 21.1804 21.8338 21.6704 22.4638C19.3904 22.7038 16.6604 23.3737 15.2304 24.2437C14.9804 24.6737 5.88033 25.2537 2.58033 27.3837C0.610334 28.4937 -1.12958 29.0438 0.920422 30.7138C1.66042 30.1138 4.44038 30.9738 4.38038 30.1838C5.06038 30.4638 9.66042 28.7037 10.1704 29.0037C10.4204 29.4037 14.0404 27.2838 13.6104 28.2838C16.1204 28.9938 19.1804 28.4137 22.3604 27.6037C21.1004 29.6037 19.8605 32.4537 19.7005 34.2237C18.6205 36.4937 15.7704 41.5138 14.8604 44.5938C13.5604 46.8338 14.0104 47.0138 15.6504 48.1638L15.6804 48.1938C16.0204 48.4238 15.6404 48.1937 16.9304 48.2437C16.8004 48.1237 16.6104 47.6038 16.3604 47.6938C16.5304 47.3438 18.4904 46.8437 17.6704 46.3737C17.6404 46.3037 18.9204 45.3237 19.0504 44.2637C20.1904 40.4837 22.9204 38.5737 24.9404 34.2637C24.8904 34.7137 28.2904 43.1838 28.1304 47.4038C27.8804 49.4838 32.9204 52.5838 32.1904 47.9438C32.2504 47.9238 32.3004 47.8438 32.3904 47.8338C31.5804 45.9238 32.6504 43.9537 32.2304 42.0137L32.2103 41.9338C31.3003 40.7538 32.3504 39.7738 30.9104 38.8138C30.9104 38.8138 31.4004 38.8637 31.4104 38.8737C30.7704 36.1237 30.3704 32.7637 29.7704 29.7537C31.9204 31.7037 33.8103 33.8037 34.5903 36.1137L34.6904 35.9638C34.6904 36.0338 34.8403 36.0837 34.7103 36.2437C36.5203 36.6237 37.1404 37.3837 38.4505 37.8937C38.4505 37.8937 39.8504 40.4237 41.4804 40.5137L43.9603 44.0238C45.0303 45.8338 50.8004 44.7937 47.4505 41.8937L47.4104 41.8537Z",
                                    fill: "#101214"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $dypTs.jsx)("svg", {
                            width: "74",
                            height: "71",
                            viewBox: "0 0 74 71",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            className: "checkmark",
                            children: /*#__PURE__*/ (0, $dypTs.jsxs)("g", {
                                id: "Gestural Line/symbol check 1",
                                children: [
                                    /*#__PURE__*/ (0, $dypTs.jsx)("path", {
                                        id: "Vector",
                                        d: "M44.0389 33.5379C45.8049 32.3341 51.7382 25.3965 46.0606 27.0247C44.5346 28.2363 37.5403 37.5739 33.6984 42.3892C32.8541 40.4137 30.4297 38.2529 28.6559 37.1571C27.5793 36.1616 27.1455 37.8054 27.1455 37.8054C27.4476 38.2453 27.7652 38.9397 28.501 39.4954C29.3221 40.1127 29.4305 41.3937 30.7783 42.3738C35.5186 45.8078 33.3808 50.8623 37.9663 42.1036C39.5464 38.2606 43.5122 37.0105 44.0312 33.5379H44.0389Z",
                                        fill: "#82B536"
                                    }),
                                    /*#__PURE__*/ (0, $dypTs.jsx)("path", {
                                        id: "Vector_2",
                                        d: "M73.9993 33.2525C74.0381 23.2745 72.4037 7.62464 61.5132 3.92824C69.0653 14.0065 73.643 30.2429 69.4371 42.7366C65.541 62.5305 35.4644 73.635 17.3394 62.1677C19.1984 63.9272 23.4508 65.9259 26.0611 66.6976C19.1364 68.1947 3.56753 50.7699 14.5897 60.2539C-16.6875 20.4424 32.8308 -17.6327 61.3351 16.7538C53.2486 1.15796 32.2499 -4.17445 19.3146 3.41126C-43.0075 52.5834 64.6115 110.815 73.9916 33.2525H73.9993Z",
                                        fill: "#82B536"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $dypTs.jsx)("h2", {
                            children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $iVyKn.default), {
                                id: "CustomersLandingPage.futureOfTeamworkHeader",
                                defaultMessage: "<helpUsShape>Help us shape</helpUsShape> <theFutureOfTeamwork>the future of teamwork</theFutureOfTeamwork>",
                                values: {
                                    helpUsShape: (str)=>/*#__PURE__*/ (0, $dypTs.jsx)("span", {
                                            className: "h1 reduced-font-weight",
                                            children: str
                                        }),
                                    theFutureOfTeamwork: (str)=>/*#__PURE__*/ (0, $dypTs.jsx)("span", {
                                            className: "h1",
                                            children: str
                                        })
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $dypTs.jsx)("p", {
                            className: ".body-lg",
                            children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $iVyKn.default), {
                                id: "CustomersLandingPage.futureOfTeamworkParagraph",
                                defaultMessage: "At Atlassian, we believe the impossible is possible - together. Join us today to help us inspire teamwork anywhere and everywhere, worldwide."
                            })
                        }),
                        /*#__PURE__*/ (0, $dypTs.jsx)((0, $5qUgh.Adg4Button), {
                            variant: "secondary",
                            color: "black",
                            href: (0, $kooLp.useLocalizedHref)("/customers/advocacy"),
                            dataEventProps: {
                                "data-event": "clicked",
                                "data-event-component": "linkButton",
                                "data-event-container": "ctaSection",
                                "data-product-key": "customers",
                                "data-label-english": "Share your story"
                            },
                            children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $iVyKn.default), {
                                id: "CustomersLandingPage.futureOfTeamworkButton",
                                defaultMessage: "Share your story"
                            })
                        })
                    ]
                })
            })
        })
    });
};
const $892822865e707dc4$var$sectionStyles = null;
const $892822865e707dc4$var$contentWrapperStyles = null;

});






var $4ccia = parcelRequire("4ccia");

var $3t7DW = parcelRequire("3t7DW");

var $1mtK6 = parcelRequire("1mtK6");
const $a77ef0e752c8e478$var$relayApi = "contentful";
(0, $3t7DW.init)((0, $1mtK6.CustomersLandingPage), (0, $4ccia.CustomerLandingPageRelayQuery), (0, $4ccia.getCustomerLandingPageRelayQueryVars)(window.location), $a77ef0e752c8e478$var$relayApi);


//# sourceMappingURL=customers-landing-page.f9c744d3.js.map
